import * as React from 'react';
import React__default, { useState, useEffect, createContext, forwardRef, createElement, Component, Fragment, useLayoutEffect, useRef, useCallback, Children, PureComponent, useContext, useMemo } from 'react';
import { InfoIcon as InfoIcon$1, Layout, Accordion as Accordion$1, FormSection, Spinner as Spinner$1, Button, Card, ItemTeaser, Modal, Footer, Footnote, SiteNav as SiteNav$1, Header, Logo, BackToTop as BackToTop$1, ContentSection, HeroTeaser, MediaTeaser as MediaTeaser$1, Notification as Notification$1, PageWrap, DescriptionList, Table, SectionHeading, ErrorMessage, IconList as IconList$1, FormField, Checkbox, Paragraph, Input, DatePicker, Select, Textarea, FormFieldRadioButtonGroup, RadioButton, DataOverview as DataOverview$1, NotificationsGroup, Heading, Combobox, Inbox, Pagination, Fieldset, UploadItem, UploadContainer, Upload, NotificationCenter } from '@vwfs-bronson/bronson-react';
import { useHistory, useLocation, Route, Redirect } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';
import { useField, useFormikContext } from 'formik';
import Cleave from 'cleave.js';
import Flickity from 'react-flickity-component';
import { useInView } from 'react-intersection-observer';

var AlertOrSuccessText = function AlertOrSuccessText(_ref) {
  var text = _ref.text,
      isSuccess = _ref.isSuccess;
  return /*#__PURE__*/React__default.createElement("span", {
    className: isSuccess ? 'u-text-success' : 'u-text-alert'
  }, " ", text, " ");
};

var InfoIcon = function InfoIcon(_ref) {
  var text = _ref.text,
      onMouseOver = _ref.onMouseOver,
      labelId = _ref.labelId;
  return /*#__PURE__*/React__default.createElement(InfoIcon$1, {
    "aria-label": labelId,
    icon: 'semantic-info',
    onMouseOver: onMouseOver,
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, text);
};

/**
 * A single entry in the contract summary to show a specific labeled value
 */
var ContractSummaryItem = function ContractSummaryItem(_ref) {
  var value = _ref.value,
      label = _ref.label,
      testClass = _ref.testClass,
      tooltip = _ref.tooltip,
      testId = _ref.testId,
      onTooltip = _ref.onTooltip;
  return /*#__PURE__*/React.createElement("dl", {
    className: testClass
  }, /*#__PURE__*/React.createElement("dt", {
    "data-testid": testId
  }, label, !!tooltip && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(InfoIcon, {
    onMouseOver: onTooltip,
    text: tooltip
  }))), /*#__PURE__*/React.createElement("dd", {
    "data-testid": testId ? "".concat(testId, "-dd") : undefined
  }, value));
};

/**
 * A contract summary usually consisting up to three items
 */
var ContractSummary = function ContractSummary(_ref) {
  var items = _ref.items;

  if (items.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Layout, null, items.map(function (summaryItem) {
    return /*#__PURE__*/React.createElement(Layout.Item, {
      key: summaryItem.label,
      "default": '1/3',
      s: '1/1'
    }, /*#__PURE__*/React.createElement(ContractSummaryItem, {
      key: summaryItem.label,
      label: summaryItem.label,
      value: summaryItem.value,
      tooltip: summaryItem.tooltip,
      testClass: summaryItem.testClass,
      testId: summaryItem.testId,
      onTooltip: summaryItem.onTooltip
    }));
  }));
};

/**
 * A contract header applicable in the most markets
 */
var ContractHeader = function ContractHeader(_ref) {
  var carInformation = _ref.carInformation,
      contractCategory = _ref.contractCategory,
      contractNumber = _ref.contractNumber,
      thirdLineData = _ref.thirdLineData,
      terminationRemark = _ref.terminationRemark,
      contractIdentifier = _ref.contractIdentifier,
      contractSummary = _ref.contractSummary,
      displayFractionLicensePlate = _ref.displayFractionLicensePlate,
      displayFractionTitle = _ref.displayFractionTitle;
  var terminationComponent = terminationRemark ? /*#__PURE__*/React.createElement("span", {
    className: "u-text-alert"
  }, " ", terminationRemark) : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Layout.Item, {
    "default": displayFractionTitle || '8/12',
    m: "1/1",
    className: "u-text-left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-form-section__title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-form-section__title-text"
  }, carInformation)), /*#__PURE__*/React.createElement("p", {
    className: "c-form-section__subtitle cp-summary-contract-information"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cp-contract-category"
  }, contractCategory), /*#__PURE__*/React.createElement("span", {
    className: "cp-contract-id"
  }, " ", contractNumber), thirdLineData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "cp-contract-id"
  }, thirdLineData)), terminationComponent)), /*#__PURE__*/React.createElement(Layout.Item, {
    "default": displayFractionLicensePlate || '4/12',
    m: "1/1",
    className: "u-mt-none@m"
  }, /*#__PURE__*/React.createElement("div", {
    className: "u-text-right@m-up  u-mr-none cp-contract-identifier-slot"
  }, contractIdentifier))), /*#__PURE__*/React.createElement("div", {
    className: "cp-contract-summary-slot"
  }, contractSummary));
};

var Accordion = function Accordion(_ref) {
  var className = _ref.className,
      openOneAtTime = _ref.openOneAtTime,
      testId = _ref.testId,
      withBackground = _ref.withBackground,
      itemKeyProp = _ref.itemKeyProp,
      onChange = _ref.onChange,
      lazyRender = _ref.lazyRender,
      headerSplit = _ref.headerSplit,
      children = _ref.children;

  if (!children) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Accordion$1, {
    className: className,
    multipleOpen: openOneAtTime,
    testId: testId,
    withBackground: withBackground,
    itemKeyProp: itemKeyProp,
    onChange: onChange,
    lazyRender: lazyRender,
    headerSplit: headerSplit
  }, children);
};
Accordion.displayName = 'Accordion';

var AccordionItem = function AccordionItem(_ref) {
  var defaultOpen = _ref.defaultOpen,
      title = _ref.title,
      subtitle = _ref.subtitle,
      icon = _ref.icon,
      tooltip = _ref.tooltip,
      testId = _ref.testId,
      contentClassName = _ref.contentClassName,
      className = _ref.className,
      titleSplit = _ref.titleSplit,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Accordion$1.Item, {
    defaultOpen: defaultOpen,
    title: title,
    subtitle: subtitle,
    icon: icon,
    tooltip: tooltip,
    testId: testId,
    contentClassName: contentClassName,
    className: className,
    titleSplit: titleSplit
  }, children);
};
AccordionItem.displayName = 'AccordionItem';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$4 = ".c-form-section__title-text {\n    width: 100%;\n    max-width: 100%;\n    white-space: inherit !important;\n}\n";
styleInject(css_248z$4);

var Contract = function Contract(_ref) {
  var contractHeader = _ref.contractHeader,
      contractBody = _ref.contractBody,
      contractUnpaids = _ref.contractUnpaids,
      contractActions = _ref.contractActions;
  var header = /*#__PURE__*/React.createElement(React.Fragment, null, contractHeader, contractUnpaids, contractActions);
  return /*#__PURE__*/React.createElement(FormSection, {
    title: header
  }, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(React.Fragment, null, contractBody)));
};

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      testId = _ref.testId,
      small = _ref.small,
      center = _ref.center,
      fullPage = _ref.fullPage,
      section = _ref.section;
  return /*#__PURE__*/React__default.createElement(Spinner$1, {
    className: className,
    testId: testId,
    small: small,
    center: center,
    fullPage: fullPage,
    section: section,
    style: {
      pointerEvents: 'auto'
    }
  });
};

var UiBlockingSpinner = function UiBlockingSpinner(_ref) {
  var _ref$isBlocking = _ref.isBlocking,
      isBlocking = _ref$isBlocking === void 0 ? false : _ref$isBlocking,
      children = _ref.children;
  return isBlocking ? /*#__PURE__*/React__default.createElement(Spinner, {
    section: true
  }, children) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};

var ContractActions = function ContractActions(_ref) {
  var contractActionItems = _ref.contractActionItems,
      className = _ref.className;

  if (!contractActionItems) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Layout, {
    className: className
  }, contractActionItems.map(function (contractActionItem, index) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: index,
      className: "u-1/3 u-1/1@s"
    }, contractActionItem.isLoading ? /*#__PURE__*/React__default.createElement(Spinner, {
      small: true
    }) : contractActionItem.pageUrl ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button, {
      className: 'c-btn c-btn--link c-btn--simple u-text-brand',
      icon: contractActionItem.iconName,
      element: "a",
      href: contractActionItem.pageUrl,
      iconReversed: contractActionItem.iconReversed,
      onClick: contractActionItem.onClick,
      testId: contractActionItem.testId
    }, contractActionItem.label), contractActionItem.tooltip && /*#__PURE__*/React__default.createElement(InfoIcon, {
      text: contractActionItem.tooltip
    })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button, {
      className: 'c-btn c-btn--link c-btn--simple u-text-brand',
      icon: contractActionItem.iconName,
      iconReversed: false,
      disabled: contractActionItem.disabled,
      onClick: contractActionItem.onClick,
      testId: contractActionItem.testId
    }, contractActionItem.label), contractActionItem.tooltip && /*#__PURE__*/React__default.createElement(InfoIcon, {
      text: contractActionItem.tooltip
    })));
  }));
};

var DividedContractHeader = function DividedContractHeader(_ref) {
  var carInformation = _ref.carInformation,
      contractCategory = _ref.contractCategory,
      contractNumber = _ref.contractNumber,
      terminationRemark = _ref.terminationRemark,
      contractIdentifier = _ref.contractIdentifier,
      extraInformation = _ref.extraInformation,
      rightSideContent = _ref.rightSideContent;
  var terminationComponent = terminationRemark ? /*#__PURE__*/React.createElement("span", {
    className: "u-text-alert"
  }, " ", terminationRemark) : '';
  var carInformationPart = /*#__PURE__*/React.createElement("div", {
    className: "u-text-left@m-up u-mr-none cp-contract-identifier-slot"
  }, contractIdentifier, /*#__PURE__*/React.createElement("div", {
    className: "c-form-section__title u-mt-small"
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-form-section__title-text"
  }, carInformation)), /*#__PURE__*/React.createElement("div", {
    className: "c-form-section__subtitle cp-summary-contract-information"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cp-contract-category"
  }, contractCategory), /*#__PURE__*/React.createElement("span", {
    className: "cp-contract-id"
  }, " ", contractNumber), terminationComponent), /*#__PURE__*/React.createElement("div", {
    className: "u-text-left"
  }, extraInformation));
  return /*#__PURE__*/React.createElement(Card, {
    element: "article"
  }, rightSideContent ? /*#__PURE__*/React.createElement(Layout, {
    equalHeight: true,
    divider: true
  }, /*#__PURE__*/React.createElement(Layout.Item, {
    "default": "1/2",
    s: "1/1"
  }, carInformationPart), /*#__PURE__*/React.createElement(Layout.Item, {
    "default": "1/2",
    s: "1/1"
  }, rightSideContent)) : /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Layout.Item, {
    "default": "1/1"
  }, carInformationPart)));
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var CookieWarningUi = function CookieWarningUi(_ref) {
  var warningText = _ref.warningText,
      secondLineText = _ref.secondLineText,
      acceptLabel = _ref.acceptLabel,
      accepted = _ref.accepted,
      setCookiesAccepted = _ref.setCookiesAccepted,
      cookiePolicyLink = _ref.cookiePolicyLink,
      linkText = _ref.linkText,
      cookiePolicyLinkClickHandler = _ref.cookiePolicyLinkClickHandler;

  if (accepted) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "c-sticky-container  js-sticky-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "c-sticky-container__inner cookie-warning"
  }, /*#__PURE__*/React__default.createElement("p", null, warningText, /*#__PURE__*/React__default.createElement(Button, {
    element: "a",
    href: cookiePolicyLink,
    onClick: function onClick() {
      return !!cookiePolicyLinkClickHandler && cookiePolicyLinkClickHandler();
    }
  }, linkText), '.'), secondLineText && /*#__PURE__*/React__default.createElement("p", null, secondLineText), /*#__PURE__*/React__default.createElement(Button, {
    onClick: setCookiesAccepted
  }, acceptLabel)));
};

var CookieWarning = function CookieWarning(_ref) {
  var warningText = _ref.warningText,
      secondLineText = _ref.secondLineText,
      acceptLabel = _ref.acceptLabel,
      cookiePolicyLink = _ref.cookiePolicyLink,
      linkText = _ref.linkText,
      cookiePolicyLinkClickHandler = _ref.cookiePolicyLinkClickHandler;

  var _useState = useState(localStorage.cookiesAccepted || false),
      _useState2 = _slicedToArray(_useState, 2),
      accepted = _useState2[0],
      setAccepted = _useState2[1];

  function setCookiesAccepted() {
    localStorage.cookiesAccepted = 'true';
    setAccepted('true');
  }

  return /*#__PURE__*/React__default.createElement(CookieWarningUi, {
    warningText: warningText,
    secondLineText: secondLineText,
    linkText: linkText,
    accepted: accepted === 'true',
    acceptLabel: acceptLabel,
    setCookiesAccepted: setCookiesAccepted,
    cookiePolicyLink: cookiePolicyLink,
    cookiePolicyLinkClickHandler: cookiePolicyLinkClickHandler
  });
};
CookieWarning.displayName = 'CookieWarning';

var isNormalLink = function isNormalLink(normalLink, link) {
  return normalLink || !!(link === null || link === void 0 ? void 0 : link.includes('mailto:'));
};
/**
 * The icon footer consisting of multiple icon bubbles with texts and links
 */


var IconFooter = function IconFooter(_ref) {
  var items = _ref.items,
      title = _ref.title,
      trackingFunction = _ref.trackingFunction,
      currentPageName = _ref.currentPageName,
      trackingFunctions = _ref.trackingFunctions,
      _ref$headingLevel = _ref.headingLevel,
      headingLevel = _ref$headingLevel === void 0 ? 5 : _ref$headingLevel;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      withModal = _useState2[0],
      setWithModal = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      modalContent = _useState4[0],
      setModalContent = _useState4[1];

  var history = useHistory();
  return /*#__PURE__*/React__default.createElement(Layout, null, title && /*#__PURE__*/React__default.createElement(Layout.Item, {
    className: 'u-text-center',
    "default": "1/1"
  }, /*#__PURE__*/React__default.createElement("h2", null, title)), /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": "1/1"
  }, /*#__PURE__*/React__default.createElement(Layout, {
    className: "row"
  }, items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: item.title,
      "default": items.length <= 6 ? "1/".concat(items.length) : '1/12',
      m: '1/1'
    }, /*#__PURE__*/React__default.createElement(ItemTeaser, {
      linkProps: _objectSpread2$1(_objectSpread2$1({
        href: item.linkUrl
      }, isNormalLink(item.normalLink ? item.normalLink : false, item.linkUrl) ? {
        element: 'a'
      } : {}), {}, {
        target: item.target,
        onClick: function onClick(event) {
          if (!!item.trackItem) {
            if (item.trackingId && (trackingFunctions === null || trackingFunctions === void 0 ? void 0 : trackingFunctions[item.trackingId])) {
              trackingFunctions[item.trackingId]();
            } else if (!!trackingFunction) {
              trackingFunction(item.title, currentPageName);
            }
          }

          if (!!item.modalContent) {
            event.preventDefault();
            setWithModal(true);
            setModalContent(item.modalContent);
          } else if (item.linkUrl && !isNormalLink(item.normalLink ? item.normalLink : false, item.linkUrl)) {
            history.push(item.linkUrl);
          }
        }
      }),
      icon: item.icon,
      title: item.title,
      linkLabel: item.linkText,
      className: item.className,
      iconClassName: item.iconClassName,
      iconDescription: item.iconDescription,
      testId: item.testId,
      small: item.small,
      inline: item.inline !== undefined ? item.inline : true,
      inlineSmallScreen: item.inlineSmallScreen,
      block: item.block,
      blockSmallScreen: item.blockSmallScreen,
      headingLevel: headingLevel
    }, item.text), withModal && /*#__PURE__*/React__default.createElement(Modal, {
      shown: withModal,
      testId: "icon-footer-item-modal-".concat(item.title),
      onClose: function onClose() {
        return setWithModal(false);
      }
    }, modalContent));
  }))));
};

/**
 * A legal footer consolidating all necessary legal footprint
 */
var LegalFooter = function LegalFooter(_ref) {
  var links = _ref.links,
      legalText = _ref.legalText,
      copyrightText = _ref.copyrightText,
      footnotes = _ref.footnotes;
  return /*#__PURE__*/React__default.createElement(Footer, null, /*#__PURE__*/React__default.createElement(Footer.ModuleMetaNav, {
    copyrightText: copyrightText
  }, links.map(function (_ref2) {
    var text = _ref2.text,
        _ref2$url = _ref2.url,
        url = _ref2$url === void 0 ? '' : _ref2$url,
        externalUrl = _ref2.externalUrl;
    return !!externalUrl ? /*#__PURE__*/React__default.createElement(Footer.ModuleMetaNav.Item, {
      normalLink: true,
      href: externalUrl,
      key: text,
      linkProps: {
        target: '_blank'
      }
    }, text) : /*#__PURE__*/React__default.createElement(Footer.ModuleMetaNav.Item, {
      key: text,
      href: url
    }, text);
  })), legalText || footnotes ? /*#__PURE__*/React__default.createElement(Footer.ModuleFootnotes, {
    footerText: legalText
  }, footnotes ? /*#__PURE__*/React__default.createElement(Footnote, {
    numbered: true
  }, footnotes.map(function (footnote) {
    return /*#__PURE__*/React__default.createElement(Footnote.Item, {
      key: footnote
    }, footnote);
  })) : null) : null);
};

var Greeting = function Greeting(_ref) {
  var fullGreetingText = _ref.fullGreetingText;
  return /*#__PURE__*/React__default.createElement("h2", null, fullGreetingText);
};

var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var currentLanguage = _ref.currentLanguage,
      selectableLanguages = _ref.selectableLanguages,
      _onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement(SiteNav$1.Item, {
    label: currentLanguage.activeLabel,
    icon: true,
    reversed: true,
    language: true,
    topAtBreakpoint: true
  }, selectableLanguages.map(function (language) {
    return /*#__PURE__*/React__default.createElement(SiteNav$1.Item.DropdownItem, {
      key: language.locale,
      onClick: function onClick() {
        return _onClick === null || _onClick === void 0 ? void 0 : _onClick(language.locale, currentLanguage.locale);
      }
    }, language.dropdownLabel);
  }));
};

function isRelativeUrl(url) {
  return url.startsWith('/') && !url.startsWith('://') || url.startsWith('#');
}
function navigateTo(history, url) {
  if (url) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isRelativeUrl(url) ? history.push(url) : document.location.href = url;
  }
}
var openInNewWindow = function openInNewWindow(url) {
  return function () {
    return window.open(url, '_blank');
  };
};
var openInSameWindow = function openInSameWindow(url) {
  return function () {
    return window.location.href = url || '#';
  };
};
var preventSubmit = function preventSubmit(e) {
  e.preventDefault();
};
var preventMouseEvent = function preventMouseEvent(e) {
  e.preventDefault();
};

function useNavigation() {
  var history = useHistory();
  return function (url) {
    navigateTo(history, url);
  };
}

/**
 * A simple, direct nav item without a dropdown. Could be either a link or a "fake" link with a click handler
 */
var SimpleNavItem = function SimpleNavItem(_ref) {
  var url = _ref.url,
      label = _ref.label,
      isActive = _ref.isActive,
      isReversed = _ref.isReversed,
      externalClickHandler = _ref.onClick,
      dropdownTitle = _ref.dropdownTitle,
      dropdownItems = _ref.dropdownItems;
  var navigateTo = useNavigation();

  var _onClick2 = function onClick(itemUrl, _onClick) {
    if (_onClick) {
      _onClick(itemUrl);
    } else {
      navigateTo(itemUrl);
    }
  };

  return /*#__PURE__*/React__default.createElement(SiteNav$1.Item, {
    label: label,
    active: isActive,
    reversed: isReversed,
    onClick: function onClick() {
      return _onClick2(url, externalClickHandler);
    },
    icon: !!(dropdownItems === null || dropdownItems === void 0 ? void 0 : dropdownItems.length),
    dropdownTitle: dropdownTitle
  }, dropdownItems === null || dropdownItems === void 0 ? void 0 : dropdownItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement(SiteNav$1.Item.DropdownItem, {
      key: item.label,
      onClick: function onClick() {
        return _onClick2(item.url, item.onClick);
      },
      active: item.isActive
    }, item.label);
  }));
};

/**
 * A one-level navigation bar composed of left-oriented nav links, right-oriented nav links and a language switcher
 */
var SiteNav = function SiteNav(_ref) {
  var navigationItems = _ref.navigationItems,
      languageSwitcher = _ref.languageSwitcher,
      closeMenuText = _ref.closeMenuText,
      openButtonTitle = _ref.openButtonTitle,
      openMenuText = _ref.openMenuText;
  var reversedNavItems = navigationItems.filter(function (item) {
    return item.isReversed;
  });
  var reversedNav = reversedNavItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement(SimpleNavItem, _extends({}, item, {
      key: item.label
    }));
  });
  var commonNavItems = navigationItems.filter(function (item) {
    return !item.isReversed;
  });
  var commonNav = commonNavItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement(SimpleNavItem, _extends({}, item, {
      key: item.label
    }));
  });
  return /*#__PURE__*/React__default.createElement(SiteNav$1, {
    closeMenuText: closeMenuText,
    title: openButtonTitle,
    openMenuText: openMenuText
  }, languageSwitcher || commonNavItems.length > 0 ? /*#__PURE__*/React__default.createElement(SiteNav$1.Area, null, commonNav, languageSwitcher) : null, reversedNavItems.length > 0 && /*#__PURE__*/React__default.createElement(SiteNav$1.Area, null, reversedNav));
};

var css_248z$3 = "/* style class for Financial Services logo in navigation bar */\n.c-header__logo .c-logo--audi {\n    width: initial !important;\n}\n\n.c-header__logo .c-logo--skoda {\n    width: 180px !important;\n    margin-top: -10px !important;\n    height: initial !important;\n}\n\n.c-header__logo .c-logo--vwcv,\n.c-header__logo .c-logo--vw,\n.c-header__logo .c-logo--seat {\n    height: initial !important;\n    width: 180px !important;\n}\n\n@media only screen and (max-width: 480px) {\n    .c-header__logo .c-logo--vwcv,\n    .c-header__logo .c-logo--vw,\n    .c-header__logo .c-logo--seat {\n        width: 100px !important;\n    }\n}\n";
styleInject(css_248z$3);

/**
 * A simple navigation bar including logo definition and an optional language switcher
 */
var NavigationBar = function NavigationBar(_ref) {
  var logoAltText = _ref.logoAltText,
      navigation = _ref.navigation,
      onLogoClickPath = _ref.onLogoClickPath,
      logoDisableLink = _ref.logoDisableLink,
      languageSwitcher = _ref.languageSwitcher,
      withStaticHeader = _ref.withStaticHeader,
      hidden = _ref.hidden,
      logoSource = _ref.logoSource,
      logoClassName = _ref.logoClassName,
      notificationsCenter = _ref.notificationsCenter,
      closeMenuText = _ref.closeMenuText,
      openButtonTitle = _ref.openButtonTitle,
      openMenuText = _ref.openMenuText;

  if (hidden) {
    return null;
  }

  var history = useHistory();

  var onLogoClick = function onLogoClick() {
    if (onLogoClickPath) {
      history.push(onLogoClickPath);
    }
  };

  var logo = logoSource ? /*#__PURE__*/React__default.createElement(Logo, {
    disableLink: logoDisableLink,
    onClick: onLogoClick,
    title: logoAltText,
    src: logoSource,
    className: logoClassName,
    "aria-hidden": !!onLogoClickPath ? 'false' : 'true'
  }) : /*#__PURE__*/React__default.createElement(Logo, {
    disableLink: logoDisableLink,
    onClick: onLogoClick,
    title: logoAltText,
    "aria-hidden": !!onLogoClickPath ? 'false' : 'true'
  });
  return /*#__PURE__*/React__default.createElement(Header, {
    logo: logo,
    staticHeader: withStaticHeader,
    notificationCenter: notificationsCenter
  }, /*#__PURE__*/React__default.createElement(SiteNav, {
    navigationItems: navigation.navigationItems,
    languageSwitcher: languageSwitcher,
    closeMenuText: closeMenuText,
    openButtonTitle: openButtonTitle,
    openMenuText: openMenuText
  }));
};

/**
 * Restores the scrolling to the top of the page after page navigation
 * Based on https://reacttraining.com/react-router/web/guides/scroll-restoration
 */
var ScrollToTopOnNavigation = function ScrollToTopOnNavigation(_ref) {
  var exceptions = _ref.exceptions,
      children = _ref.children;
  var lastLocation = useLastLocation();
  var lastPathname = lastLocation === null || lastLocation === void 0 ? void 0 : lastLocation.pathname;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  useEffect(function () {
    var shouldScroll = !(exceptions && exceptions.some(function (_ref2) {
      var from = _ref2.from,
          to = _ref2.to;
      return (!lastPathname || lastPathname && lastPathname.match(from)) && pathname.match(to);
    }));

    if (shouldScroll) {
      setTimeout(function () {
        window.scrollTo(0, 0);
      });
    }
  }, [pathname, lastPathname, exceptions]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", children, " ");
};

var PrivateRoute = function PrivateRoute(_ref) {
  var isAuthorized = _ref.isAuthorized,
      notAuthorizedUrl = _ref.notAuthorizedUrl,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["isAuthorized", "notAuthorizedUrl", "children"]);

  return /*#__PURE__*/React__default.createElement(Route, _extends({}, otherProps, {
    render: function render(_ref2) {
      var location = _ref2.location;
      return isAuthorized() ? children : /*#__PURE__*/React__default.createElement(Redirect, {
        to: {
          pathname: notAuthorizedUrl,
          state: {
            from: location
          }
        }
      });
    }
  }));
};

/**
 * The pre-defined "back to top" button
 */
var BackToTop = function BackToTop(_ref) {
  var label = _ref.label,
      props = _objectWithoutProperties(_ref, ["label"]);

  return /*#__PURE__*/React__default.createElement(BackToTop$1, props, label);
};

var MasterPage = function MasterPage(_ref) {
  var cookieWarning = _ref.cookieWarning,
      navigationBar = _ref.navigationBar,
      iconFooter = _ref.iconFooter,
      legalFooter = _ref.legalFooter,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "o-root"
  }, cookieWarning, navigationBar, /*#__PURE__*/React__default.createElement("main", {
    className: "o-main"
  }, children), label && /*#__PURE__*/React__default.createElement(BackToTop, {
    label: label
  }), iconFooter && /*#__PURE__*/React__default.createElement(ContentSection, {
    pageWrapSize: "medium",
    altBackground: true
  }, iconFooter), legalFooter);
};

var HeroImage = function HeroImage(_ref) {
  var className = _ref.className,
      pretitle = _ref.pretitle,
      title = _ref.title,
      subTitle = _ref.subTitle,
      text = _ref.text,
      imageUrl = _ref.imageUrl,
      buttonText = _ref.buttonText,
      clickHandler = _ref.clickHandler,
      shallow = _ref.shallow,
      inverted = _ref.inverted,
      focalPoint = _ref.focalPoint,
      auto = _ref.auto,
      _ref$buttonIsHiddenOn = _ref.buttonIsHiddenOnLargeScreen,
      buttonIsHiddenOnLargeScreen = _ref$buttonIsHiddenOn === void 0 ? false : _ref$buttonIsHiddenOn,
      testId = _ref.testId;
  var imgProps = {
    src: imageUrl
  };
  return /*#__PURE__*/React__default.createElement(HeroTeaser, {
    className: className,
    pretitle: pretitle,
    title: title,
    sub: subTitle,
    imgProps: imgProps,
    buttonText: buttonText,
    onButtonClick: clickHandler,
    shallow: shallow,
    noImage: !imageUrl,
    inverted: !!inverted,
    topLeft: focalPoint === 'top-left',
    topCenter: focalPoint === 'top-center',
    topRight: focalPoint === 'top-right',
    centerLeft: focalPoint === 'center-left',
    centerRight: focalPoint === 'center-right',
    bottomLeft: focalPoint === 'bottom-left',
    bottomCenter: focalPoint === 'bottom-center',
    bottomRight: focalPoint === 'bottom-right',
    auto: auto,
    buttonIsHiddenOnLargeScreen: buttonIsHiddenOnLargeScreen,
    testId: testId
  }, text);
};

var MediaTeaser = function MediaTeaser(_ref) {
  var title = _ref.title,
      pretitle = _ref.pretitle,
      imageUrl = _ref.imageUrl,
      buttonLabel = _ref.buttonLabel,
      clickHandler = _ref.clickHandler,
      hasLinkButton = _ref.hasLinkButton,
      text = _ref.text,
      reversed = _ref.reversed,
      vertical = _ref.vertical,
      className = _ref.className,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'media-teaser' : _ref$testId,
      video = _ref.video,
      buttonClassName = _ref.buttonClassName,
      _ref$fullLink = _ref.fullLink,
      fullLink = _ref$fullLink === void 0 ? false : _ref$fullLink,
      fullLinkFooter = _ref.fullLinkFooter,
      buttonProps = _ref.buttonProps;
  var imgProps = {
    src: imageUrl
  };
  return /*#__PURE__*/React__default.createElement(MediaTeaser$1, {
    title: title,
    pretitle: pretitle,
    imgProps: imgProps,
    buttonLabel: buttonLabel,
    onButtonClick: clickHandler,
    linkButton: hasLinkButton,
    reversed: reversed,
    vertical: vertical,
    className: className,
    testId: testId,
    video: video,
    buttonModifier: buttonClassName,
    fullLink: fullLink,
    fullLinkFooter: fullLinkFooter,
    buttonProps: buttonProps
  }, text);
};

var Notification = function Notification(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      headline = _ref.headline,
      className = _ref.className,
      status = _ref.status,
      buttonText = _ref.buttonText,
      buttons = _ref.buttons,
      onCloseClick = _ref.onCloseClick,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? false : _ref$showCloseButton,
      buttonCloseAriaLabel = _ref.buttonCloseAriaLabel,
      text = _ref.text,
      testId = _ref.testId,
      children = _ref.children;
  var defaultButton = /*#__PURE__*/React__default.createElement(Button, {
    className: 'c-btn  u-text-brand',
    iconReversed: false,
    onClick: onCloseClick
  }, buttonText);

  var getButtons = function getButtons() {
    return buttons ? buttons : buttonText ? defaultButton : undefined;
  };

  return /*#__PURE__*/React__default.createElement(Notification$1, {
    visible: visible,
    title: headline,
    className: className,
    status: status,
    buttons: getButtons(),
    onCloseClick: onCloseClick,
    showCloseButton: showCloseButton,
    closeLabel: buttonCloseAriaLabel,
    text: text,
    testId: testId
  }, children);
};

var NotificationStatus;

(function (NotificationStatus) {
  NotificationStatus["info"] = "info";
  NotificationStatus["warning"] = "warning";
  NotificationStatus["success"] = "success";
  NotificationStatus["error"] = "error";
})(NotificationStatus || (NotificationStatus = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var lib = {};

var skeleton = {};

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 && // charcode for l
  content.charCodeAt(0) === 108 && // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
      return '';
    }
};

var isBrowser$2 = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser$2 ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }

    if (prefix === false) {
      return prefixFalseCache;
    }

    return getCache(prefix);
  };
});

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  if (isBrowser$2) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  if (isBrowser$2) {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;

    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser = typeof document !== 'undefined';
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = /*#__PURE__*/createContext({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/forwardRef(render);
};

if (!isBrowser) {
  var BasicProvider = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose$1(BasicProvider, _React$Component);

    function BasicProvider(props, context, updater) {
      var _this;

      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }

    var _proto = BasicProvider.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };

    return BasicProvider;
  }(Component);

  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return /*#__PURE__*/createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$1.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (process.env.NODE_ENV !== 'production') {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  return newProps;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$1.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);

  if (!isBrowser && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty$1.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/createElement(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/createElement(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {
    if (!isBrowser) {
      var serialized = this.props.serialized;
      var serializedNames = serialized.name;
      var serializedStyles = serialized.styles;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        serializedStyles += next.styles;
        next = next.next;
      }

      var shouldCache = this.props.cache.compat === true;
      var rules = this.props.cache.insert("", {
        name: serializedNames,
        styles: serializedStyles
      }, this.sheet, shouldCache);

      if (!shouldCache) {
        var _ref;

        return /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion-" + this.props.cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = this.props.cache.sheet.nonce, _ref));
      }
    }

    return null;
  };

  return InnerGlobal;
}(Component);

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      if (isBrowser) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser) {
        serializedHashes += " " + serialized.name;
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    if (!isBrowser && rules.length !== 0) {
      var _ref;

      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref)), ele);
    }

    return ele;
  });
});

var core_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ClassNames: ClassNames,
    Global: Global,
    createElement: jsx,
    jsx: jsx,
    keyframes: keyframes,
    CacheProvider: CacheProvider,
    ThemeContext: ThemeContext,
    get withEmotionCache () { return withEmotionCache; },
    css: css
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(core_esm);

Object.defineProperty(skeleton, "__esModule", {
  value: true
});
skeleton.default = Skeleton$1;
skeleton.skeletonStyles = skeleton.skeletonKeyframes = skeleton.defaultHighlightColor = skeleton.defaultBaseColor = void 0;

_interopRequireDefault(React__default);

var _core$1 = require$$1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    background-position: -200px 0;\n  }\n  ", "\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultBaseColor = "#eee";
skeleton.defaultBaseColor = defaultBaseColor;
var defaultHighlightColor = "#f5f5f5";
skeleton.defaultHighlightColor = defaultHighlightColor;

var skeletonKeyframes = function skeletonKeyframes(duration, delay) {
  return (0, _core$1.keyframes)(_templateObject(), delay > 0 ? "".concat(Math.floor(1 / (duration + delay) * duration * 100), "% {\n    background-position: calc(200px + 100%) 0;\n  }") : undefined);
};

skeleton.skeletonKeyframes = skeletonKeyframes;
var skeletonStyles =
/*#__PURE__*/
(0, _core$1.css)("background-color:", defaultBaseColor, ";background-image:linear-gradient( 90deg,", defaultBaseColor, ",", defaultHighlightColor, ",", defaultBaseColor, " );background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;display:inline-block;line-height:1;width:100%;;label:skeletonStyles;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
skeleton.skeletonStyles = skeletonStyles;

function Skeleton$1(_ref) {
  var count = _ref.count,
      duration = _ref.duration,
      width = _ref.width,
      Wrapper = _ref.wrapper,
      height = _ref.height,
      circle = _ref.circle,
      delay = _ref.delay,
      customStyle = _ref.style,
      customClassName = _ref.className;
  var elements = [];

  for (var i = 0; i < count; i++) {
    var style = {};

    if (width !== null) {
      style.width = width;
    }

    if (height !== null) {
      style.height = height;
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = "50%";
    }

    var className = "react-loading-skeleton";

    if (customClassName) {
      className += " " + customClassName;
    }

    elements.push((0, _core$1.jsx)("span", {
      key: i,
      className: className,
      css:
      /*#__PURE__*/
      (0, _core$1.css)(skeletonStyles, " animation:", skeletonKeyframes(duration, delay), " ", duration + delay, "s ease-in-out infinite;label:Skeleton;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9za2VsZXRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0RWdCIiwiZmlsZSI6Ii4uL3NyYy9za2VsZXRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCB7IGNzcywga2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL2NvcmVcIjtcblxuZXhwb3J0IGNvbnN0IGRlZmF1bHRCYXNlQ29sb3IgPSBcIiNlZWVcIjtcblxuZXhwb3J0IGNvbnN0IGRlZmF1bHRIaWdobGlnaHRDb2xvciA9IFwiI2Y1ZjVmNVwiO1xuXG5leHBvcnQgY29uc3Qgc2tlbGV0b25LZXlmcmFtZXMgPSAoZHVyYXRpb24sIGRlbGF5KSA9PiBrZXlmcmFtZXNgXG4gIDAlIHtcbiAgICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiAtMjAwcHggMDtcbiAgfVxuICAke1xuICAgIGRlbGF5ID4gMFxuICAgICAgPyBgJHtNYXRoLmZsb29yKCgxIC8gKGR1cmF0aW9uICsgZGVsYXkpKSAqIGR1cmF0aW9uICogMTAwKX0lIHtcbiAgICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiBjYWxjKDIwMHB4ICsgMTAwJSkgMDtcbiAgfWBcbiAgICAgIDogdW5kZWZpbmVkXG4gIH1cbiAgMTAwJSB7XG4gICAgYmFja2dyb3VuZC1wb3NpdGlvbjogY2FsYygyMDBweCArIDEwMCUpIDA7XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBza2VsZXRvblN0eWxlcyA9IGNzc2BcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtkZWZhdWx0QmFzZUNvbG9yfTtcbiAgYmFja2dyb3VuZC1pbWFnZTogbGluZWFyLWdyYWRpZW50KFxuICAgIDkwZGVnLFxuICAgICR7ZGVmYXVsdEJhc2VDb2xvcn0sXG4gICAgJHtkZWZhdWx0SGlnaGxpZ2h0Q29sb3J9LFxuICAgICR7ZGVmYXVsdEJhc2VDb2xvcn1cbiAgKTtcbiAgYmFja2dyb3VuZC1zaXplOiAyMDBweCAxMDAlO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbGluZS1oZWlnaHQ6IDE7XG4gIHdpZHRoOiAxMDAlO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gU2tlbGV0b24oe1xuICBjb3VudCxcbiAgZHVyYXRpb24sXG4gIHdpZHRoLFxuICB3cmFwcGVyOiBXcmFwcGVyLFxuICBoZWlnaHQsXG4gIGNpcmNsZSxcbiAgZGVsYXksXG4gIHN0eWxlOiBjdXN0b21TdHlsZSxcbiAgY2xhc3NOYW1lOiBjdXN0b21DbGFzc05hbWVcbn0pIHtcbiAgY29uc3QgZWxlbWVudHMgPSBbXTtcblxuICBmb3IgKGxldCBpID0gMDsgaSA8IGNvdW50OyBpKyspIHtcbiAgICBsZXQgc3R5bGUgPSB7fTtcblxuICAgIGlmICh3aWR0aCAhPT0gbnVsbCkge1xuICAgICAgc3R5bGUud2lkdGggPSB3aWR0aDtcbiAgICB9XG5cbiAgICBpZiAoaGVpZ2h0ICE9PSBudWxsKSB7XG4gICAgICBzdHlsZS5oZWlnaHQgPSBoZWlnaHQ7XG4gICAgfVxuXG4gICAgaWYgKHdpZHRoICE9PSBudWxsICYmIGhlaWdodCAhPT0gbnVsbCAmJiBjaXJjbGUpIHtcbiAgICAgIHN0eWxlLmJvcmRlclJhZGl1cyA9IFwiNTAlXCI7XG4gICAgfVxuXG4gICAgbGV0IGNsYXNzTmFtZSA9IFwicmVhY3QtbG9hZGluZy1za2VsZXRvblwiO1xuICAgIGlmIChjdXN0b21DbGFzc05hbWUpIHtcbiAgICAgIGNsYXNzTmFtZSArPSBcIiBcIiArIGN1c3RvbUNsYXNzTmFtZTtcbiAgICB9XG5cbiAgICBlbGVtZW50cy5wdXNoKFxuICAgICAgPHNwYW5cbiAgICAgICAga2V5PXtpfVxuICAgICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgJHtza2VsZXRvblN0eWxlc31cbiAgICAgICAgICBhbmltYXRpb246ICR7c2tlbGV0b25LZXlmcmFtZXMoZHVyYXRpb24sIGRlbGF5KX0gJHtkdXJhdGlvbiArXG4gICAgICAgICAgZGVsYXl9cyBlYXNlLWluLW91dCBpbmZpbml0ZVxuICAgICAgICBgfVxuICAgICAgICBzdHlsZT17e1xuICAgICAgICAgIC4uLmN1c3RvbVN0eWxlLFxuICAgICAgICAgIC4uLnN0eWxlXG4gICAgICAgIH19XG4gICAgICA+XG4gICAgICAgICZ6d25qO1xuICAgICAgPC9zcGFuPlxuICAgICk7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxzcGFuPlxuICAgICAge1dyYXBwZXJcbiAgICAgICAgPyBlbGVtZW50cy5tYXAoKGVsZW1lbnQsIGkpID0+IChcbiAgICAgICAgICAgIDxXcmFwcGVyIGtleT17aX0+XG4gICAgICAgICAgICAgIHtlbGVtZW50fVxuICAgICAgICAgICAgICAmenduajtcbiAgICAgICAgICAgIDwvV3JhcHBlcj5cbiAgICAgICAgICApKVxuICAgICAgICA6IGVsZW1lbnRzfVxuICAgIDwvc3Bhbj5cbiAgKTtcbn1cblxuU2tlbGV0b24uZGVmYXVsdFByb3BzID0ge1xuICBjb3VudDogMSxcbiAgZHVyYXRpb246IDEuMixcbiAgd2lkdGg6IG51bGwsXG4gIHdyYXBwZXI6IG51bGwsXG4gIGhlaWdodDogbnVsbCxcbiAgY2lyY2xlOiBmYWxzZSxcbiAgZGVsYXk6IDBcbn07XG4iXX0= */")),
      style: _objectSpread({}, customStyle, {}, style)
    }, "\u200C"));
  }

  return (0, _core$1.jsx)("span", null, Wrapper ? elements.map(function (element, i) {
    return (0, _core$1.jsx)(Wrapper, {
      key: i
    }, element, "\u200C");
  }) : elements);
}

Skeleton$1.defaultProps = {
  count: 1,
  duration: 1.2,
  width: null,
  wrapper: null,
  height: null,
  circle: false,
  delay: 0
};

var skeletonTheme = {};

Object.defineProperty(skeletonTheme, "__esModule", {
  value: true
});
skeletonTheme.default = void 0;

var _react = _interopRequireWildcard(React__default);

var _core = require$$1;

var _skeleton = skeleton;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SkeletonTheme =
/*#__PURE__*/
function (_Component) {
  _inherits(SkeletonTheme, _Component);

  function SkeletonTheme() {
    _classCallCheck(this, SkeletonTheme);

    return _possibleConstructorReturn(this, _getPrototypeOf(SkeletonTheme).apply(this, arguments));
  }

  _createClass(SkeletonTheme, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          highlightColor = _this$props.highlightColor,
          children = _this$props.children;
      var themeStyles =
      /*#__PURE__*/
      (0, _core.css)(".react-loading-skeleton{background-color:", color, ";background-image:linear-gradient( 90deg,", color, ",", highlightColor, ",", color, " );};label:SkeletonTheme;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9za2VsZXRvbi10aGVtZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZMkIiLCJmaWxlIjoiLi4vc3JjL3NrZWxldG9uLXRoZW1lLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSBcIkBlbW90aW9uL2NvcmVcIjtcbmltcG9ydCB7IGRlZmF1bHRCYXNlQ29sb3IsIGRlZmF1bHRIaWdobGlnaHRDb2xvciB9IGZyb20gXCIuL3NrZWxldG9uXCI7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFNrZWxldG9uVGhlbWUgZXh0ZW5kcyBDb21wb25lbnQge1xuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIGNvbG9yOiBkZWZhdWx0QmFzZUNvbG9yLFxuICAgIGhpZ2hsaWdodENvbG9yOiBkZWZhdWx0SGlnaGxpZ2h0Q29sb3JcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBjb2xvciwgaGlnaGxpZ2h0Q29sb3IsIGNoaWxkcmVuIH0gPSB0aGlzLnByb3BzO1xuICAgIGNvbnN0IHRoZW1lU3R5bGVzID0gY3NzYFxuICAgICAgLnJlYWN0LWxvYWRpbmctc2tlbGV0b24ge1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yfTtcbiAgICAgICAgYmFja2dyb3VuZC1pbWFnZTogbGluZWFyLWdyYWRpZW50KFxuICAgICAgICAgIDkwZGVnLFxuICAgICAgICAgICR7Y29sb3J9LFxuICAgICAgICAgICR7aGlnaGxpZ2h0Q29sb3J9LFxuICAgICAgICAgICR7Y29sb3J9XG4gICAgICAgICk7XG4gICAgICB9XG4gICAgYDtcbiAgICByZXR1cm4gPGRpdiBjc3M9e3RoZW1lU3R5bGVzfT57Y2hpbGRyZW59PC9kaXY+O1xuICB9XG59XG4iXX0= */"));
      return (0, _core.jsx)("div", {
        css: themeStyles
      }, children);
    }
  }]);

  return SkeletonTheme;
}(_react.Component);

skeletonTheme.default = SkeletonTheme;

_defineProperty$1(SkeletonTheme, "defaultProps", {
  color: _skeleton.defaultBaseColor,
  highlightColor: _skeleton.defaultHighlightColor
});

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _skeleton.default;
  }
});
Object.defineProperty(exports, "SkeletonTheme", {
  enumerable: true,
  get: function get() {
    return _skeletonTheme.default;
  }
});

var _skeleton = _interopRequireDefault(skeleton);

var _skeletonTheme = _interopRequireDefault(skeletonTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(lib));

var ReactLoadingSkeleton = /*@__PURE__*/getDefaultExportFromCjs(lib);

var Skeleton = function Skeleton(props) {
  return /*#__PURE__*/React__default.createElement(ReactLoadingSkeleton, props);
};

var ContractHeaderLoadingPlaceholder = function ContractHeaderLoadingPlaceholder(_ref) {
  var _ref$summaryElements = _ref.summaryElements,
      summaryElements = _ref$summaryElements === void 0 ? 3 : _ref$summaryElements;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30
  }), !!summaryElements && /*#__PURE__*/React__default.createElement(Layout, null, Array.from(Array(summaryElements).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: key,
      "default": '1/3',
      s: '1/1'
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 50,
      className: "u-mt"
    }));
  })));
};

var AmortizationTableLoadingPlaceholder = function AmortizationTableLoadingPlaceholder(_ref) {
  var _ref$tileElements = _ref.tileElements,
      tileElements = _ref$tileElements === void 0 ? 3 : _ref$tileElements;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Card, {
    className: "u-mb",
    element: "article"
  }, /*#__PURE__*/React__default.createElement(ContractHeaderLoadingPlaceholder, {
    summaryElements: 0
  })), /*#__PURE__*/React__default.createElement(Layout, {
    className: "u-mb-small"
  }, Array.from(Array(tileElements).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: key,
      "default": "1/".concat(tileElements),
      s: '1/1'
    }, /*#__PURE__*/React__default.createElement(Card, {
      element: "article"
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 50
    }), /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 35,
      count: 2
    })));
  })), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 50
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    count: 4,
    height: 40
  }));
};

var ContractDetailsLoadingPlaceholder = function ContractDetailsLoadingPlaceholder(_ref) {
  var _ref$sections = _ref.sections,
      sections = _ref$sections === void 0 ? [3, 2] : _ref$sections;
  return /*#__PURE__*/React__default.createElement(Layout, null, sections.map(function (section, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, sections.length > 1 ? /*#__PURE__*/React__default.createElement(Layout.Item, {
      "default": '1/2',
      s: '1/1'
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 40,
      className: "u-mb-small u-mt-small"
    })) : null, Array.from(Array(section).keys()).map(function (key) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: "".concat(index).concat(key)
      }, /*#__PURE__*/React__default.createElement(Layout.Item, {
        "default": '1/2',
        s: '1/1'
      }, /*#__PURE__*/React__default.createElement(Skeleton, {
        height: 30
      })), /*#__PURE__*/React__default.createElement(Layout.Item, {
        "default": '1/2',
        s: '1/1'
      }, /*#__PURE__*/React__default.createElement(Skeleton, {
        height: 30
      })));
    }));
  }));
};

var ContractsLoadingPlaceholder = function ContractsLoadingPlaceholder(_ref) {
  var _ref$summaryElements = _ref.summaryElements,
      summaryElements = _ref$summaryElements === void 0 ? 3 : _ref$summaryElements,
      _ref$numberOfContract = _ref.numberOfContracts,
      numberOfContracts = _ref$numberOfContract === void 0 ? 1 : _ref$numberOfContract,
      firstContractExpanded = _ref.firstContractExpanded,
      _ref$contractActions = _ref.contractActions,
      contractActions = _ref$contractActions === void 0 ? 0 : _ref$contractActions,
      _ref$contractDetailsR = _ref.contractDetailsRows,
      contractDetailsRows = _ref$contractDetailsR === void 0 ? 3 : _ref$contractDetailsR,
      _ref$expandable = _ref.expandable,
      expandable = _ref$expandable === void 0 ? false : _ref$expandable;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.from(Array(numberOfContracts).keys()).map(function (contractKey, index) {
    return /*#__PURE__*/React__default.createElement(Card, {
      element: "article",
      className: 'u-mb',
      expandable: expandable,
      contentLarge: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !!contractActions && /*#__PURE__*/React__default.createElement(Layout, null, Array.from(Array(contractActions).keys()).map(function (key) {
        return /*#__PURE__*/React__default.createElement(Layout.Item, {
          key: key,
          "default": '1/3',
          s: '1/1'
        }, /*#__PURE__*/React__default.createElement(Skeleton, {
          height: 45
        }));
      })), !!contractDetailsRows && Array.from(Array(contractDetailsRows).keys()).map(function (key) {
        return /*#__PURE__*/React__default.createElement(Skeleton, {
          height: 45,
          key: key
        });
      })),
      defaultExpanded: firstContractExpanded && index === 0,
      key: contractKey
    }, /*#__PURE__*/React__default.createElement(ContractHeaderLoadingPlaceholder, {
      summaryElements: summaryElements
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "u-mb"
    }));
  }));
};

var DividedContractHeaderLoadingPlaceholder = function DividedContractHeaderLoadingPlaceholder(_ref) {
  var _ref$withRightSideCon = _ref.withRightSideContent,
      withRightSideContent = _ref$withRightSideCon === void 0 ? true : _ref$withRightSideCon,
      _ref$withLicensePlate = _ref.withLicensePlate,
      withLicensePlate = _ref$withLicensePlate === void 0 ? true : _ref$withLicensePlate,
      withExtraInformation = _ref.withExtraInformation,
      _ref$rightSideContent = _ref.rightSideContentRows,
      rightSideContentRows = _ref$rightSideContent === void 0 ? 3 : _ref$rightSideContent,
      customRightSideContent = _ref.customRightSideContent;
  var carInformationPart = /*#__PURE__*/React__default.createElement("div", {
    className: "u-text-left@m-up u-mr-none cp-contract-identifier-slot"
  }, withLicensePlate && /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30
  }), withExtraInformation && /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30
  }));
  var rightSideContents = Array.from(Array(rightSideContentRows).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 40,
      key: key
    });
  });
  return /*#__PURE__*/React__default.createElement(Card, {
    element: "article"
  }, withRightSideContent ? /*#__PURE__*/React__default.createElement(Layout, {
    equalHeight: true,
    divider: true
  }, /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": "1/2",
    s: "1/1"
  }, carInformationPart), /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": "1/2",
    s: "1/1"
  }, /*#__PURE__*/React__default.createElement("div", null, customRightSideContent || rightSideContents))) : /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": "1/1"
  }, carInformationPart)));
};

var EarlySettlementLoadingPlaceholder = function EarlySettlementLoadingPlaceholder(_ref) {
  var _ref$withContractHead = _ref.withContractHeader,
      withContractHeader = _ref$withContractHead === void 0 ? true : _ref$withContractHead,
      _ref$withDividedContr = _ref.withDividedContractHeader,
      withDividedContractHeader = _ref$withDividedContr === void 0 ? false : _ref$withDividedContr,
      _ref$numberOfButtons = _ref.numberOfButtons,
      numberOfButtons = _ref$numberOfButtons === void 0 ? 2 : _ref$numberOfButtons,
      _ref$withDocumentUplo = _ref.withDocumentUpload,
      withDocumentUpload = _ref$withDocumentUplo === void 0 ? false : _ref$withDocumentUplo,
      _ref$summaryElements = _ref.summaryElements,
      summaryElements = _ref$summaryElements === void 0 ? 0 : _ref$summaryElements;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, withContractHeader && !withDividedContractHeader && /*#__PURE__*/React__default.createElement(Card, {
    element: "article"
  }, /*#__PURE__*/React__default.createElement(ContractHeaderLoadingPlaceholder, {
    summaryElements: 0
  })), withDividedContractHeader && /*#__PURE__*/React__default.createElement(DividedContractHeaderLoadingPlaceholder, {
    withExtraInformation: true
  }), /*#__PURE__*/React__default.createElement(ContentSection, {
    className: 'u-text-center'
  }, !!summaryElements && /*#__PURE__*/React__default.createElement(Skeleton, {
    count: summaryElements,
    height: 50
  }), /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 200
  })), withDocumentUpload && /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 170
  }))), Array.from(Array(numberOfButtons).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 40,
      width: 200,
      className: "u-mt u-m-xsmall",
      key: key
    });
  })));
};

var HeroTeaserLoadingPlaceholder = function HeroTeaserLoadingPlaceholder(_ref) {
  var _ref$withPretitle = _ref.withPretitle,
      withPretitle = _ref$withPretitle === void 0 ? false : _ref$withPretitle,
      _ref$withTitle = _ref.withTitle,
      withTitle = _ref$withTitle === void 0 ? true : _ref$withTitle,
      _ref$withSubTitle = _ref.withSubTitle,
      withSubTitle = _ref$withSubTitle === void 0 ? false : _ref$withSubTitle,
      _ref$withButton = _ref.withButton,
      withButton = _ref$withButton === void 0 ? false : _ref$withButton;

  var getTeaserItem = function getTeaserItem(layoutItemWidth) {
    return /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, {
      "default": layoutItemWidth,
      m: "1/1"
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 60
    })));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "c-hero-teaser c-hero-teaser--shallow"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "c-hero-teaser__image"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "c-hero-teaser__content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "c-hero-teaser__content-inner"
  }, withPretitle && getTeaserItem('1/5'), withTitle && getTeaserItem('1/3'), withSubTitle && getTeaserItem('1/2'), withButton && getTeaserItem('1/4'))));
};

var FaqLoadingPlaceholder = function FaqLoadingPlaceholder(_ref) {
  var _ref$withHeroTeaser = _ref.withHeroTeaser,
      withHeroTeaser = _ref$withHeroTeaser === void 0 ? true : _ref$withHeroTeaser,
      withDescription = _ref.withDescription,
      _ref$questionsCount = _ref.questionsCount,
      questionsCount = _ref$questionsCount === void 0 ? 5 : _ref$questionsCount,
      _ref$itemGroups = _ref.itemGroups,
      itemGroups = _ref$itemGroups === void 0 ? [] : _ref$itemGroups;
  return /*#__PURE__*/React__default.createElement(ContentSection, {
    pageWrapSize: "medium"
  }, withHeroTeaser && /*#__PURE__*/React__default.createElement(HeroTeaserLoadingPlaceholder, null), /*#__PURE__*/React__default.createElement("div", {
    className: "u-mh"
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 60
  }), withDescription && /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "u-mb"
  }), !itemGroups.length && /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    count: questionsCount
  }), itemGroups.map(function (group, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      className: "u-mb"
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 50,
      width: 200
    }), /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 30,
      count: group
    }));
  })));
};

var GreetingLoadingPlaceholder = function GreetingLoadingPlaceholder() {
  return /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 50,
    className: "u-mb"
  });
};

var IconFooterLoadingPlaceholder = function IconFooterLoadingPlaceholder(_ref) {
  var _ref$summaryElements = _ref.summaryElements,
      summaryElements = _ref$summaryElements === void 0 ? 3 : _ref$summaryElements;
  return /*#__PURE__*/React__default.createElement(Layout, {
    className: "row"
  }, Array.from(Array(summaryElements).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: key,
      "default": "1/".concat(summaryElements),
      s: '1/1'
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 170
    }));
  }));
};

var LandingPageMarketingCardLoadingPlaceholder = function LandingPageMarketingCardLoadingPlaceholder(_ref) {
  var _ref$cardStyles = _ref.cardStyles,
      cardStyles = _ref$cardStyles === void 0 ? ['normal'] : _ref$cardStyles;
  var image = /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 205
  });
  var content = /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 50
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 20,
    count: 3
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30
  }));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, cardStyles.map(function (style, index) {
    return /*#__PURE__*/React__default.createElement(Layout, {
      key: index,
      className: "u-mb"
    }, /*#__PURE__*/React__default.createElement(Layout.Item, {
      "default": "1/2"
    }, style === 'normal' ? image : content), /*#__PURE__*/React__default.createElement(Layout.Item, {
      "default": "1/2"
    }, style === 'normal' ? content : image));
  }));
};

var LegalFooterLoadingPlaceholder = function LegalFooterLoadingPlaceholder() {
  return /*#__PURE__*/React__default.createElement(Footer, null, /*#__PURE__*/React__default.createElement("div", {
    className: "u-p-small"
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 65
  })));
};

var LoginChoiceLoadingPlaceholder = function LoginChoiceLoadingPlaceholder() {
  return /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(ContentSection, {
    className: 'login-choice-form u-text-center'
  }, /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 90,
    width: 400,
    className: "u-mb u-mt-xlarge "
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 70
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 70,
    className: "u-mb u-mt"
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40,
    width: 150,
    className: "u-mb u-m-xsmall"
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40,
    width: 200,
    className: "u-mt"
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40,
    width: 200,
    className: "u-mb"
  })))));
};

var MarketingCardLoadingPlaceholder = function MarketingCardLoadingPlaceholder() {
  return /*#__PURE__*/React__default.createElement(Card, {
    element: "article"
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 250
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    className: "u-mb u-mt"
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    count: 3
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 25,
    className: "u-mb u-mt"
  }));
};

var MyDocumentsLoadingPlaceholder = function MyDocumentsLoadingPlaceholder(_ref) {
  var _ref$summaryElements = _ref.summaryElements,
      summaryElements = _ref$summaryElements === void 0 ? 3 : _ref$summaryElements;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 60,
    className: "u-mb"
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    className: "u-mb-small"
  }), /*#__PURE__*/React__default.createElement(Layout, {
    className: "u-mb-large"
  }, Array.from(Array(summaryElements).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: key,
      "default": "1/".concat(summaryElements),
      s: '1/1'
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 60
    }));
  })), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40,
    className: "u-mb-small"
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 35
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    count: 4,
    height: 50
  }));
};

var MyProfileLoadingPlaceholder = function MyProfileLoadingPlaceholder(_ref) {
  var _ref$sectionCounts = _ref.sectionCounts,
      sectionCounts = _ref$sectionCounts === void 0 ? [3, 8, 4] : _ref$sectionCounts;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, sectionCounts.map(function (rows, index) {
    return /*#__PURE__*/React__default.createElement(Card, {
      element: "article",
      key: index,
      className: "u-text-left"
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 30,
      width: 200,
      className: "u-mb"
    }), /*#__PURE__*/React__default.createElement(Skeleton, {
      count: rows,
      className: "u-mb-small"
    }));
  }));
};

var RegistrationLoadingPlaceholder = function RegistrationLoadingPlaceholder(_ref) {
  var _ref$numberOfButtons = _ref.numberOfButtons,
      numberOfButtons = _ref$numberOfButtons === void 0 ? 1 : _ref$numberOfButtons,
      _ref$summaryElements = _ref.summaryElements,
      summaryElements = _ref$summaryElements === void 0 ? 4 : _ref$summaryElements;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ContentSection, {
    className: 'u-text-center'
  }, /*#__PURE__*/React__default.createElement(PageWrap, {
    size: 'xsmall'
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, {
    className: 'u-text-center'
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 90,
    width: 300
  })), /*#__PURE__*/React__default.createElement(Layout.Item, {
    className: 'u-text-center'
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    width: 450
  })), /*#__PURE__*/React__default.createElement(Layout.Item, {
    className: 'u-text-center'
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    width: 300
  })), /*#__PURE__*/React__default.createElement(Layout.Item, {
    className: 'u-text-center'
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    width: 500
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, !!summaryElements && /*#__PURE__*/React__default.createElement(Skeleton, {
    count: summaryElements,
    height: 50
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40,
    count: numberOfButtons
  }))))));
};

var RequestLoadingPlaceholder = function RequestLoadingPlaceholder(_ref) {
  var _ref$withTextArea = _ref.withTextArea,
      withTextArea = _ref$withTextArea === void 0 ? false : _ref$withTextArea,
      _ref$withMarketingCar = _ref.withMarketingCard,
      withMarketingCard = _ref$withMarketingCar === void 0 ? false : _ref$withMarketingCar,
      _ref$numberOfButtons = _ref.numberOfButtons,
      numberOfButtons = _ref$numberOfButtons === void 0 ? 1 : _ref$numberOfButtons;
  return /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": withMarketingCard ? '2/3' : '1/1',
    m: '1/1'
  }, /*#__PURE__*/React__default.createElement(ContentSection, {
    className: 'request-certificate-form u-text-center'
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 70
  })), /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 70
  })), withTextArea && /*#__PURE__*/React__default.createElement(Layout.Item, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 140
  }))), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 40,
    width: 200,
    className: "u-mt u-m-xsmall",
    count: numberOfButtons
  }))), withMarketingCard && /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": '1/3',
    m: '1/1'
  }, /*#__PURE__*/React__default.createElement(MarketingCardLoadingPlaceholder, null)));
};

var DefaultStaticPageContentLoadingPlaceholder = function DefaultStaticPageContentLoadingPlaceholder() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 60
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    count: 4
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 60,
    className: "u-mt"
  }), /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 30,
    count: 3
  }));
};
var StaticPageLoadingPlaceholder = function StaticPageLoadingPlaceholder(_ref) {
  var _ref$withHeroTeaser = _ref.withHeroTeaser,
      withHeroTeaser = _ref$withHeroTeaser === void 0 ? true : _ref$withHeroTeaser,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["withHeroTeaser", "children"]);

  return /*#__PURE__*/React__default.createElement(ContentSection, {
    pageWrapSize: "medium"
  }, withHeroTeaser && /*#__PURE__*/React__default.createElement(HeroTeaserLoadingPlaceholder, rest), children || /*#__PURE__*/React__default.createElement(DefaultStaticPageContentLoadingPlaceholder, null));
};

var DealerRequestLoadingPlaceholder = function DealerRequestLoadingPlaceholder(_ref) {
  var _ref$summaryElements = _ref.summaryElements,
      summaryElements = _ref$summaryElements === void 0 ? 2 : _ref$summaryElements,
      _ref$numberOfButtons = _ref.numberOfButtons,
      numberOfButtons = _ref$numberOfButtons === void 0 ? 2 : _ref$numberOfButtons;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Layout, {
    className: "u-mb-large"
  }, Array.from(Array(summaryElements).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: key,
      "default": "1/".concat(summaryElements),
      s: '1/1'
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 60
    }));
  })), /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": '1/3',
    m: '1/2'
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 60,
    className: "u-mb"
  })), /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": '1/1',
    m: '1/1'
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    height: 230
  })), /*#__PURE__*/React__default.createElement(ContentSection, {
    className: 'u-text-right'
  }, Array.from(Array(numberOfButtons).keys()).map(function (key) {
    return /*#__PURE__*/React__default.createElement(Skeleton, {
      height: 50,
      width: 200,
      className: "u-mt u-m-xsmall",
      key: key
    });
  }))));
};

var DefinitionListItemTitle = function DefinitionListItemTitle(_ref) {
  var title = _ref.title,
      tooltip = _ref.tooltip,
      labelId = _ref.labelId;
  return /*#__PURE__*/React__default.createElement("div", null, title, tooltip && /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip,
    labelId: labelId
  }));
};

var DefinitionList = function DefinitionList(_ref) {
  var list = _ref.list,
      className = _ref.className,
      testId = _ref.testId,
      split = _ref.split,
      shortTerms = _ref.shortTerms;

  if (!list || list.length === 0) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(DescriptionList, {
    className: className,
    testId: testId,
    shortTerms: shortTerms,
    split: split,
    horizontal: true
  }, list.map(function (item, index) {
    var title = /*#__PURE__*/React__default.createElement(DefinitionListItemTitle, {
      title: item.label,
      tooltip: item.tooltip
    });
    return /*#__PURE__*/React__default.createElement(DescriptionList.Group, {
      testId: item.testId,
      key: index,
      termText: title
    }, /*#__PURE__*/React__default.createElement(DescriptionList.Detail, null, item.value ? /*#__PURE__*/React__default.createElement("span", {
      className: item.uppercaseValue ? 'u-text-uppercase' : ''
    }, item.value) : /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: '&nbsp;'
      },
      "data-testid": item.testId + 'Value'
    })));
  }));
};

var DefinitionListHorizontal = function DefinitionListHorizontal(_ref) {
  var list = _ref.list,
      className = _ref.className,
      testId = _ref.testId,
      shortTerms = _ref.shortTerms;

  if (!list || list.length === 0) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(DescriptionList, {
    className: className,
    testId: testId,
    shortTerms: shortTerms,
    horizontal: true
  }, list.map(function (item, index) {
    var title = /*#__PURE__*/React__default.createElement(DefinitionListItemTitle, {
      title: item.label,
      tooltip: item.tooltip,
      labelId: item.labelId
    });
    return /*#__PURE__*/React__default.createElement(DescriptionList.Group, {
      testId: item.testId,
      key: index,
      termText: title
    }, /*#__PURE__*/React__default.createElement(DescriptionList.Detail, null, item.value ? /*#__PURE__*/React__default.createElement("span", {
      className: item.uppercaseValue ? 'u-text-uppercase' : ''
    }, item.value) : /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: '&nbsp;'
      },
      "data-testid": item.testId + 'Value'
    })));
  }));
};

var DefinitionListCollection = function DefinitionListCollection(_ref) {
  var collectionItems = _ref.collectionItems,
      shortTerms = _ref.shortTerms;

  if (collectionItems.length === 0) {
    return null;
  }

  var lastItemIndex = collectionItems.length - 1;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, collectionItems.map(function (section, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, section.title && /*#__PURE__*/React__default.createElement("h6", null, section.title), section.summaryInformation && /*#__PURE__*/React__default.createElement("p", null, " ", section.summaryInformation, " "), /*#__PURE__*/React__default.createElement(DefinitionListHorizontal, {
      list: section.items,
      className: section.className,
      testId: section.testId,
      shortTerms: shortTerms
    }), lastItemIndex !== index && /*#__PURE__*/React__default.createElement("hr", {
      className: "u-mv"
    }));
  }));
};

var Faq = function Faq(_ref) {
  var header = _ref.header,
      descriptionText = _ref.descriptionText,
      items = _ref.items,
      itemGroups = _ref.itemGroups,
      _ref$openOneAtTime = _ref.openOneAtTime,
      openOneAtTime = _ref$openOneAtTime === void 0 ? true : _ref$openOneAtTime,
      onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement("section", null, /*#__PURE__*/React__default.createElement("h2", {
    className: 'cp-faq-header'
  }, header), /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "<p className={'cp-faq-description'}>".concat(descriptionText || '', "</p>")
    }
  }), !items && itemGroups ? /*#__PURE__*/React__default.createElement(Accordion, {
    onChange: onChange
  }, itemGroups && itemGroups.map(function (itemGroup) {
    return /*#__PURE__*/React__default.createElement(AccordionItem, {
      key: itemGroup.category,
      title: itemGroup.category
    }, /*#__PURE__*/React__default.createElement(FaqSectionView, {
      items: itemGroup.items,
      openOneAtTime: openOneAtTime
    }));
  })) : items && /*#__PURE__*/React__default.createElement(FaqSectionView, {
    onChange: onChange,
    items: items,
    openOneAtTime: openOneAtTime
  }));
};

var FaqSectionView = function FaqSectionView(_ref2) {
  var items = _ref2.items,
      _ref2$openOneAtTime = _ref2.openOneAtTime,
      openOneAtTime = _ref2$openOneAtTime === void 0 ? true : _ref2$openOneAtTime,
      onChange = _ref2.onChange;
  var itemsWithRenderedHtml = items.map(function (_ref3) {
    var question = _ref3.question,
        answer = _ref3.answer;
    return {
      title: question,
      content: /*#__PURE__*/React__default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: answer
        }
      })
    };
  });
  return /*#__PURE__*/React__default.createElement(Accordion, {
    openOneAtTime: openOneAtTime,
    onChange: onChange
  }, itemsWithRenderedHtml.map(function (item) {
    return /*#__PURE__*/React__default.createElement(AccordionItem, {
      key: item.title,
      title: item.title
    }, item.content);
  }));
};

var CookieTable = function CookieTable(_ref) {
  var columnTitles = _ref.columnTitles,
      cookies = _ref.cookies,
      props = _objectWithoutProperties(_ref, ["columnTitles", "cookies"]);

  var typeTitle = columnTitles.type,
      nameTitle = columnTitles.name,
      descriptionTitle = columnTitles.description,
      expirationDurationTitle = columnTitles.expirationDuration,
      service = columnTitles.service,
      creationTime = columnTitles.creationTime,
      source = columnTitles.source;
  return /*#__PURE__*/React__default.createElement(Table, _extends({
    bordered: true,
    colored: true,
    wide: true
  }, props), /*#__PURE__*/React__default.createElement(Table.Thead, null, /*#__PURE__*/React__default.createElement(Table.Tr, null, /*#__PURE__*/React__default.createElement(Table.Th, null, typeTitle), /*#__PURE__*/React__default.createElement(Table.Th, null, nameTitle), /*#__PURE__*/React__default.createElement(Table.Th, null, descriptionTitle), /*#__PURE__*/React__default.createElement(Table.Th, null, expirationDurationTitle), service && /*#__PURE__*/React__default.createElement(Table.Th, null, service), creationTime && /*#__PURE__*/React__default.createElement(Table.Th, null, creationTime), source && /*#__PURE__*/React__default.createElement(Table.Th, null, source))), /*#__PURE__*/React__default.createElement(Table.Tbody, null, cookies.map(function (_ref2) {
    var type = _ref2.type,
        name = _ref2.name,
        description = _ref2.description,
        expirationDuration = _ref2.expirationDuration,
        service = _ref2.service,
        creationTime = _ref2.creationTime,
        source = _ref2.source;
    return /*#__PURE__*/React__default.createElement(Table.Tr, {
      key: name
    }, /*#__PURE__*/React__default.createElement(Table.Td, null, type), /*#__PURE__*/React__default.createElement(Table.Td, null, name), /*#__PURE__*/React__default.createElement(Table.Td, null, /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: description
      }
    })), /*#__PURE__*/React__default.createElement(Table.Td, null, expirationDuration), service && /*#__PURE__*/React__default.createElement(Table.Td, null, service), creationTime && /*#__PURE__*/React__default.createElement(Table.Td, null, creationTime), source && /*#__PURE__*/React__default.createElement(Table.Td, null, source));
  })));
};
CookieTable.displayName = 'CookieTable';

var CookiePolicy = function CookiePolicy(_ref) {
  var title = _ref.title,
      textAboveTable = _ref.textAboveTable,
      cookieTable = _ref.cookieTable,
      textBelowTable = _ref.textBelowTable;
  var titleComponent = title ? /*#__PURE__*/React__default.createElement(SectionHeading, {
    level: 1
  }, title) : null;
  var textAboveTableComponent = textAboveTable ? /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: textAboveTable
    },
    className: 'u-pb-small'
  }) : null;
  var cookieTableComponent = cookieTable ? cookieTable : null;
  var textBelowTableComponent = textBelowTable ? /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: textBelowTable
    }
  }) : null;
  return /*#__PURE__*/React__default.createElement(ContentSection.ComponentWrapper, null, titleComponent, " ", textAboveTableComponent, " ", cookieTableComponent, " ", textBelowTableComponent);
};
CookiePolicy.displayName = 'CookiePolicy';

var ValueOrErrorMessage = function ValueOrErrorMessage(_ref) {
  var value = _ref.value,
      errorMessage = _ref.errorMessage;
  return value ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, value) : /*#__PURE__*/React__default.createElement(ErrorMessage, null, errorMessage);
};

var CheckmarkList = function CheckmarkList(_ref) {
  var items = _ref.items;

  if (items.length === 0) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(IconList$1, null, items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(IconList$1.Item, {
      key: index,
      icon: "checkmark"
    }, item);
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var hasError$1 = function hasError(meta) {
  return meta.touched && !!meta.error;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var hasSuccess = function hasSuccess(meta) {
  return meta.touched && !meta.error;
};

var ValidationErrorMessage = function ValidationErrorMessage(_ref) {
  var meta = _ref.meta,
      testId = _ref.testId,
      withHtmlValidationWarning = _ref.withHtmlValidationWarning,
      id = _ref.id;

  /**
   * Working with the style and not with an if statement was required to not break the tests in the markets.
   * See also hint from Bronson team
   * https://teams.microsoft.com/l/message/19:1ff395352c3542fa8477b5c53072ebdf@thread.skype/1598356613820?tenantId=e9293843-ced6-4c97-b99f-4998c3285f92&groupId=ca9aef03-550e-48ec-8b25-840a6c13b765&parentMessageId=1598356613820&teamName=Bronson-%20%2F%20UX-Support&channelName=General&createdTime=1598356613820
   */
  var hideErrorStyle = {
    display: 'none'
  };
  var hideErrorMessage = !hasError$1(meta);
  return /*#__PURE__*/React__default.createElement(ErrorMessage, {
    id: id,
    testId: "".concat(testId, "ErrorMessage"),
    style: hideErrorMessage ? hideErrorStyle : undefined,
    "aria-hidden": hideErrorMessage,
    role: "alert"
  }, withHtmlValidationWarning ? /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: meta.error || ''
    }
  }) : meta.error);
};

var getErrorMessageComponent = function getErrorMessageComponent(_ref) {
  var id = _ref.id,
      name = _ref.name,
      meta = _ref.meta,
      testId = _ref.testId,
      withHtmlValidationWarning = _ref.withHtmlValidationWarning;
  var errorMessageId = getErrorMessageId({
    name: name,
    id: id
  });
  return /*#__PURE__*/React__default.createElement(ValidationErrorMessage, {
    id: errorMessageId,
    meta: meta,
    testId: testId,
    withHtmlValidationWarning: withHtmlValidationWarning
  });
};
var getErrorMessageId = function getErrorMessageId(_ref2) {
  var name = _ref2.name,
      id = _ref2.id;
  var errorMessageId = id !== null && id !== void 0 ? id : name; // Bronson's ErrorMessage component appends `error-` to element id.

  return errorMessageId;
};
var getInputErrorMessageComponentAndId = function getInputErrorMessageComponentAndId(props) {
  var errorErrorMessageId = getErrorMessageId(props);
  return {
    errorMessageComponent: getErrorMessageComponent(props),
    errorMessageId: "error-".concat(errorErrorMessageId)
  };
};

var ValidatedCheckbox = function ValidatedCheckbox(_ref) {
  var name = _ref.name,
      label = _ref.label,
      testId = _ref.testId,
      _ref$isMandatory = _ref.isMandatory,
      isMandatory = _ref$isMandatory === void 0 ? false : _ref$isMandatory,
      onFocus = _ref.onFocus,
      disabled = _ref.disabled,
      id = _ref.id,
      hint = _ref.hint,
      withHtmlValidationWarning = _ref.withHtmlValidationWarning,
      className = _ref.className,
      tooltip = _ref.tooltip,
      inlineTooltip = _ref.inlineTooltip,
      formLabel = _ref.formLabel,
      isCheckboxMandatory = _ref.isCheckboxMandatory,
      onLinkClick = _ref.onLinkClick,
      groupName = _ref.groupName;

  var _useField = useField({
    name: name,
    type: 'checkbox'
  }),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var _ref2 = groupName ? useField({
    name: groupName
  }) : [],
      _ref3 = _slicedToArray(_ref2, 2),
      groupMeta = _ref3[1];

  var notion = isCheckboxMandatory ? /*#__PURE__*/React__default.createElement("span", {
    className: "c-form-field__notion"
  }, "* ") : null;
  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;
  var inlineInfoIcon = inlineTooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: inlineTooltip
  }) : null;

  var _getInputErrorMessage = getInputErrorMessageComponentAndId({
    name: name,
    id: id,
    meta: meta,
    testId: testId,
    withHtmlValidationWarning: withHtmlValidationWarning
  }),
      errorMessageComponent = _getInputErrorMessage.errorMessageComponent,
      errorMessageId = _getInputErrorMessage.errorMessageId;

  return /*#__PURE__*/React__default.createElement(FormField, {
    type: "checkbox",
    testId: "".concat(testId, "FormField"),
    required: isMandatory,
    hint: hint,
    onClick: onLinkClick,
    errorMessage: errorMessageComponent,
    labelText: formLabel,
    labelForId: id,
    infoIcon: infoIcon
  }, /*#__PURE__*/React__default.createElement(Checkbox, _extends({
    id: id,
    error: groupMeta ? hasError$1(groupMeta) : hasError$1(meta),
    onFocus: onFocus
  }, field, {
    testId: testId,
    disabled: disabled,
    className: className,
    "aria-describedby": errorMessageId
  }), label, notion, inlineInfoIcon));
};

var ValidatedInput = function ValidatedInput(_ref) {
  var children = _ref.children,
      name = _ref.name,
      label = _ref.label,
      hint = _ref.hint,
      onLinkClick = _ref.onLinkClick,
      testId = _ref.testId,
      id = _ref.id,
      tooltip = _ref.tooltip,
      handleChange = _ref.handleChange,
      _ref$isMandatory = _ref.isMandatory,
      isMandatory = _ref$isMandatory === void 0 ? false : _ref$isMandatory,
      _ref$requiredText = _ref.requiredText,
      requiredText = _ref$requiredText === void 0 ? '*' : _ref$requiredText,
      _ref$withHtmlValidati = _ref.withHtmlValidationWarning,
      withHtmlValidationWarning = _ref$withHtmlValidati === void 0 ? false : _ref$withHtmlValidati,
      inputId = _ref.inputId,
      inputClassName = _ref.inputClassName,
      className = _ref.className,
      helpText = _ref.helpText,
      helpTextClassName = _ref.helpTextClassName,
      addonElement = _ref.addonElement,
      autocomplete = _ref.autocomplete,
      disabled = _ref.disabled,
      inputProps = _objectWithoutProperties(_ref, ["children", "name", "label", "hint", "onLinkClick", "testId", "id", "tooltip", "handleChange", "isMandatory", "requiredText", "withHtmlValidationWarning", "inputId", "inputClassName", "className", "helpText", "helpTextClassName", "addonElement", "autocomplete", "disabled"]);

  var _useField = useField({
    name: name,
    type: 'input'
  }),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;

  var _getInputErrorMessage = getInputErrorMessageComponentAndId({
    name: name,
    id: id,
    meta: meta,
    testId: testId,
    withHtmlValidationWarning: withHtmlValidationWarning
  }),
      errorMessageComponent = _getInputErrorMessage.errorMessageComponent,
      errorMessageId = _getInputErrorMessage.errorMessageId;

  var errorMessage = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !disabled && errorMessageComponent, !!helpText && !hasError$1(meta) && /*#__PURE__*/React__default.createElement(Paragraph, {
    className: "u-text-muted u-text-fs-1 u-pt-xsmall ".concat(helpTextClassName !== null && helpTextClassName !== void 0 ? helpTextClassName : ''),
    testId: "".concat(testId, "HelpText")
  }, helpText));
  return /*#__PURE__*/React__default.createElement(FormField, {
    type: "input",
    onClick: onLinkClick,
    hint: hint,
    labelText: label,
    labelForId: inputId,
    testId: "".concat(testId, "FormField"),
    id: id,
    errorMessage: errorMessage,
    infoIcon: infoIcon,
    onChange: handleChange,
    required: isMandatory,
    requiredText: isMandatory ? requiredText : undefined,
    className: className
  }, /*#__PURE__*/React__default.createElement(Input, _extends({
    error: !disabled && hasError$1(meta),
    success: !disabled && hasSuccess(meta),
    testId: testId,
    id: inputId,
    className: inputClassName,
    addonElement: addonElement,
    autoComplete: autocomplete,
    disabled: disabled,
    "aria-invalid": hasError$1(meta),
    "aria-describedby": errorMessageId,
    required: isMandatory
  }, inputProps, field), children));
};

var ValidatedDate = function ValidatedDate(_ref) {
  var name = _ref.name,
      language = _ref.language,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      outputDateFormat = _ref.outputDateFormat,
      excludeWeekend = _ref.excludeWeekend,
      disableMobile = _ref.disableMobile,
      label = _ref.label,
      onLinkClick = _ref.onLinkClick,
      testId = _ref.testId,
      id = _ref.id,
      tooltip = _ref.tooltip,
      value = _ref.value,
      _ref$isMandatory = _ref.isMandatory,
      isMandatory = _ref$isMandatory === void 0 ? false : _ref$isMandatory,
      placeholder = _ref.placeholder,
      onFocus = _ref.onFocus,
      _ref$customDisableDat = _ref.customDisableDateConditions,
      customDisableDateConditions = _ref$customDisableDat === void 0 ? [] : _ref$customDisableDat,
      disabled = _ref.disabled,
      hint = _ref.hint,
      _ref$maskedInput = _ref.maskedInput,
      maskedInput = _ref$maskedInput === void 0 ? false : _ref$maskedInput,
      className = _ref.className;

  var _useFormikContext = useFormikContext(),
      setFieldTouched = _useFormikContext.setFieldTouched,
      setFieldValue = _useFormikContext.setFieldValue,
      getFieldMeta = _useFormikContext.getFieldMeta;

  var _useField = useField({
    name: name,
    type: 'input'
  }),
      _useField2 = _slicedToArray(_useField, 2),
      meta = _useField2[1];

  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;

  var _getInputErrorMessage = getInputErrorMessageComponentAndId({
    name: name,
    id: id,
    meta: meta,
    testId: testId
  }),
      errorMessageComponent = _getInputErrorMessage.errorMessageComponent,
      errorMessageId = _getInputErrorMessage.errorMessageId;

  var disabledDateConditions = _toConsumableArray(customDisableDateConditions);

  if (excludeWeekend) disabledDateConditions.push(function (date) {
    return date.getDay() === 0 || date.getDay() === 6;
  });
  return /*#__PURE__*/React__default.createElement(FormField, {
    type: "input",
    onClick: onLinkClick,
    labelText: label,
    labelForId: id,
    testId: "".concat(testId, "FormField"),
    errorMessage: errorMessageComponent,
    infoIcon: infoIcon,
    required: isMandatory,
    hint: hint,
    className: className
  }, /*#__PURE__*/React__default.createElement(DatePicker, {
    id: id,
    name: name,
    placeholder: placeholder,
    dateFormat: outputDateFormat,
    flatpickrOptions: {
      disable: disabledDateConditions,
      locale: language,
      disableMobile: !!disableMobile,
      errorHandler: function errorHandler(e) {
        console.log("Flatpickr error: ".concat(e));
      }
    },
    maxDate: maxDate,
    minDate: minDate,
    onBlur: function onBlur() {
      setFieldTouched(name, true, true);
    },
    onChange: function onChange(value) {
      setFieldValue(name, value, getFieldMeta(name).touched);
    },
    value: value,
    onFocus: onFocus,
    disabled: disabled,
    maskedInput: maskedInput,
    "aria-describedby": errorMessageId
  }));
};

var ValidatedSelect = function ValidatedSelect(_ref) {
  var name = _ref.name,
      label = _ref.label,
      id = _ref.id,
      testId = _ref.testId,
      selectItems = _ref.selectItems,
      placeholder = _ref.placeholder,
      className = _ref.className,
      selectClassName = _ref.selectClassName,
      disablePlaceholder = _ref.disablePlaceholder,
      _ref$isMandatory = _ref.isMandatory,
      isMandatory = _ref$isMandatory === void 0 ? false : _ref$isMandatory,
      emptyByDefault = _ref.emptyByDefault,
      onFocus = _ref.onFocus,
      tooltip = _ref.tooltip,
      _onChange = _ref.onChange,
      disabled = _ref.disabled,
      hint = _ref.hint,
      onLinkClick = _ref.onLinkClick;

  var _useField = useField({
    name: name,
    type: 'select'
  }),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;

  var _getInputErrorMessage = getInputErrorMessageComponentAndId({
    name: name,
    id: id,
    meta: meta,
    testId: testId
  }),
      errorMessageComponent = _getInputErrorMessage.errorMessageComponent,
      errorMessageId = _getInputErrorMessage.errorMessageId;

  return /*#__PURE__*/React__default.createElement(FormField, {
    type: "select",
    testId: "".concat(testId, "FormField"),
    labelText: label,
    labelForId: id,
    className: className,
    errorMessage: errorMessageComponent,
    required: isMandatory,
    infoIcon: infoIcon,
    hint: hint,
    onClick: onLinkClick
  }, /*#__PURE__*/React__default.createElement(Select, _extends({
    id: id,
    testId: testId,
    className: selectClassName,
    onFocus: onFocus
  }, field, {
    onChange: function onChange(e) {
      field.onChange(e); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      _onChange && _onChange(e.target.value);
    },
    disabled: disabled,
    "aria-describedby": errorMessageId
  }), emptyByDefault && /*#__PURE__*/React__default.createElement(Select.Item, {
    hidden: true
  }), placeholder && /*#__PURE__*/React__default.createElement(Select.Item, {
    value: '',
    disabled: disablePlaceholder !== null && disablePlaceholder !== void 0 ? disablePlaceholder : true
  }, placeholder), selectItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Select.Item, {
      key: (item === null || item === void 0 ? void 0 : item.key) ? item.key : item.value,
      value: item.value
    }, item.label);
  })));
};

var ValidatedTextarea = function ValidatedTextarea(_ref) {
  var id = _ref.id,
      testId = _ref.testId,
      name = _ref.name,
      tooltip = _ref.tooltip,
      onLinkClick = _ref.onLinkClick,
      label = _ref.label,
      maxLength = _ref.maxLength,
      placeholder = _ref.placeholder,
      _ref$isMandatory = _ref.isMandatory,
      isMandatory = _ref$isMandatory === void 0 ? false : _ref$isMandatory,
      _ref$enableMaxLength = _ref.enableMaxLength,
      enableMaxLength = _ref$enableMaxLength === void 0 ? false : _ref$enableMaxLength,
      disabled = _ref.disabled,
      hint = _ref.hint,
      className = _ref.className;

  var _useField = useField({
    name: name,
    type: 'textarea'
  }),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;

  var _getInputErrorMessage = getInputErrorMessageComponentAndId({
    name: name,
    id: id,
    meta: meta,
    testId: testId
  }),
      errorMessageComponent = _getInputErrorMessage.errorMessageComponent,
      errorMessageId = _getInputErrorMessage.errorMessageId;

  return /*#__PURE__*/React__default.createElement(FormField, {
    labelForId: id,
    type: "textarea",
    onClick: onLinkClick,
    labelText: label,
    testId: "".concat(testId, "FormField"),
    id: id,
    errorMessage: errorMessageComponent,
    infoIcon: infoIcon,
    required: isMandatory,
    hint: hint,
    className: className
  }, /*#__PURE__*/React__default.createElement(Textarea, _extends({
    "aria-describedby": errorMessageId,
    id: id,
    testId: testId,
    placeholder: placeholder,
    charCounter: true,
    maxCounter: maxLength,
    enableMaxLength: enableMaxLength,
    disabled: disabled
  }, field)));
};

var FocusFirstError = function FocusFirstError() {
  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      isSubmitting = _useFormikContext.isSubmitting,
      isValidating = _useFormikContext.isValidating;

  useEffect(function () {
    if (isSubmitting && !isValidating) {
      var keys = Object.keys(errors);

      if (keys.length > 0) {
        var selector = "[name=".concat(keys[0], "]");
        var errorElement = document.querySelector(selector);

        if (errorElement) {
          errorElement.focus();
        }
      }
    }
  }, [errors, isSubmitting, isValidating]);
  return null;
};

var ValidatedCheckboxWithGroup = function ValidatedCheckboxWithGroup(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React__default.createElement(ValidatedCheckbox, props);
};
var ValidatedCheckboxGroup = function ValidatedCheckboxGroup(_ref2) {
  var children = _ref2.children,
      name = _ref2.name,
      label = _ref2.label,
      secondaryLabel = _ref2.secondaryLabel,
      className = _ref2.className,
      testId = _ref2.testId,
      id = _ref2.id,
      _ref2$isMandatory = _ref2.isMandatory,
      isMandatory = _ref2$isMandatory === void 0 ? false : _ref2$isMandatory,
      _ref2$withHtmlValidat = _ref2.withHtmlValidationWarning,
      withHtmlValidationWarning = _ref2$withHtmlValidat === void 0 ? false : _ref2$withHtmlValidat,
      groupClassName = _ref2.groupClassName,
      onLinkClick = _ref2.onLinkClick,
      handleChange = _ref2.handleChange,
      tooltip = _ref2.tooltip,
      hint = _ref2.hint;

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 2),
      meta = _useField2[1];

  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;

  var _getInputErrorMessage = getInputErrorMessageComponentAndId({
    name: name,
    id: id,
    meta: meta,
    testId: testId,
    withHtmlValidationWarning: withHtmlValidationWarning
  }),
      errorMessageComponent = _getInputErrorMessage.errorMessageComponent;

  return /*#__PURE__*/React__default.createElement(FormField, {
    type: "other",
    testId: "".concat(testId, "FormField"),
    id: id,
    labelText: label,
    required: isMandatory,
    onClick: onLinkClick,
    infoIcon: infoIcon,
    onChange: handleChange,
    className: className,
    hint: hint
  }, secondaryLabel && /*#__PURE__*/React__default.createElement(Paragraph, {
    className: 'u-text-muted'
  }, secondaryLabel), /*#__PURE__*/React__default.createElement("div", {
    className: groupClassName
  }, children, errorMessageComponent));
};
ValidatedCheckboxGroup.Checkbox = ValidatedCheckboxWithGroup;

var ValidatedRadioButtonGroup = function ValidatedRadioButtonGroup(_ref) {
  var radioButtons = _ref.radioButtons,
      name = _ref.name,
      tooltip = _ref.tooltip,
      defaultChecked = _ref.defaultChecked,
      label = _ref.label,
      disabled = _ref.disabled,
      testId = _ref.testId,
      handleChange = _ref.handleChange,
      className = _ref.className,
      _ref$isMandatory = _ref.isMandatory,
      isMandatory = _ref$isMandatory === void 0 ? false : _ref$isMandatory,
      _ref$withHtmlValidati = _ref.withHtmlValidationWarning,
      withHtmlValidationWarning = _ref$withHtmlValidati === void 0 ? false : _ref$withHtmlValidati,
      formFieldClassName = _ref.formFieldClassName,
      hint = _ref.hint,
      id = _ref.id,
      onLinkClick = _ref.onLinkClick;

  var _useField = useField(name),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;

  var _getInputErrorMessage = getInputErrorMessageComponentAndId({
    name: name,
    id: id,
    meta: meta,
    testId: testId,
    withHtmlValidationWarning: withHtmlValidationWarning
  }),
      errorMessageComponent = _getInputErrorMessage.errorMessageComponent,
      errorMessageId = _getInputErrorMessage.errorMessageId;

  return /*#__PURE__*/React__default.createElement(FormField, {
    type: "other",
    id: id,
    testId: "".concat(testId, "FormField"),
    errorMessage: errorMessageComponent,
    labelText: label,
    infoIcon: infoIcon,
    onChange: handleChange,
    required: isMandatory,
    onClick: onLinkClick,
    className: formFieldClassName,
    hint: hint
  }, /*#__PURE__*/React__default.createElement(FormFieldRadioButtonGroup, _extends({
    className: className,
    "aria-describedby": errorMessageId
  }, field), radioButtons.map(function (_ref2, index) {
    var label = _ref2.label,
        value = _ref2.value,
        tooltip = _ref2.tooltip;
    return /*#__PURE__*/React__default.createElement(RadioButton, {
      key: index,
      testId: "".concat(testId, ".").concat(value),
      name: name,
      value: value,
      disabled: disabled,
      defaultChecked: defaultChecked || value === field.value
    }, label, tooltip && /*#__PURE__*/React__default.createElement(InfoIcon, {
      text: tooltip
    }));
  })));
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var withCleave = function withCleave(WrappedComponent) {
  var Wrapper = function Wrapper(_ref) {
    var name = _ref.name,
        cleaveOptions = _ref.cleaveOptions,
        handleChange = _ref.handleChange,
        props = _objectWithoutProperties(_ref, ["name", "cleaveOptions", "handleChange"]);

    var _useFormikContext = useFormikContext(),
        setFieldValue = _useFormikContext.setFieldValue,
        initialValues = _useFormikContext.initialValues;

    var stringifiedOptions = JSON.stringify(cleaveOptions);
    var inputSelector = "input[name=\"".concat(name, "\"]");
    var isInputElementMounted = document.querySelectorAll(inputSelector).length > 0;
    useLayoutEffect(function () {
      if (isInputElementMounted) {
        new Cleave(inputSelector, _objectSpread2$1(_objectSpread2$1({}, cleaveOptions), {}, {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          initValue: initialValues[name],
          onValueChanged: function onValueChanged(e) {
            setFieldValue("".concat(name), e.target.value, true);

            if (handleChange) {
              handleChange(e);
            }
          }
        }));
      } // TODO do proper cleanup


      return undefined;
    }, [setFieldValue, name, stringifiedOptions, isInputElementMounted]);
    return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({
      name: name
    }, props));
  };

  Wrapper.displayName = "withCleave(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapper;
};
var CleaveInput = withCleave(ValidatedInput);

var InfoBox = function InfoBox(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React__default.createElement("p", {
    className: "c-info-box"
  }, " ", text, " ");
};

var withAutoScroll = function withAutoScroll(WrappedComponent, wrappedComponentDisplayName) {
  var Wrapper = function Wrapper(props) {
    var scrollRef = useRef(null);
    useLayoutEffect(function () {
      if (scrollRef && scrollRef.current) {
        window.scrollTo(0, scrollRef.current.offsetTop);
      }
    }, [scrollRef]);
    return /*#__PURE__*/React__default.createElement("div", {
      ref: scrollRef
    }, /*#__PURE__*/React__default.createElement(WrappedComponent, props));
  };

  if (wrappedComponentDisplayName) {
    WrappedComponent.displayName = wrappedComponentDisplayName;
  }

  Wrapper.displayName = "withAutoScroll(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapper;
};

/**
 * Wraps the Bronson React DataOverview to introduce a short-term workaround aligned with the Bronson & UX teams
 * Should be removed as soon this becomes part of the Bronson React DataOverview or another solution is found
 */
var DataOverview = function DataOverview(_ref) {
  var withoutCardEffect = _ref.withoutCardEffect,
      props = _objectWithoutProperties(_ref, ["withoutCardEffect"]);

  return withoutCardEffect ? /*#__PURE__*/React__default.createElement(DataOverview$1, _extends({
    style: {
      boxShadow: 'none',
      border: 'none',
      paddingLeft: '0px'
    }
  }, props)) : /*#__PURE__*/React__default.createElement(DataOverview$1, props);
};

var TableHeaderCellWithTooltip = function TableHeaderCellWithTooltip(_ref) {
  var heading = _ref.heading,
      tooltip = _ref.tooltip;
  return /*#__PURE__*/React__default.createElement("span", null, heading, "\xA0", /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }));
};

var TableHeaderCell = function TableHeaderCell(_ref2) {
  var entry = _ref2.heading,
      sortable = _ref2.sortable,
      sortSelected = _ref2.sortSelected,
      sortOrder = _ref2.sortOrder,
      sortCallback = _ref2.sortCallback;
  var content = typeof entry === 'string' ? entry : entry.heading;
  var classNames = '';

  if (sortable) {
    content = /*#__PURE__*/React__default.createElement("a", {
      className: 'c-link',
      onClick: sortCallback
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "c-link__effect u-ws-nowrap"
    }, content, "\xA0", sortSelected && (sortOrder ? /*#__PURE__*/React__default.createElement("i", {
      className: 'c-icon c-icon--[semantic-sort-desc] c-icon-–simple'
    }) : /*#__PURE__*/React__default.createElement("i", {
      className: 'c-icon c-icon--[semantic-sort-asc] c-icon-–simple'
    }))));
  }

  if (typeof entry !== 'string') {
    var _ref3 = entry,
        tooltip = _ref3.tooltip,
        hiddenForMobile = _ref3.hiddenForMobile,
        textAlign = _ref3.textAlign;
    content = tooltip ? /*#__PURE__*/React__default.createElement(TableHeaderCellWithTooltip, {
      heading: content,
      tooltip: tooltip
    }) : content;
    classNames = [!!textAlign ? "u-text-".concat(textAlign) : '', !!hiddenForMobile ? 'u-hide@xs' : ''].filter(Boolean).join(' ');
  }

  return /*#__PURE__*/React__default.createElement(Table.Th, {
    className: classNames
  }, content);
};
TableHeaderCell.displayName = 'TableHeaderCell';

function groupRows(rows, groupByFn) {
  var result = {};
  rows.forEach(function (row) {
    var groupLabel = groupByFn(row); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

    result[groupLabel] ? result[groupLabel].push(row) : result[groupLabel] = [row];
  });
  return result;
}

function sortGroupLabels(groupedRows, groupByOptions) {
  var groupLabels = Object.keys(groupedRows);
  var reversed = groupByOptions.reversed,
      compareGroupByLabel = groupByOptions.compareGroupByLabel;
  var sortedGroupLabels = groupLabels.sort(compareGroupByLabel);
  return reversed ? sortedGroupLabels.reverse() : sortedGroupLabels;
}

function sortRows(rows, sortOptions) {
  if (sortOptions) {
    var compare = sortOptions.compare,
        _sortOptions$reversed = sortOptions.reversed,
        reversed = _sortOptions$reversed === void 0 ? false : _sortOptions$reversed;
    return reversed ? rows.sort(compare) : rows.sort(compare).reverse();
  }

  return rows;
}

function createGroupedTableRows() {
  var GroupedTableRows = function GroupedTableRows(_ref) {
    var rows = _ref.rows,
        groupByOptions = _ref.groupByOptions,
        sortOptions = _ref.sortOptions,
        toColumnValues = _ref.toColumnValues;

    if (rows.length <= 0) {
      return null;
    }

    var groupBy = groupByOptions.groupBy,
        formatGroupLabel = groupByOptions.formatGroupLabel;
    var sortedRows = sortRows(rows, sortOptions);
    var groupedRows = groupRows(sortedRows, groupBy);
    var sortedGroupLabels = sortGroupLabels(groupedRows, groupByOptions);
    var numberOfColumns = toColumnValues(rows[0]).length;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, sortedGroupLabels.map(function (groupLabel) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: groupLabel
      }, /*#__PURE__*/React__default.createElement(Table.Tr, null, /*#__PURE__*/React__default.createElement(Table.Th, {
        colSpan: numberOfColumns
      }, formatGroupLabel ? formatGroupLabel(groupLabel) : groupLabel)), groupedRows[groupLabel].map(function (row, rowIndex) {
        return /*#__PURE__*/React__default.createElement(Table.Tr, {
          key: groupLabel + rowIndex
        }, toColumnValues(row).map(function (cellData, cellIndex) {
          if (typeof cellData === 'string') {
            return /*#__PURE__*/React__default.createElement(Table.Td, {
              key: cellIndex
            }, cellData);
          }

          return /*#__PURE__*/React__default.createElement(Table.Td, {
            key: cellIndex,
            className: [!!cellData.nowrap ? 'u-ws-nowrap' : '', !!cellData.hiddenForMobile ? 'u-hide@xs' : '', !!cellData.textAlign ? "u-text-".concat(cellData.textAlign) : ''].filter(Boolean).join(' ')
          }, cellData === null || cellData === void 0 ? void 0 : cellData.value);
        }));
      }));
    }));
  };

  GroupedTableRows.displayName = 'GroupedTableRows';
  return GroupedTableRows;
}

function orderRows(rows, sortOptions) {
  if (sortOptions) {
    var compare = sortOptions.compare,
        _sortOptions$reversed = sortOptions.reversed,
        reversed = _sortOptions$reversed === void 0 ? false : _sortOptions$reversed;

    var copyRows = _toConsumableArray(rows);

    return reversed ? copyRows.sort(compare) : copyRows.sort(compare).reverse();
  }

  return rows;
}

function createOrderedTableRows() {
  var OrderedTableRows = function OrderedTableRows(_ref) {
    var rows = _ref.rows,
        sortOptions = _ref.sortOptions,
        toColumnValues = _ref.toColumnValues;

    if (rows.length <= 0) {
      return null;
    }

    var orderedRows = orderRows(rows, sortOptions);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, orderedRows.map(function (row, rowIndex) {
      return /*#__PURE__*/React__default.createElement(Table.Tr, {
        key: rowIndex
      }, toColumnValues(row).map(function (cellData, cellIndex) {
        if (typeof cellData === 'string') {
          return /*#__PURE__*/React__default.createElement(Table.Td, {
            key: cellIndex
          }, cellData);
        }

        return /*#__PURE__*/React__default.createElement(Table.Td, {
          key: cellIndex,
          className: [!!cellData.nowrap ? 'u-ws-nowrap' : '', !!cellData.hiddenForMobile ? 'u-hide@xs' : '', !!cellData.textAlign ? "u-text-".concat(cellData.textAlign) : ''].filter(Boolean).join(' ')
        }, cellData === null || cellData === void 0 ? void 0 : cellData.value);
      }));
    }));
  };

  OrderedTableRows.displayName = 'OrderedTableRows';
  return OrderedTableRows;
}

var TableSummary = function TableSummary(_ref) {
  var summaryRow = _ref.summaryRow;
  return /*#__PURE__*/React__default.createElement(Table.Tfoot, null, /*#__PURE__*/React__default.createElement(Table.Tr, null, summaryRow.map(function (cellData, cellIndex) {
    if (typeof cellData === 'string') {
      return /*#__PURE__*/React__default.createElement(Table.Th, {
        className: "u-bg-brand u-text-white",
        key: cellIndex
      }, cellData);
    }

    return /*#__PURE__*/React__default.createElement(Table.Th, {
      key: cellIndex,
      className: ['u-bg-brand u-text-white', !!cellData.hiddenForMobile ? 'u-hide@xs' : '', !!cellData.textAlign ? "u-text-".concat(cellData.textAlign) : ''].filter(Boolean).join(' ')
    }, cellData === null || cellData === void 0 ? void 0 : cellData.value);
  })));
};

function createDynamicTable() {
  var DynamicTable = function DynamicTable(_ref) {
    var rows = _ref.rows,
        columnHeadings = _ref.columnHeadings,
        groupByOptions = _ref.groupByOptions,
        defaultSortOptions = _ref.sortOptions,
        columnSortOptions = _ref.columnSortOptions,
        toColumnValues = _ref.toColumnValues,
        formatOptions = _ref.formatOptions,
        _ref$hasSummary = _ref.hasSummary,
        hasSummary = _ref$hasSummary === void 0 ? false : _ref$hasSummary,
        _ref$summaryRow = _ref.summaryRow,
        summaryRow = _ref$summaryRow === void 0 ? [] : _ref$summaryRow;

    var _useState = useState(function () {
      return {
        columnIndex: 0,
        options: columnSortOptions && columnSortOptions.length > 0 ? columnSortOptions[0] : defaultSortOptions,
        alternativeOrder: false
      };
    }),
        _useState2 = _slicedToArray(_useState, 2),
        selectedSortOptions = _useState2[0],
        setSelectedSortOptions = _useState2[1];

    if (!columnHeadings) {
      return null;
    }

    var sortCallback = function sortCallback(columnIndex) {
      return function () {
        if (columnSortOptions && columnSortOptions.length > columnIndex) {
          var newValue;

          if (selectedSortOptions && selectedSortOptions.columnIndex === columnIndex) {
            var currentOrder = selectedSortOptions.alternativeOrder;
            newValue = _objectSpread2$1(_objectSpread2$1({}, selectedSortOptions), {}, {
              alternativeOrder: !currentOrder
            });
          } else {
            newValue = {
              columnIndex: columnIndex,
              options: columnSortOptions[columnIndex],
              alternativeOrder: false
            };
          }

          setSelectedSortOptions(newValue);
        }
      };
    };

    var GroupedTableRows = createGroupedTableRows();
    var OrderedTableRows = createOrderedTableRows();
    var initialSortOptions = selectedSortOptions.options;
    var modifiedSortOptions = undefined;

    if (initialSortOptions) {
      modifiedSortOptions = _objectSpread2$1(_objectSpread2$1({}, initialSortOptions), {}, {
        reversed: !!(initialSortOptions === null || initialSortOptions === void 0 ? void 0 : initialSortOptions.reversed) != (selectedSortOptions === null || selectedSortOptions === void 0 ? void 0 : selectedSortOptions.alternativeOrder)
      });
    }

    return /*#__PURE__*/React__default.createElement(Table, formatOptions, /*#__PURE__*/React__default.createElement(Table.Thead, null, /*#__PURE__*/React__default.createElement(Table.Tr, null, columnHeadings.map(function (heading, index) {
      var _modifiedSortOptions;

      return /*#__PURE__*/React__default.createElement(TableHeaderCell, {
        key: typeof heading === 'string' ? heading : heading.heading,
        heading: heading,
        sortable: columnSortOptions && columnSortOptions.length > index,
        sortSelected: (selectedSortOptions === null || selectedSortOptions === void 0 ? void 0 : selectedSortOptions.columnIndex) === index,
        sortOrder: (_modifiedSortOptions = modifiedSortOptions) === null || _modifiedSortOptions === void 0 ? void 0 : _modifiedSortOptions.reversed,
        sortCallback: sortCallback(index)
      });
    }))), /*#__PURE__*/React__default.createElement(Table.Tbody, null, groupByOptions ? /*#__PURE__*/React__default.createElement(GroupedTableRows, {
      rows: rows,
      toColumnValues: toColumnValues,
      sortOptions: modifiedSortOptions,
      groupByOptions: groupByOptions
    }) : /*#__PURE__*/React__default.createElement(OrderedTableRows, {
      rows: rows,
      toColumnValues: toColumnValues,
      sortOptions: modifiedSortOptions
    })), hasSummary && /*#__PURE__*/React__default.createElement(TableSummary, {
      summaryRow: summaryRow
    }));
  };

  DynamicTable.displayName = 'DynamicTable';
  return DynamicTable;
}

var NotificationWithNavigationButton = function NotificationWithNavigationButton(_ref) {
  var status = _ref.status,
      headline = _ref.headline,
      text = _ref.text,
      _ref$notificationTest = _ref.notificationTestId,
      notificationTestId = _ref$notificationTest === void 0 ? 'notificationWithNavButton' : _ref$notificationTest,
      submitButtonLabel = _ref.submitButtonLabel,
      pathToNavigate = _ref.pathToNavigate,
      className = _ref.className;
  var history = useHistory();

  var handleClick = function handleClick() {
    return history.push(pathToNavigate);
  };

  return /*#__PURE__*/React__default.createElement(Notification$1, {
    className: className,
    visible: true,
    showCloseButton: false,
    status: status,
    title: headline,
    text: text,
    testId: notificationTestId
  }, /*#__PURE__*/React__default.createElement(Button, {
    secondary: true,
    className: "u-bg-white u-mt",
    testId: "submitButton",
    onClick: handleClick
  }, submitButtonLabel));
};

// TODO: Remove when Bronson-React exposes this component
var DownloadLink = function DownloadLink(_ref) {
  var label = _ref.label,
      fileInfo = _ref.fileInfo,
      _onClick = _ref.onClick,
      testId = _ref.testId;
  return /*#__PURE__*/React__default.createElement("a", {
    onClick: function onClick(event) {
      event.preventDefault();

      _onClick();
    },
    className: "c-link  c-download-link",
    "data-testid": testId
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "c-link__icon  c-icon  c-icon--[semantic-download]"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "c-link__body"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "c-link__effect"
  }, label), fileInfo && /*#__PURE__*/React__default.createElement("span", {
    className: "c-download-link__file-info"
  }, "(", fileInfo, ")")));
};

var IconList = function IconList(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React__default.createElement(IconList$1, null, items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(IconList$1.Item, {
      key: index,
      icon: item.icon
    }, item.label);
  }));
};

var CookieNotification = function CookieNotification(_ref) {
  var status = _ref.status,
      headline = _ref.headline,
      text = _ref.text,
      className = _ref.className,
      testId = _ref.testId,
      clickHandler = _ref.clickHandler,
      children = _ref.children;

  var _useState = useState(localStorage.cookiesAccepted || false),
      _useState2 = _slicedToArray(_useState, 2),
      accepted = _useState2[0],
      setAccepted = _useState2[1];

  var onClickButton = function onClickButton() {
    localStorage.cookiesAccepted = 'true';
    setAccepted(true);
  };

  return /*#__PURE__*/React__default.createElement(NotificationsGroup, null, /*#__PURE__*/React__default.createElement(Notification$1, {
    visible: !accepted,
    className: className,
    status: status,
    title: headline,
    showCloseButton: true,
    testId: testId,
    text: text,
    onCloseClick: function onCloseClick() {
      onClickButton(); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      !!clickHandler && clickHandler();
    }
  }, children));
};

var CookieNotificationStatusEnum;

(function (CookieNotificationStatusEnum) {
  CookieNotificationStatusEnum["info"] = "info";
  CookieNotificationStatusEnum["warning"] = "warning";
  CookieNotificationStatusEnum["success"] = "success";
  CookieNotificationStatusEnum["error"] = "error";
})(CookieNotificationStatusEnum || (CookieNotificationStatusEnum = {}));

var PageHeader = function PageHeader(_ref) {
  var title = _ref.title,
      testId = _ref.testId,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level;
  return /*#__PURE__*/React__default.createElement(Heading, {
    level: level,
    testId: testId
  }, title);
};

var formatOptions = {
  auto: true,
  noScroll: false,
  colored: false,
  bordered: true,
  highlight: false,
  wide: true
};

var toColumnValues = function toColumnValues(row) {
  return [row.name, row.version, row.copyright];
};

var ThirdPartyLicensesTable = function ThirdPartyLicensesTable(_ref) {
  var textAboveTable = _ref.textAboveTable,
      columnHeadings = _ref.columnHeadings,
      rows = _ref.rows,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? '' : _ref$description,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {
    label: '',
    url: ''
  } : _ref$link,
      viewLicenseLabel = _ref.viewLicenseLabel;
  var DynamicTable = createDynamicTable();
  return /*#__PURE__*/React__default.createElement(ContentSection, null, /*#__PURE__*/React__default.createElement(PageWrap, {
    size: 'medium'
  }, /*#__PURE__*/React__default.createElement("header", {
    className: "u-text-center"
  }, /*#__PURE__*/React__default.createElement("h3", null, /*#__PURE__*/React__default.createElement("p", null, textAboveTable))), /*#__PURE__*/React__default.createElement(DynamicTable, {
    rows: rows,
    columnHeadings: columnHeadings,
    toColumnValues: toColumnValues,
    formatOptions: formatOptions
  }), link.url && /*#__PURE__*/React__default.createElement("div", {
    className: "u-mb"
  }, /*#__PURE__*/React__default.createElement("span", null, viewLicenseLabel, ": "), /*#__PURE__*/React__default.createElement("a", {
    href: link.url
  }, link.label)), description && /*#__PURE__*/React__default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  })));
};

var lodash = {exports: {}};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
}(lodash, lodash.exports));

var _ = lodash.exports;

var groupLicensesByType = function groupLicensesByType(content) {
  return _.groupBy(content, 'license');
};
var getLicenseKey = function getLicenseKey(licenseType) {
  return licenseType.toLowerCase().replace(/\./gi, '-');
};

var css_248z$2 = ".c-input__input {\n    cursor: default;\n}";
styleInject(css_248z$2);

var defaultOptionKey = 'ALL';
var defaultOptionValue = 'All';
var generalOptionKey = 'GENERAL';
var PostboxFilters = function PostboxFilters(_ref) {
  var documentTypeFilter = _ref.documentTypeFilter,
      contractIdentifierFilter = _ref.contractIdentifierFilter,
      timeFrameFilter = _ref.timeFrameFilter,
      onDocumentTypeChange = _ref.onDocumentTypeChange,
      onContractIdentifierChange = _ref.onContractIdentifierChange,
      onTimeFrameChange = _ref.onTimeFrameChange,
      defaultContractIdentifierKey = _ref.defaultContractIdentifierKey,
      defaultDocumentTypeKey = _ref.defaultDocumentTypeKey,
      defaultTimeFrameFilterKey = _ref.defaultTimeFrameFilterKey;
  var filtersLength = [documentTypeFilter, contractIdentifierFilter, timeFrameFilter].filter(function (f) {
    return f;
  }).length;
  var documentTypeFilterItemsWithAll = documentTypeFilter && [{
    documentType: defaultOptionKey,
    value: documentTypeFilter.allLabel
  }].concat(_toConsumableArray(documentTypeFilter.filterItems));
  var contractIdentifierFilterItemsWithAll = contractIdentifierFilter && [{
    contractIdentifier: defaultOptionKey,
    value: contractIdentifierFilter.allLabel
  }].concat(_toConsumableArray(contractIdentifierFilter.withGeneralOption ? [{
    contractIdentifier: generalOptionKey,
    value: contractIdentifierFilter.generalLabel || ''
  }] : []), _toConsumableArray(contractIdentifierFilter.filterItems));
  var timeFrameItemsWithAll = timeFrameFilter && [{
    value: timeFrameFilter.allLabel,
    key: defaultOptionKey,
    reactNode: undefined
  }].concat(_toConsumableArray(timeFrameFilter.filterItems));

  var getDefaultDocumentTypeItems = function getDefaultDocumentTypeItems(documentTypeFilterItems) {
    var _documentTypeFilterIt;

    return {
      value: [defaultDocumentTypeKey ? {
        key: defaultDocumentTypeKey,
        value: (_documentTypeFilterIt = documentTypeFilterItems.find(function (el) {
          return el.documentType.toString() === defaultDocumentTypeKey;
        })) === null || _documentTypeFilterIt === void 0 ? void 0 : _documentTypeFilterIt.value
      } : {
        key: defaultOptionKey,
        value: defaultOptionValue
      }]
    };
  };

  var getDefaultContractIdentifierFilterItems = function getDefaultContractIdentifierFilterItems(contractIdentifierItems) {
    var _contractIdentifierIt;

    return {
      value: [defaultContractIdentifierKey ? {
        key: defaultContractIdentifierKey,
        value: (_contractIdentifierIt = contractIdentifierItems.find(function (el) {
          return el.contractIdentifier.toString() === defaultContractIdentifierKey.toString();
        })) === null || _contractIdentifierIt === void 0 ? void 0 : _contractIdentifierIt.value
      } : {
        key: defaultOptionKey,
        value: defaultOptionValue
      }]
    };
  };

  var getDefaultTimeFrameItems = function getDefaultTimeFrameItems(timeFrameItems) {
    var _timeFrameItems$find;

    return {
      value: [defaultTimeFrameFilterKey ? {
        key: defaultTimeFrameFilterKey,
        value: (_timeFrameItems$find = timeFrameItems.find(function (el) {
          return el.key === defaultTimeFrameFilterKey;
        })) === null || _timeFrameItems$find === void 0 ? void 0 : _timeFrameItems$find.value
      } : {
        key: defaultOptionKey,
        value: defaultOptionValue
      }]
    };
  };

  var defaultFraktion = "1/".concat(filtersLength);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Layout, null, !!documentTypeFilter && !!documentTypeFilterItemsWithAll && /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": defaultFraktion,
    s: '1/1'
  }, documentTypeFilter.label && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Paragraph, {
    id: documentTypeFilter.id
  }, documentTypeFilter.label)), /*#__PURE__*/React__default.createElement(Combobox, {
    testId: 'DocumentTypeFilter',
    ariaLabelledBy: documentTypeFilter.id,
    onChange: function onChange(value) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      onDocumentTypeChange && onDocumentTypeChange(value[0].key);
    },
    defaultState: getDefaultDocumentTypeItems(documentTypeFilterItemsWithAll)
  }, documentTypeFilterItemsWithAll.map(function (filterItem) {
    return /*#__PURE__*/React__default.createElement(Combobox.Item, {
      key: filterItem.documentType.toString(),
      testId: "DocumentTypeFilterItem-".concat(filterItem.documentType),
      optionValue: filterItem.value,
      optionKey: filterItem.documentType.toString()
    }, filterItem.reactNode || /*#__PURE__*/React__default.createElement("span", null, filterItem.value));
  }))), !!contractIdentifierFilter && !!contractIdentifierFilterItemsWithAll && /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": defaultFraktion,
    s: '1/1'
  }, contractIdentifierFilter.label && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Paragraph, {
    id: contractIdentifierFilter.id
  }, contractIdentifierFilter.label)), /*#__PURE__*/React__default.createElement(Combobox, {
    testId: 'ContractIdentifierFilter',
    ariaLabelledBy: contractIdentifierFilter.id,
    onChange: function onChange(value) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      onContractIdentifierChange && onContractIdentifierChange(value[0].key);
    },
    defaultState: getDefaultContractIdentifierFilterItems(contractIdentifierFilterItemsWithAll)
  }, contractIdentifierFilterItemsWithAll.map(function (filterItem) {
    return /*#__PURE__*/React__default.createElement(Combobox.Item, {
      key: filterItem.contractIdentifier.toString(),
      testId: "ContractIdentifierFilter-".concat(filterItem.contractIdentifier),
      optionValue: filterItem.value,
      optionKey: filterItem.contractIdentifier.toString()
    }, filterItem.reactNode || /*#__PURE__*/React__default.createElement("span", null, filterItem.value));
  }))), !!timeFrameFilter && !!timeFrameItemsWithAll && /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": defaultFraktion,
    s: '1/1'
  }, timeFrameFilter.label && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Paragraph, {
    id: timeFrameFilter.id
  }, timeFrameFilter.label)), /*#__PURE__*/React__default.createElement(Combobox, {
    testId: 'TimeFrameFilter',
    ariaLabelledBy: timeFrameFilter.id,
    onChange: function onChange(value) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      onTimeFrameChange && onTimeFrameChange(value[0].key);
    },
    defaultState: getDefaultTimeFrameItems(timeFrameItemsWithAll)
  }, timeFrameItemsWithAll.map(function (filterItem) {
    return /*#__PURE__*/React__default.createElement(Combobox.Item, {
      key: filterItem.key.toString(),
      testId: "TimeFrameFilter-".concat(filterItem.key),
      optionValue: filterItem.value,
      optionKey: filterItem.key.toString()
    }, filterItem.reactNode || /*#__PURE__*/React__default.createElement("span", null, filterItem.value));
  })))));
};

var css_248z$1 = ".c-inbox-table .c-inbox-table__td--subject {\n    padding-left: 14px !important;\n}\n";
styleInject(css_248z$1);

var PostboxTable = function PostboxTable(_ref) {
  var filterTitle = _ref.filterTitle,
      filterElements = _ref.filterElements,
      documents = _ref.documents,
      tableHeaderColumnLabels = _ref.tableHeaderColumnLabels,
      locale = _ref.locale,
      localization = _ref.localization,
      noDocumentsSelectedErrorText = _ref.noDocumentsSelectedErrorText,
      overridedColumns = _ref.overridedColumns,
      overridedHeaders = _ref.overridedHeaders,
      tableHeaderClassNames = _ref.tableHeaderClassNames,
      tableColumnClassNames = _ref.tableColumnClassNames,
      dateFormatter = _ref.dateFormatter,
      downloadButtonLabel = _ref.downloadButtonLabel,
      _ref$downloadShowLabe = _ref.downloadShowLabel,
      downloadShowLabel = _ref$downloadShowLabe === void 0 ? false : _ref$downloadShowLabe,
      deleteButtonLabel = _ref.deleteButtonLabel,
      _ref$deleteShowLabel = _ref.deleteShowLabel,
      deleteShowLabel = _ref$deleteShowLabel === void 0 ? false : _ref$deleteShowLabel,
      _ref$sortingOrder = _ref.sortingOrder,
      sortingOrder = _ref$sortingOrder === void 0 ? 'ASC' : _ref$sortingOrder;

  function removeDuplicatesFromArray(inputArray) {
    return Array.from(new Set(inputArray));
  }

  var allYearsInAllDocuments = documents.map(function (document) {
    return document.date.format('YYYY');
  });
  var availableYears = removeDuplicatesFromArray(allYearsInAllDocuments);
  return /*#__PURE__*/React__default.createElement(Inbox, {
    filterTitle: filterTitle,
    filterElements: filterElements,
    testId: 'InboxTable',
    columns: overridedColumns,
    locale: locale,
    dateFormatter: dateFormatter,
    localization: localization,
    tableHeaderClassNames: tableHeaderClassNames,
    tableColumnClassNames: tableColumnClassNames,
    tableHeader: overridedHeaders ? overridedHeaders : [/*#__PURE__*/React__default.createElement(React__default.Fragment, null, tableHeaderColumnLabels === null || tableHeaderColumnLabels === void 0 ? void 0 : tableHeaderColumnLabels.date), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (tableHeaderColumnLabels === null || tableHeaderColumnLabels === void 0 ? void 0 : tableHeaderColumnLabels.action) ? tableHeaderColumnLabels.action : "\xA0"), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, tableHeaderColumnLabels === null || tableHeaderColumnLabels === void 0 ? void 0 : tableHeaderColumnLabels.subject), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (tableHeaderColumnLabels === null || tableHeaderColumnLabels === void 0 ? void 0 : tableHeaderColumnLabels["delete"]) ? tableHeaderColumnLabels === null || tableHeaderColumnLabels === void 0 ? void 0 : tableHeaderColumnLabels["delete"] : "\xA0")],
    downloadButtonLabel: downloadButtonLabel,
    downloadShowLabel: downloadShowLabel,
    deleteButtonLabel: deleteButtonLabel,
    deleteShowLabel: deleteShowLabel,
    sortingOrder: sortingOrder
  }, documents.length === 0 ? /*#__PURE__*/React__default.createElement(Inbox.Section, {
    key: 'none',
    year: '',
    showTableHeader: true
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: (overridedHeaders === null || overridedHeaders === void 0 ? void 0 : overridedHeaders.length) || 4
  }, /*#__PURE__*/React__default.createElement(Notification, {
    status: NotificationStatus.info,
    text: noDocumentsSelectedErrorText
  })))) : availableYears.map(function (sectionYear) {
    return /*#__PURE__*/React__default.createElement(Inbox.Section, {
      year: sectionYear,
      showYear: true,
      showTableHeader: true,
      key: 'InboxSection-' + sectionYear
    }, documents.filter(function (document) {
      return document.date.format('YYYY') === sectionYear;
    }).map(function (document) {
      return document.loading ? /*#__PURE__*/React__default.createElement(SpinnerMessage, {
        key: 'InboxRow-' + document.documentId,
        colSpan: (overridedHeaders === null || overridedHeaders === void 0 ? void 0 : overridedHeaders.length) || 4,
        year: document.date.format('YYYY'),
        month: document.date.format('MM'),
        day: document.date.format('DD')
      }) : /*#__PURE__*/React__default.createElement(Inbox.Message, {
        testId: 'InboxRow-' + document.documentId,
        key: 'InboxRow-' + document.documentId,
        year: document.date.format('YYYY'),
        day: document.date.format('DD'),
        month: document.date.format('MM'),
        extraInfo: document.extraInfo,
        download: !document.showDelete,
        read: document.read,
        onItemClick: document.onClick,
        onDownloadClick: document.onClick,
        onDeleteClick: document.onDeleteClick,
        "col-publisher": document.publisher || ' ',
        "col-expiry-date": document.expiryDate || ' ',
        messageKey: "document-".concat(document.documentId),
        tooltipContent: document.tooltipContent
      }, document.subject);
    }));
  }));
};

var SpinnerMessage = function SpinnerMessage(_ref2) {
  var colSpan = _ref2.colSpan;
  return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: colSpan
  }, /*#__PURE__*/React__default.createElement(Spinner, {
    small: true
  })));
};

var testIds = {
  resetButton: 'ResetButton',
  filters: {
    documentType: {
      openId: 'DocumentTypeFilter',
      leasingDocument: 'DocumentTypeFilterItem-LEASING_DOCUMENT',
      all: 'DocumentTypeFilterItem-ALL'
    },
    contract: {
      openId: 'ContractIdentifierFilter',
      contract1000: 'ContractIdentifierFilter-1000',
      all: 'ContractIdentifierFilter-ALL',
      general: 'ContractIdentifierFilter-GENERAL'
    },
    timeFrame: {
      openId: 'TimeFrameFilter',
      year2020: 'TimeFrameFilter-2020',
      all: 'TimeFrameFilter-ALL'
    }
  },
  firstDocumentRow: 'InboxRow-1'
};

var Paging = function Paging(_ref) {
  var ariaLabel = _ref.ariaLabel,
      items = _ref.items,
      itemsPerPage = _ref.itemsPerPage,
      activePage = _ref.activePage,
      onPageClick = _ref.onPageClick,
      prevText = _ref.prevText,
      nextText = _ref.nextText,
      testId = _ref.testId;
  if (items <= itemsPerPage) return null;
  var pages = Math.ceil(items / itemsPerPage);

  var onPrevClick = function onPrevClick() {
    onPageClick(activePage - 1);
  };

  var onNextClick = function onNextClick() {
    onPageClick(activePage + 1);
  };

  var paginationItems = new Array(pages).fill(null).map(function (_, index) {
    var pageNumber = ++index;
    return /*#__PURE__*/React__default.createElement(Pagination.Item, {
      key: pageNumber,
      active: pageNumber === activePage,
      onClick: function onClick(e) {
        onPageClick(pageNumber);
        e.preventDefault();
      }
    }, pageNumber);
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'u-mt-small'
  }, /*#__PURE__*/React__default.createElement(Pagination, {
    title: ariaLabel,
    prevDisabled: activePage === 1,
    nextDisabled: activePage === pages,
    onPrevClick: onPrevClick,
    onNextClick: onNextClick,
    prevText: prevText,
    nextText: nextText,
    testId: testId
  }, paginationItems));
};

var Postbox = function Postbox(_ref) {
  var filters = _ref.filters,
      table = _ref.table,
      resetButtonText = _ref.resetButtonText,
      withPaging = _ref.withPaging,
      itemsPerPage = _ref.itemsPerPage,
      defaultDocumentType = _ref.defaultDocumentType,
      defaultContractIdentifier = _ref.defaultContractIdentifier,
      defaultTimeFrameFilterKey = _ref.defaultTimeFrameFilterKey;
  var allOptionKey = 'ALL';
  var generalOptionKey = 'GENERAL';

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      resetKey = _useState2[0],
      setResetKey = _useState2[1];

  var _useState3 = useState(defaultDocumentType ? defaultDocumentType : allOptionKey),
      _useState4 = _slicedToArray(_useState3, 2),
      currentDocumentTypeFilter = _useState4[0],
      setCurrentDocumentTypeFilter = _useState4[1];

  var _useState5 = useState(defaultDocumentType ? defaultDocumentType : allOptionKey),
      _useState6 = _slicedToArray(_useState5, 2),
      resetDocumentTypeFilter = _useState6[0],
      setResetDocumentTypeFilter = _useState6[1];

  var _useState7 = useState(defaultContractIdentifier ? defaultContractIdentifier : allOptionKey),
      _useState8 = _slicedToArray(_useState7, 2),
      currentContractIdentifier = _useState8[0],
      setContractIdentifier = _useState8[1];

  var _useState9 = useState(defaultContractIdentifier ? defaultContractIdentifier : allOptionKey),
      _useState10 = _slicedToArray(_useState9, 2),
      resetContractIdentifier = _useState10[0],
      setResetContractIdentifier = _useState10[1];

  var _useState11 = useState(defaultTimeFrameFilterKey ? defaultTimeFrameFilterKey : allOptionKey),
      _useState12 = _slicedToArray(_useState11, 2),
      currentTimeFrameFilterKey = _useState12[0],
      setTimeFrameFilterKey = _useState12[1];

  var _useState13 = useState(defaultTimeFrameFilterKey ? defaultTimeFrameFilterKey : allOptionKey),
      _useState14 = _slicedToArray(_useState13, 2),
      resetTimeFrameFilterKey = _useState14[0],
      setResetTimeFrameFilterKey = _useState14[1];

  var _useState15 = useState(table.documents),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedDocuments = _useState16[0],
      setSelectedDocuments = _useState16[1];

  var _useState17 = useState(1),
      _useState18 = _slicedToArray(_useState17, 2),
      page = _useState18[0],
      setPage = _useState18[1];

  useEffect(function () {
    setSelectedDocuments(table.documents.filter(function (document) {
      if (currentDocumentTypeFilter === allOptionKey) {
        return true;
      }

      return document.documentType.toString() === currentDocumentTypeFilter.toString();
    }).filter(function (document) {
      var _document$contractIde;

      if (currentContractIdentifier === allOptionKey) {
        return true;
      }

      if (currentContractIdentifier === generalOptionKey) {
        return !document.contractIdentifier;
      }

      return ((_document$contractIde = document.contractIdentifier) === null || _document$contractIde === void 0 ? void 0 : _document$contractIde.toString()) === currentContractIdentifier.toString();
    }).filter(function (document) {
      if (currentTimeFrameFilterKey === allOptionKey || !filters.timeFrameFilter) {
        return true;
      }

      var currentTimeFrameFilterItems = filters.timeFrameFilter.filterItems.filter(function (filterItem) {
        return filterItem.key.toString() === currentTimeFrameFilterKey.toString();
      })[0];
      var currentSelectedTimeFrom = currentTimeFrameFilterItems.from;
      var currentSelectedTimeTo = currentTimeFrameFilterItems.to;

      if (currentSelectedTimeFrom <= document.date && currentSelectedTimeTo >= document.date) {
        return true;
      }

      return false;
    }));
  }, [currentDocumentTypeFilter, currentContractIdentifier, currentTimeFrameFilterKey, filters, table, page]);

  function resetPage() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    withPaging && setPage(1);
  }

  function handleResetKey(value, resetKey) {
    if (value === allOptionKey && resetKey) {
      setResetKey(0);
      resetPage();
    } else if (value === allOptionKey) {
      setResetKey(function (prevState) {
        return prevState + 1;
      });
      resetPage();
    }
  }

  var onContractIdentifierChange = function onContractIdentifierChange(value) {
    setContractIdentifier(value);
    handleResetKey(value, true);
  };

  var onDocumentTypeChange = function onDocumentTypeChange(value) {
    setCurrentDocumentTypeFilter(value);
    handleResetKey(value, true);
  };

  var onTimeFrameChange = function onTimeFrameChange(value) {
    setTimeFrameFilterKey(value);
    handleResetKey(value, true);
  };

  var getDocumentsForPage = function getDocumentsForPage(documents) {
    if (!itemsPerPage || !withPaging) return documents;
    var from = (page - 1) * itemsPerPage;
    return documents.slice(from, from + itemsPerPage);
  };

  var resetAllFilters = function resetAllFilters() {
    setResetDocumentTypeFilter(allOptionKey);
    setResetContractIdentifier(allOptionKey);
    setResetTimeFrameFilterKey(allOptionKey);
    handleResetKey(allOptionKey);
    setCurrentDocumentTypeFilter(allOptionKey);
    setContractIdentifier(allOptionKey);
    setTimeFrameFilterKey(allOptionKey);
  };

  var hideResetButton = currentContractIdentifier === allOptionKey && currentDocumentTypeFilter === allOptionKey && currentTimeFrameFilterKey === allOptionKey;
  return /*#__PURE__*/React__default.createElement("div", {
    key: resetKey
  }, /*#__PURE__*/React__default.createElement(PostboxFilters, {
    documentTypeFilter: filters.documentTypeFilter,
    contractIdentifierFilter: filters.contractIdentifierFilter,
    timeFrameFilter: filters.timeFrameFilter,
    onContractIdentifierChange: onContractIdentifierChange,
    onDocumentTypeChange: onDocumentTypeChange,
    onTimeFrameChange: onTimeFrameChange,
    defaultDocumentTypeKey: resetDocumentTypeFilter,
    defaultContractIdentifierKey: resetContractIdentifier,
    defaultTimeFrameFilterKey: resetTimeFrameFilterKey
  }), /*#__PURE__*/React__default.createElement(Layout, {
    className: 'u-text-right u-mt-small'
  }, /*#__PURE__*/React__default.createElement(Layout.Item, {
    className: 'u-mt-none'
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: resetAllFilters,
    testId: testIds.resetButton,
    icon: 'semantic-reload',
    iconReversed: true,
    style: hideResetButton ? {
      visibility: 'hidden'
    } : undefined
  }, resetButtonText))), /*#__PURE__*/React__default.createElement(PostboxTable, {
    documents: getDocumentsForPage(selectedDocuments),
    tableHeaderColumnLabels: table.tableHeaderColumnLabels,
    locale: table.locale,
    tableHeaderClassNames: table.tableHeaderClassNames,
    tableColumnClassNames: table.tableColumnClassNames,
    localization: table.localization,
    noDocumentsSelectedErrorText: table.noDocumentsSelectedErrorText,
    dateFormatter: table.dateFormatter,
    overridedColumns: table.overridedColumns,
    overridedHeaders: table.overridedHeaders,
    sortingOrder: table.sortingOrder
  }), withPaging && itemsPerPage && /*#__PURE__*/React__default.createElement(Paging, {
    items: selectedDocuments.length,
    itemsPerPage: itemsPerPage,
    activePage: page,
    onPageClick: setPage
  }));
};

var InfoCheckbox = function InfoCheckbox(_ref) {
  var preLinkLabel = _ref.preLinkLabel,
      linkLabel = _ref.linkLabel,
      _ref$afterLinkLabel = _ref.afterLinkLabel,
      afterLinkLabel = _ref$afterLinkLabel === void 0 ? '.' : _ref$afterLinkLabel,
      testId = _ref.testId,
      fieldName = _ref.fieldName,
      testIdInfoText = _ref.testIdInfoText,
      infoLinkHref = _ref.infoLinkHref,
      tooltip = _ref.tooltip,
      linkRef = _ref.linkRef,
      isLinkButton = _ref.isLinkButton,
      children = _ref.children,
      id = _ref.id,
      onFocus = _ref.onFocus;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInfoText = _useState2[0],
      setShowInfoText = _useState2[1];

  var infoIcon = tooltip ? /*#__PURE__*/React__default.createElement(InfoIcon, {
    text: tooltip
  }) : null;
  var cardRef = useRef(null);

  function myAfterLink() {
    if (afterLinkLabel === '.') {
      return afterLinkLabel;
    }

    return ' ' + afterLinkLabel;
  }

  var scrollToCard = useCallback(function () {
    var _cardRef$current;

    cardRef === null || cardRef === void 0 ? void 0 : (_cardRef$current = cardRef.current) === null || _cardRef$current === void 0 ? void 0 : _cardRef$current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, []);

  var handleExternalClick = function handleExternalClick() {
    setShowInfoText(true);
    scrollToCard();
  };

  useEffect(function () {
    var _linkRef$current;

    linkRef === null || linkRef === void 0 ? void 0 : (_linkRef$current = linkRef.current) === null || _linkRef$current === void 0 ? void 0 : _linkRef$current.addEventListener('click', handleExternalClick);
    return function () {
      var _linkRef$current2;

      return linkRef === null || linkRef === void 0 ? void 0 : (_linkRef$current2 = linkRef.current) === null || _linkRef$current2 === void 0 ? void 0 : _linkRef$current2.removeEventListener('click', handleExternalClick);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    event.preventDefault();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Fieldset.Row, null, /*#__PURE__*/React__default.createElement(ValidatedCheckbox, {
    id: id,
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, preLinkLabel, preLinkLabel ? ' ' : undefined, children && (isLinkButton ? /*#__PURE__*/React__default.createElement("a", {
      onClick: function onClick(e) {
        e.preventDefault();
        setShowInfoText(!showInfoText);
      }
    }, linkLabel) : /*#__PURE__*/React__default.createElement(Button, {
      onClick: handleClick,
      link: true,
      testId: testId + 'ExpandableLink'
    }, linkLabel)), infoLinkHref && /*#__PURE__*/React__default.createElement("a", {
      href: infoLinkHref,
      target: '_blank',
      rel: "noreferrer",
      "data-testid": testId + 'ExternalLink'
    }, linkLabel), myAfterLink(), infoIcon),
    testId: testId,
    name: fieldName,
    onFocus: onFocus
  })), showInfoText && /*#__PURE__*/React__default.createElement(Fieldset.Row, {
    testId: testIdInfoText
  }, /*#__PURE__*/React__default.createElement(Card, {
    element: 'article',
    scrollable: true
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: cardRef,
    className: 'u-text-left'
  }, children))));
};

var AmortizationTableHeader = function AmortizationTableHeader(_ref) {
  var carInformation = _ref.carInformation,
      contractCategory = _ref.contractCategory,
      contractNumber = _ref.contractNumber,
      licensePlateComponent = _ref.licensePlateComponent,
      tiles = _ref.tiles,
      displayFractionLicensePlate = _ref.displayFractionLicensePlate,
      displayFractionTitle = _ref.displayFractionTitle,
      thirdLineData = _ref.thirdLineData;
  return /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": "1/1"
  }, /*#__PURE__*/React__default.createElement(Card, {
    element: "article"
  }, /*#__PURE__*/React__default.createElement(ContractHeader, {
    carInformation: carInformation,
    contractCategory: contractCategory,
    contractNumber: contractNumber,
    contractIdentifier: licensePlateComponent,
    displayFractionLicensePlate: displayFractionLicensePlate,
    displayFractionTitle: displayFractionTitle,
    thirdLineData: thirdLineData
  }))), tiles && /*#__PURE__*/React__default.createElement(Layout.Item, {
    "default": "1/1"
  }, /*#__PURE__*/React__default.createElement(Layout, {
    className: 'o-layout--equal-height'
  }, tiles)));
};

var AmortizationTableTiles = function AmortizationTableTiles(_ref) {
  var tiles = _ref.tiles,
      noWrap = _ref.noWrap;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, tiles.map(function (tile, index) {
    return /*#__PURE__*/React__default.createElement(Layout.Item, {
      key: index,
      "default": "1/3",
      m: "1/1",
      className: noWrap ? 'u-ws-nowrap' : ''
    }, /*#__PURE__*/React__default.createElement(DataOverview$1, {
      title: tile.title,
      icon: tile.icon
    }, /*#__PURE__*/React__default.createElement(DefinitionListHorizontal, {
      list: tile.data
    })));
  }));
};

var FileUploadItems = function FileUploadItems(_ref) {
  var files = _ref.files,
      removeFile = _ref.removeFile,
      maxFileSize = _ref.maxFileSize,
      maxFileSizePerFile = _ref.maxFileSizePerFile,
      validFileFormats = _ref.validFileFormats,
      _ref$progressValue = _ref.progressValue,
      progressValue = _ref$progressValue === void 0 ? '100' : _ref$progressValue,
      sizeError = _ref.sizeError,
      typeError = _ref.typeError,
      sizeAndTypeError = _ref.sizeAndTypeError,
      cancelLabel = _ref.cancelLabel,
      fileSizeFormatter = _ref.fileSizeFormatter;

  if (!files) {
    return null;
  }

  var getFileError = function getFileError(fileSize, fileType, index) {
    var isSizeInvalid = (maxFileSize ? maxFileSize < fileSize : false) || (maxFileSizePerFile ? maxFileSizePerFile < fileSize : false);
    var isTypeInvalid = validFileFormats ? !validFileFormats.some(function (type) {
      return type.toUpperCase() === fileType.toUpperCase();
    }) : false;

    if (!isSizeInvalid && !isTypeInvalid) {
      return '';
    }

    var error = isSizeInvalid && isTypeInvalid ? sizeAndTypeError : isSizeInvalid ? sizeError : typeError;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, error, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Button, {
      onClick: function onClick() {
        return removeFile(index);
      }
    }, cancelLabel));
  };

  var getFileType = function getFileType(name) {
    var lastDot = name.lastIndexOf('.');
    return name.substring(lastDot + 1).toLowerCase() || '';
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, files.map(function (_ref2, index) {
    var name = _ref2.name,
        size = _ref2.size;
    var type = getFileType(name);
    var error = getFileError(size, type, index);
    return /*#__PURE__*/React__default.createElement(UploadItem, {
      className: 'u-mb-small',
      key: index,
      icon: "semantic-file",
      fileName: name,
      error: !!error,
      fileSize: fileSizeFormatter(size),
      fileType: type,
      message: error,
      hideMainButton: true,
      onSecondaryButtonClick: function onSecondaryButtonClick() {
        return removeFile(index);
      },
      progressValue: progressValue
    });
  }));
};

var FileUpload = function FileUpload(_ref) {
  var maxFileSize = _ref.maxFileSize,
      maxFileSizePerFile = _ref.maxFileSizePerFile,
      validFileFormats = _ref.validFileFormats,
      sizeError = _ref.sizeError,
      typeError = _ref.typeError,
      sizeAndTypeError = _ref.sizeAndTypeError,
      cancelLabel = _ref.cancelLabel,
      fileSizeFormatter = _ref.fileSizeFormatter,
      rest = _objectWithoutProperties(_ref, ["maxFileSize", "maxFileSizePerFile", "validFileFormats", "sizeError", "typeError", "sizeAndTypeError", "cancelLabel", "fileSizeFormatter"]);

  var _useField = useField(rest.name),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var _useState = useState(field.value),
      _useState2 = _slicedToArray(_useState, 2),
      filesList = _useState2[0],
      setFilesList = _useState2[1];

  var removeFile = function removeFile(index) {
    var fileListCopy = _toConsumableArray(filesList);

    fileListCopy.splice(index, 1);
    setFilesList(fileListCopy);
    helpers.setValue(fileListCopy);
  };

  var fileChangedHandler = function fileChangedHandler(event) {
    var target = event.target;
    var files = target.files;
    var array = Array.prototype.slice.call(files);
    setFilesList([].concat(_toConsumableArray(filesList), _toConsumableArray(array)));
    helpers.setTouched(true);
    helpers.setValue([].concat(_toConsumableArray(filesList), _toConsumableArray(array)));
    target.value = '';
  };

  return /*#__PURE__*/React__default.createElement(FormField, {
    type: "input",
    testId: 'upload-form-field'
  }, /*#__PURE__*/React__default.createElement(UploadContainer, {
    upload: /*#__PURE__*/React__default.createElement(Upload, _extends({
      onChange: function onChange(e) {
        return fileChangedHandler(e);
      }
    }, rest)),
    testId: 'upload-container'
  }, /*#__PURE__*/React__default.createElement(FileUploadItems, {
    files: filesList,
    removeFile: removeFile,
    validFileFormats: validFileFormats,
    maxFileSize: maxFileSize,
    maxFileSizePerFile: maxFileSizePerFile,
    sizeError: sizeError,
    typeError: typeError,
    sizeAndTypeError: sizeAndTypeError,
    cancelLabel: cancelLabel,
    fileSizeFormatter: fileSizeFormatter
  })), meta.error && meta.touched && /*#__PURE__*/React__default.createElement("div", {
    className: "c-error-message u-mb-small"
  }, meta.error));
};

var groupByFileSize = function groupByFileSize(files, maxRequestSize) {
  return files.sort(function (_ref, _ref2) {
    var a = _ref.size;
    var b = _ref2.size;
    return b - a;
  }).reduce(function (acc, curr) {
    var assigned = false;
    var result = acc.map(function (combined) {
      var size = combined.reduce(function (sum, file) {
        return sum + file.size;
      }, 0);

      if (size + curr.size < maxRequestSize && !assigned) {
        assigned = true;
        return [].concat(_toConsumableArray(combined), [curr]);
      }

      return combined;
    });
    return !assigned ? [].concat(_toConsumableArray(result), [[curr]]) : result;
  }, []);
};

var useNotificationsCenter = function useNotificationsCenter(fetchFunction, intervalInMinutes) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      notificationsCenter = _useState2[0],
      setNotificationsCenter = _useState2[1];

  var cancelRequest = useRef(false);
  var fetchInterval = useRef();

  var fetch = function fetch() {
    fetchFunction().then(function (response) {
      if (cancelRequest.current) return;
      setNotificationsCenter(response.data);
    })["catch"](function (error) {
      // eslint-disable-next-line no-console
      console.warn(error); // eslint-disable-next-line no-console

      console.warn("Can not get notifications. Retrying in ".concat(intervalInMinutes, " min."));
    });
  };

  var startInterval = function startInterval() {
    return setInterval(function () {
      fetch();
    }, intervalInMinutes * 60 * 1000);
  };

  var update = function update(notifications) {
    setNotificationsCenter(notifications);
  };

  useEffect(function () {
    fetch();
    fetchInterval.current = startInterval();
    return function () {
      cancelRequest.current = true; // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      fetchInterval.current && clearInterval(fetchInterval.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    notificationsCenter: notificationsCenter,
    update: update
  };
};

var createItems = function createItems(notifications, setReadStatus) {
  var res = new Map();
  if (!notifications.length) return res;
  notifications.forEach(function (notification) {
    var id = notification.id,
        read = notification.read,
        date = notification.date,
        _onClick = notification.onClick,
        _onMarkReadUnread = notification.onMarkReadUnread,
        props = _objectWithoutProperties(notification, ["id", "read", "date", "onClick", "onMarkReadUnread"]);

    res.set(id, /*#__PURE__*/React__default.createElement(NotificationCenter.Item, _extends({
      key: id,
      unread: !read,
      datetime: date,
      testId: "notification-item-".concat(notification.id),
      onClick: function onClick() {
        setReadStatus(notification);

        _onClick();
      },
      onMarkReadUnread: function onMarkReadUnread() {
        setReadStatus(notification, true); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

        _onMarkReadUnread && _onMarkReadUnread();
      }
    }, props), /*#__PURE__*/React__default.createElement("p", null, notification.content)));
  });
  return res;
};

var nativeItemsMapper = function nativeItemsMapper(notifications) {
  return notifications.map(function (notification) {
    return {
      id: notification.id,
      title: notification.title,
      content: notification.content,
      read: notification.read,
      date: notification.date,
      onClick: function onClick() {
        // eslint-disable-next-line no-console
        console.warn('onClick or itemsMapper is not implemented');
      }
    };
  });
};

var NotificationsCenter = function NotificationsCenter(_ref) {
  var fetchFunction = _ref.fetchFunction,
      itemsMapper = _ref.itemsMapper,
      intervalInMinutes = _ref.intervalInMinutes,
      toggleLabel = _ref.toggleLabel,
      panelHeading = _ref.panelHeading,
      _ref$closeButtonLabel = _ref.closeButtonLabel,
      closeButtonLabel = _ref$closeButtonLabel === void 0 ? '' : _ref$closeButtonLabel;

  var _useNotificationsCent = useNotificationsCenter(fetchFunction, intervalInMinutes),
      notificationsCenter = _useNotificationsCent.notificationsCenter,
      update = _useNotificationsCent.update;

  var setReadStatus = function setReadStatus(notificationItem) {
    var toggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var updatedNotificationsCenter = _toConsumableArray(notificationsCenter);

    var updatedNotificationItem = updatedNotificationsCenter.find(function (item) {
      return item.id === notificationItem.id;
    }); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

    updatedNotificationItem && (updatedNotificationItem.read = toggle ? !updatedNotificationItem.read : true);
    update(updatedNotificationsCenter);
  };

  var mappedItems = itemsMapper ? itemsMapper(notificationsCenter) : nativeItemsMapper(notificationsCenter);
  var items = createItems(mappedItems, setReadStatus);
  return /*#__PURE__*/React__default.createElement(NotificationCenter, {
    closeButtonLabel: closeButtonLabel,
    toggleLabel: toggleLabel,
    panelHeading: panelHeading,
    testId: 'notifications-center',
    notifications: mappedItems
  }, function (data) {
    return items.get(data.id);
  });
};

var css_248z = ".dot-indicators-on-top {\n    margin-top: 14px !important;\n}\n\n.dot-indicators-on-top .flickity-page-dots {\n    bottom: auto !important;\n    top: -30px;\n}\n";
styleInject(css_248z);

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      options = _ref.options,
      className = _ref.className;
  options = _objectSpread2$1(_objectSpread2$1({
    autoPlay: true,
    wrapAround: true,
    adaptiveHeight: true,
    prevNextButtons: false
  }, options), {}, {
    cellSelector: '.c-carousel__item'
  });
  var cnt = 0;
  Children.forEach(children, function (child) {
    return child && cnt++;
  });
  var margin = 14;

  switch (process.env.REACT_APP_WEBSITE_BRONSON_THEME) {
    case 'audi':
      margin = 12;
      break;

    case 'vw6':
      margin = 20;
      break;

    case 'seat':
    case 'skoda':
      margin = 16;
      break;
  }

  margin = options.withoutMarketingCards ? 0 : margin;
  var cssClass = options.dotIndicatorOnTop ? 'dot-indicators-on-top' : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, cnt > 1 ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "-".concat(margin, "px")
    },
    className: cssClass
  }, /*#__PURE__*/React__default.createElement(Flickity, {
    elementType: "div",
    className: "c-carousel js-carousel",
    options: options
  }, Children.map(children, function (child) {
    return child && /*#__PURE__*/React__default.createElement("div", {
      className: "c-carousel__item u-p-small"
    }, child);
  }))) : children);
};
Carousel.displayName = 'Carousel';

var ErrorPage = function ErrorPage(_ref) {
  var headline = _ref.headline,
      _ref$headlineLevel = _ref.headlineLevel,
      headlineLevel = _ref$headlineLevel === void 0 ? 2 : _ref$headlineLevel,
      className = _ref.className,
      testId = _ref.testId,
      pageWrapSize = _ref.pageWrapSize,
      notificationHeadline = _ref.notificationHeadline,
      notificationText = _ref.notificationText,
      buttonLabel = _ref.buttonLabel,
      onButtonClick = _ref.onButtonClick;
  return /*#__PURE__*/React__default.createElement(ContentSection, {
    pageWrapSize: pageWrapSize,
    className: "".concat(className || '', " u-text-center"),
    testId: testId
  }, /*#__PURE__*/React__default.createElement(Heading, {
    level: headlineLevel,
    testId: "".concat(testId, "-headline"),
    className: 'u-mb-large'
  }, headline), /*#__PURE__*/React__default.createElement(Notification$1, {
    visible: true,
    title: notificationHeadline,
    status: NotificationStatus.error,
    showCloseButton: false,
    text: notificationText,
    testId: "".concat(testId, "-notification")
  }), !!buttonLabel && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onButtonClick,
    testId: "".concat(testId, "-button"),
    className: 'u-mt-large'
  }, buttonLabel));
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty$1 = _defineProperty;

var defineProperty = defineProperty$1;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var objectSpread2 = _objectSpread2;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose;

var propTypes$1 = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q=b$1?
Symbol.for("react.suspense_list"):60120,r$1=b$1?Symbol.for("react.memo"):60115,t=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w=b$1?Symbol.for("react.fundamental"):60117,x=b$1?Symbol.for("react.responder"):60118,y=b$1?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$1:case m$1:case e:case g:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r$1:case h$1:return a;default:return u}}case d$1:return u}}}function A(a){return z(a)===m$1}reactIs_production_min.AsyncMode=l$1;reactIs_production_min.ConcurrentMode=m$1;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h$1;reactIs_production_min.Element=c$1;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r$1;reactIs_production_min.Portal=d$1;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f$1;reactIs_production_min.Suspense=p$1;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l$1};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h$1};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r$1};reactIs_production_min.isPortal=function(a){return z(a)===d$1};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f$1};reactIs_production_min.isSuspense=function(a){return z(a)===p$1};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m$1||a===g||a===f$1||a===p$1||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r$1||a.$$typeof===h$1||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v$1)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$7 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$7;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$3 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$6 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$4 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$3 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$3(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$4(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$6);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$3(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$1[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$3(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$3.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};

var checkPropTypes_1$1 = checkPropTypes$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$3 = reactIs$1.exports;
var assign$1 = objectAssign;

var ReactPropTypesSecret$5 = ReactPropTypesSecret_1$1;
var checkPropTypes$2 = checkPropTypes_1$1;

var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull$1() {
  return null;
}

var factoryWithTypeCheckers$1 = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$5) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$2(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$5);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$3.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$2(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$2('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$3(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$5);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$2('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$2(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull$1;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$5) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$5);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$5);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes$2;
  ReactPropTypes.resetWarningCache = checkPropTypes$2.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$4 = ReactPropTypesSecret_1$1;

function emptyFunction$1() {}
function emptyFunctionWithReset$1() {}
emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims$1 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$4) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs$2 = reactIs$1.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess$1 = true;
  propTypes$1.exports = factoryWithTypeCheckers$1(ReactIs$2.isElement, throwOnDirectAccess$1);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$1.exports = factoryWithThrowingShims$1();
}

var PropTypes = propTypes$1.exports;

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

function createReactKeycloakContext(initialContext) {
  return createContext(objectSpread2({
    initialized: false
  }, initialContext));
}

var initialState = {
  initialized: false,
  isLoading: true,
  token: undefined
};
function createReactKeycloakProvider(ReactKeycloakContext) {
  var KeycloakProvider = /*#__PURE__*/function (_React$PureComponent) {
    inheritsLoose(KeycloakProvider, _React$PureComponent);

    function KeycloakProvider() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

      defineProperty$1(assertThisInitialized(_this), "defaultInitConfig", {
        onLoad: 'check-sso',
        promiseType: 'native'
      });

      defineProperty$1(assertThisInitialized(_this), "state", objectSpread2({}, initialState));

      defineProperty$1(assertThisInitialized(_this), "onKeycloakError", function (event) {
        return function (error) {
          var onEvent = _this.props.onEvent; // Notify Events listener

          onEvent && onEvent(event, error);
        };
      });

      defineProperty$1(assertThisInitialized(_this), "updateState", function (event) {
        return function () {
          var _this$props = _this.props,
              keycloak = _this$props.keycloak,
              onEvent = _this$props.onEvent,
              onTokens = _this$props.onTokens,
              isLoadingCheck = _this$props.isLoadingCheck;
          var _this$state = _this.state,
              prevInitialized = _this$state.initialized,
              prevLoading = _this$state.isLoading,
              prevToken = _this$state.token;
          var idToken = keycloak.idToken,
              refreshToken = keycloak.refreshToken,
              newToken = keycloak.token; // Notify Events listener

          onEvent && onEvent(event); // Check Loading state

          var isLoading = isLoadingCheck ? isLoadingCheck(keycloak) : false; // Avoid double-refresh if state hasn't changed

          if (!prevInitialized || isLoading !== prevLoading || newToken !== prevToken) {
            _this.setState({
              initialized: true,
              isLoading: isLoading,
              token: newToken
            });
          } // Notify token listener, if any


          if (newToken !== prevToken) {
            onTokens && onTokens({
              idToken: idToken,
              refreshToken: refreshToken,
              token: newToken
            });
          }
        };
      });

      defineProperty$1(assertThisInitialized(_this), "refreshKeycloakToken", function (event) {
        return function () {
          var _this$props2 = _this.props,
              autoRefreshToken = _this$props2.autoRefreshToken,
              keycloak = _this$props2.keycloak,
              onEvent = _this$props2.onEvent; // Notify Events listener

          onEvent && onEvent(event);

          if (autoRefreshToken) {
            // Refresh Keycloak token
            keycloak.updateToken(5);
          }
        };
      });

      return _this;
    }

    var _proto = KeycloakProvider.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.init();
    };

    _proto.componentDidUpdate = function componentDidUpdate(_ref) {
      var prevKeycloak = _ref.keycloak,
          prevInitConfig = _ref.initConfig;

      if (this.props.keycloak !== prevKeycloak || !reactFastCompare(this.props.initConfig, prevInitConfig)) {
        // De-init previous Keycloak instance
        prevKeycloak.onReady = undefined;
        prevKeycloak.onAuthSuccess = undefined;
        prevKeycloak.onAuthError = undefined;
        prevKeycloak.onAuthRefreshSuccess = undefined;
        prevKeycloak.onAuthRefreshError = undefined;
        prevKeycloak.onAuthLogout = undefined;
        prevKeycloak.onTokenExpired = undefined; // Reset state

        this.setState(objectSpread2({}, initialState)); // Init new Keycloak instance

        this.init();
      }
    };

    _proto.init = function init() {
      var _this$props3 = this.props,
          initConfig = _this$props3.initConfig,
          keycloak = _this$props3.keycloak; // Attach Keycloak listeners

      keycloak.onReady = this.updateState('onReady');
      keycloak.onAuthSuccess = this.updateState('onAuthSuccess');
      keycloak.onAuthError = this.onKeycloakError('onAuthError');
      keycloak.onAuthRefreshSuccess = this.updateState('onAuthRefreshSuccess');
      keycloak.onAuthRefreshError = this.onKeycloakError('onAuthRefreshError');
      keycloak.onAuthLogout = this.updateState('onAuthLogout');
      keycloak.onTokenExpired = this.refreshKeycloakToken('onTokenExpired');
      keycloak.init(objectSpread2(objectSpread2({}, this.defaultInitConfig), initConfig)).catch(this.onKeycloakError('onInitError'));
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          keycloak = _this$props4.keycloak,
          LoadingComponent = _this$props4.LoadingComponent;
      var _this$state2 = this.state,
          initialized = _this$state2.initialized,
          isLoading = _this$state2.isLoading;

      if (!!LoadingComponent && (!initialized || isLoading)) {
        return LoadingComponent;
      }

      return /*#__PURE__*/createElement(ReactKeycloakContext.Provider, {
        value: {
          initialized: initialized,
          keycloak: keycloak
        }
      }, children);
    };

    return KeycloakProvider;
  }(PureComponent);

  process.env.NODE_ENV !== "production" ? KeycloakProvider.propTypes = {
    children: PropTypes.element.isRequired,
    keycloak: PropTypes.shape({
      init: PropTypes.func.isRequired,
      updateToken: PropTypes.func.isRequired,
      idToken: PropTypes.string,
      refreshToken: PropTypes.string,
      token: PropTypes.string,
      onReady: PropTypes.func,
      onAuthSuccess: PropTypes.func,
      onAuthError: PropTypes.func,
      onAuthRefreshSuccess: PropTypes.func,
      onAuthRefreshError: PropTypes.func,
      onAuthLogout: PropTypes.func,
      onTokenExpired: PropTypes.func
    }).isRequired,
    autoRefreshToken: PropTypes.bool,
    initConfig: PropTypes.shape({}),
    isLoadingCheck: PropTypes.func,
    LoadingComponent: PropTypes.element,
    onError: PropTypes.func,
    onEvent: PropTypes.func,
    onTokens: PropTypes.func
  } : void 0;
  KeycloakProvider.defaultProps = {
    autoRefreshToken: true,
    initConfig: {
      onLoad: 'check-sso',
      promiseType: 'native'
    },
    isLoadingCheck: null,
    LoadingComponent: null,
    onError: null,
    onEvent: null,
    onTokens: null
  };
  return KeycloakProvider;
}

var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var reactKeycloakWebContext = createReactKeycloakContext();

var reactKeycloakProvider = createReactKeycloakProvider(reactKeycloakWebContext);

function useKeycloak() {
  var _useContext = useContext(reactKeycloakWebContext),
      initialized = _useContext.initialized,
      keycloak = _useContext.keycloak;

  return Object.assign([keycloak, initialized], {
    initialized: initialized,
    keycloak: keycloak
  });
}

var base64Js = {};

base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i$1 = 0, len = code.length; i$1 < len; ++i$1) {
  lookup[i$1] = code[i$1];
  revLookup[code.charCodeAt(i$1)] = i$1;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function getLens (b64) {
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4);

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen;

  var i;
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = (tmp >> 16) & 0xFF;
    arr[curByte++] = (tmp >> 8) & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4);
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2);
    arr[curByte++] = (tmp >> 8) & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    );
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    );
  }

  return parts.join('')
}

var sha256$1 = {exports: {}};

/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */

(function (module) {
/*jslint bitwise: true */
(function () {

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA256_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = commonjsGlobal;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && 'object' === 'object' && module.exports;
  var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (outputType, is224) {
    return function (message) {
      return new Sha256(is224, true).update(message)[outputType]();
    };
  };

  var createMethod = function (is224) {
    var method = createOutputMethod('hex', is224);
    if (NODE_JS) {
      method = nodeWrap(method, is224);
    }
    method.create = function () {
      return new Sha256(is224);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type, is224);
    }
    return method;
  };

  var nodeWrap = function (method, is224) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var algorithm = is224 ? 'sha224' : 'sha256';
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw new Error(ERROR);
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash(algorithm).update(new Buffer(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  var createHmacOutputMethod = function (outputType, is224) {
    return function (key, message) {
      return new HmacSha256(key, is224, true).update(message)[outputType]();
    };
  };

  var createHmacMethod = function (is224) {
    var method = createHmacOutputMethod('hex', is224);
    method.create = function (key) {
      return new HmacSha256(key, is224);
    };
    method.update = function (key, message) {
      return method.create(key).update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createHmacOutputMethod(type, is224);
    }
    return method;
  };

  function Sha256(is224, sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    if (is224) {
      this.h0 = 0xc1059ed8;
      this.h1 = 0x367cd507;
      this.h2 = 0x3070dd17;
      this.h3 = 0xf70e5939;
      this.h4 = 0xffc00b31;
      this.h5 = 0x68581511;
      this.h6 = 0x64f98fa7;
      this.h7 = 0xbefa4fa4;
    } else { // 256
      this.h0 = 0x6a09e667;
      this.h1 = 0xbb67ae85;
      this.h2 = 0x3c6ef372;
      this.h3 = 0xa54ff53a;
      this.h4 = 0x510e527f;
      this.h5 = 0x9b05688c;
      this.h6 = 0x1f83d9ab;
      this.h7 = 0x5be0cd19;
    }

    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
  }

  Sha256.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
          blocks[4] = blocks[5] = blocks[6] = blocks[7] =
          blocks[8] = blocks[9] = blocks[10] = blocks[11] =
          blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Sha256.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
  };

  Sha256.prototype.hash = function () {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6,
      h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;

    for (j = 16; j < 64; ++j) {
      // rightrotate
      t1 = blocks[j - 15];
      s0 = ((t1 >>> 7) | (t1 << 25)) ^ ((t1 >>> 18) | (t1 << 14)) ^ (t1 >>> 3);
      t1 = blocks[j - 2];
      s1 = ((t1 >>> 17) | (t1 << 15)) ^ ((t1 >>> 19) | (t1 << 13)) ^ (t1 >>> 10);
      blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }

    bc = b & c;
    for (j = 0; j < 64; j += 4) {
      if (this.first) {
        if (this.is224) {
          ab = 300032;
          t1 = blocks[0] - 1413257819;
          h = t1 - 150054599 << 0;
          d = t1 + 24177077 << 0;
        } else {
          ab = 704751109;
          t1 = blocks[0] - 210244248;
          h = t1 - 1521486534 << 0;
          d = t1 + 143694565 << 0;
        }
        this.first = false;
      } else {
        s0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        s1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        ab = a & b;
        maj = ab ^ (a & c) ^ bc;
        ch = (e & f) ^ (~e & g);
        t1 = h + s1 + ch + K[j] + blocks[j];
        t2 = s0 + maj;
        h = d + t1 << 0;
        d = t1 + t2 << 0;
      }
      s0 = ((d >>> 2) | (d << 30)) ^ ((d >>> 13) | (d << 19)) ^ ((d >>> 22) | (d << 10));
      s1 = ((h >>> 6) | (h << 26)) ^ ((h >>> 11) | (h << 21)) ^ ((h >>> 25) | (h << 7));
      da = d & a;
      maj = da ^ (d & b) ^ ab;
      ch = (h & e) ^ (~h & f);
      t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
      t2 = s0 + maj;
      g = c + t1 << 0;
      c = t1 + t2 << 0;
      s0 = ((c >>> 2) | (c << 30)) ^ ((c >>> 13) | (c << 19)) ^ ((c >>> 22) | (c << 10));
      s1 = ((g >>> 6) | (g << 26)) ^ ((g >>> 11) | (g << 21)) ^ ((g >>> 25) | (g << 7));
      cd = c & d;
      maj = cd ^ (c & a) ^ da;
      ch = (g & h) ^ (~g & e);
      t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
      t2 = s0 + maj;
      f = b + t1 << 0;
      b = t1 + t2 << 0;
      s0 = ((b >>> 2) | (b << 30)) ^ ((b >>> 13) | (b << 19)) ^ ((b >>> 22) | (b << 10));
      s1 = ((f >>> 6) | (f << 26)) ^ ((f >>> 11) | (f << 21)) ^ ((f >>> 25) | (f << 7));
      bc = b & c;
      maj = bc ^ (b & d) ^ cd;
      ch = (f & g) ^ (~f & h);
      t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
      t2 = s0 + maj;
      e = a + t1 << 0;
      a = t1 + t2 << 0;
    }

    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
  };

  Sha256.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var hex = HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
      HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F] +
      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h4 >> 28) & 0x0F] + HEX_CHARS[(h4 >> 24) & 0x0F] +
      HEX_CHARS[(h4 >> 20) & 0x0F] + HEX_CHARS[(h4 >> 16) & 0x0F] +
      HEX_CHARS[(h4 >> 12) & 0x0F] + HEX_CHARS[(h4 >> 8) & 0x0F] +
      HEX_CHARS[(h4 >> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F] +
      HEX_CHARS[(h5 >> 28) & 0x0F] + HEX_CHARS[(h5 >> 24) & 0x0F] +
      HEX_CHARS[(h5 >> 20) & 0x0F] + HEX_CHARS[(h5 >> 16) & 0x0F] +
      HEX_CHARS[(h5 >> 12) & 0x0F] + HEX_CHARS[(h5 >> 8) & 0x0F] +
      HEX_CHARS[(h5 >> 4) & 0x0F] + HEX_CHARS[h5 & 0x0F] +
      HEX_CHARS[(h6 >> 28) & 0x0F] + HEX_CHARS[(h6 >> 24) & 0x0F] +
      HEX_CHARS[(h6 >> 20) & 0x0F] + HEX_CHARS[(h6 >> 16) & 0x0F] +
      HEX_CHARS[(h6 >> 12) & 0x0F] + HEX_CHARS[(h6 >> 8) & 0x0F] +
      HEX_CHARS[(h6 >> 4) & 0x0F] + HEX_CHARS[h6 & 0x0F];
    if (!this.is224) {
      hex += HEX_CHARS[(h7 >> 28) & 0x0F] + HEX_CHARS[(h7 >> 24) & 0x0F] +
        HEX_CHARS[(h7 >> 20) & 0x0F] + HEX_CHARS[(h7 >> 16) & 0x0F] +
        HEX_CHARS[(h7 >> 12) & 0x0F] + HEX_CHARS[(h7 >> 8) & 0x0F] +
        HEX_CHARS[(h7 >> 4) & 0x0F] + HEX_CHARS[h7 & 0x0F];
    }
    return hex;
  };

  Sha256.prototype.toString = Sha256.prototype.hex;

  Sha256.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var arr = [
      (h0 >> 24) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 8) & 0xFF, h0 & 0xFF,
      (h1 >> 24) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 8) & 0xFF, h1 & 0xFF,
      (h2 >> 24) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 8) & 0xFF, h2 & 0xFF,
      (h3 >> 24) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 8) & 0xFF, h3 & 0xFF,
      (h4 >> 24) & 0xFF, (h4 >> 16) & 0xFF, (h4 >> 8) & 0xFF, h4 & 0xFF,
      (h5 >> 24) & 0xFF, (h5 >> 16) & 0xFF, (h5 >> 8) & 0xFF, h5 & 0xFF,
      (h6 >> 24) & 0xFF, (h6 >> 16) & 0xFF, (h6 >> 8) & 0xFF, h6 & 0xFF
    ];
    if (!this.is224) {
      arr.push((h7 >> 24) & 0xFF, (h7 >> 16) & 0xFF, (h7 >> 8) & 0xFF, h7 & 0xFF);
    }
    return arr;
  };

  Sha256.prototype.array = Sha256.prototype.digest;

  Sha256.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) {
      dataView.setUint32(28, this.h7);
    }
    return buffer;
  };

  function HmacSha256(key, is224, sharedMemory) {
    var i, type = typeof key;
    if (type === 'string') {
      var bytes = [], length = key.length, index = 0, code;
      for (i = 0; i < length; ++i) {
        code = key.charCodeAt(i);
        if (code < 0x80) {
          bytes[index++] = code;
        } else if (code < 0x800) {
          bytes[index++] = (0xc0 | (code >> 6));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes[index++] = (0xe0 | (code >> 12));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (key.charCodeAt(++i) & 0x3ff));
          bytes[index++] = (0xf0 | (code >> 18));
          bytes[index++] = (0x80 | ((code >> 12) & 0x3f));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        }
      }
      key = bytes;
    } else {
      if (type === 'object') {
        if (key === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
          key = new Uint8Array(key);
        } else if (!Array.isArray(key)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
    }

    if (key.length > 64) {
      key = (new Sha256(is224, true)).update(key).array();
    }

    var oKeyPad = [], iKeyPad = [];
    for (i = 0; i < 64; ++i) {
      var b = key[i] || 0;
      oKeyPad[i] = 0x5c ^ b;
      iKeyPad[i] = 0x36 ^ b;
    }

    Sha256.call(this, is224, sharedMemory);

    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
  }
  HmacSha256.prototype = new Sha256();

  HmacSha256.prototype.finalize = function () {
    Sha256.prototype.finalize.call(this);
    if (this.inner) {
      this.inner = false;
      var innerHash = this.array();
      Sha256.call(this, this.is224, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(innerHash);
      Sha256.prototype.finalize.call(this);
    }
  };

  var exports = createMethod();
  exports.sha256 = exports;
  exports.sha224 = createMethod(true);
  exports.sha256.hmac = createHmacMethod();
  exports.sha224.hmac = createHmacMethod(true);

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha256 = exports.sha256;
    root.sha224 = exports.sha224;
  }
})();
}(sha256$1));

var sha256 = sha256$1.exports;

/*
 * Copyright 2016 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

if (typeof Promise === 'undefined') {
    throw Error('Keycloak requires an environment that supports Promises. Make sure that you include the appropriate polyfill.');
}

var loggedPromiseDeprecation = false;

function logPromiseDeprecation() {
    if (!loggedPromiseDeprecation) {
        loggedPromiseDeprecation = true;
        console.warn('[KEYCLOAK] Usage of legacy style promise methods such as `.error()` and `.success()` has been deprecated and support will be removed in future versions. Use standard style promise methods such as `.then() and `.catch()` instead.');
    }
}

function Keycloak (config) {
    if (!(this instanceof Keycloak)) {
        return new Keycloak(config);
    }

    var kc = this;
    var adapter;
    var refreshQueue = [];
    var callbackStorage;

    var loginIframe = {
        enable: true,
        callbackList: [],
        interval: 5
    };

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
        if ((scripts[i].src.indexOf('keycloak.js') !== -1 || scripts[i].src.indexOf('keycloak.min.js') !== -1) && scripts[i].src.indexOf('version=') !== -1) {
            kc.iframeVersion = scripts[i].src.substring(scripts[i].src.indexOf('version=') + 8).split('&')[0];
        }
    }

    var useNonce = true;
    var logInfo = createLogger(console.info);
    var logWarn = createLogger(console.warn);

    kc.init = function (initOptions) {
        kc.authenticated = false;

        callbackStorage = createCallbackStorage();
        var adapters = ['default', 'cordova', 'cordova-native'];

        if (initOptions && adapters.indexOf(initOptions.adapter) > -1) {
            adapter = loadAdapter(initOptions.adapter);
        } else if (initOptions && typeof initOptions.adapter === "object") {
            adapter = initOptions.adapter;
        } else {
            if (window.Cordova || window.cordova) {
                adapter = loadAdapter('cordova');
            } else {
                adapter = loadAdapter();
            }
        }

        if (initOptions) {
            if (typeof initOptions.useNonce !== 'undefined') {
                useNonce = initOptions.useNonce;
            }

            if (typeof initOptions.checkLoginIframe !== 'undefined') {
                loginIframe.enable = initOptions.checkLoginIframe;
            }

            if (initOptions.checkLoginIframeInterval) {
                loginIframe.interval = initOptions.checkLoginIframeInterval;
            }

            if (initOptions.onLoad === 'login-required') {
                kc.loginRequired = true;
            }

            if (initOptions.responseMode) {
                if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') {
                    kc.responseMode = initOptions.responseMode;
                } else {
                    throw 'Invalid value for responseMode';
                }
            }

            if (initOptions.flow) {
                switch (initOptions.flow) {
                    case 'standard':
                        kc.responseType = 'code';
                        break;
                    case 'implicit':
                        kc.responseType = 'id_token token';
                        break;
                    case 'hybrid':
                        kc.responseType = 'code id_token token';
                        break;
                    default:
                        throw 'Invalid value for flow';
                }
                kc.flow = initOptions.flow;
            }

            if (initOptions.timeSkew != null) {
                kc.timeSkew = initOptions.timeSkew;
            }

            if(initOptions.redirectUri) {
                kc.redirectUri = initOptions.redirectUri;
            }

            if (initOptions.silentCheckSsoRedirectUri) {
                kc.silentCheckSsoRedirectUri = initOptions.silentCheckSsoRedirectUri;
            }

            if (typeof initOptions.silentCheckSsoFallback === 'boolean') {
                kc.silentCheckSsoFallback = initOptions.silentCheckSsoFallback;
            } else {
                kc.silentCheckSsoFallback = true;
            }

            if (initOptions.pkceMethod) {
                if (initOptions.pkceMethod !== "S256") {
                    throw 'Invalid value for pkceMethod';
                }
                kc.pkceMethod = initOptions.pkceMethod;
            }

            if (typeof initOptions.enableLogging === 'boolean') {
                kc.enableLogging = initOptions.enableLogging;
            } else {
                kc.enableLogging = false;
            }

            if (typeof initOptions.scope === 'string') {
                kc.scope = initOptions.scope;
            }

            if (typeof initOptions.messageReceiveTimeout === 'number' && initOptions.messageReceiveTimeout > 0) {
                kc.messageReceiveTimeout = initOptions.messageReceiveTimeout;
            } else {
                kc.messageReceiveTimeout = 10000;
            }
        }

        if (!kc.responseMode) {
            kc.responseMode = 'fragment';
        }
        if (!kc.responseType) {
            kc.responseType = 'code';
            kc.flow = 'standard';
        }

        var promise = createPromise();

        var initPromise = createPromise();
        initPromise.promise.then(function() {
            kc.onReady && kc.onReady(kc.authenticated);
            promise.setSuccess(kc.authenticated);
        }).catch(function(error) {
            promise.setError(error);
        });

        var configPromise = loadConfig();

        function onLoad() {
            var doLogin = function(prompt) {
                if (!prompt) {
                    options.prompt = 'none';
                }

                kc.login(options).then(function () {
                    initPromise.setSuccess();
                }).catch(function (error) {
                    initPromise.setError(error);
                });
            };

            var checkSsoSilently = function() {
                var ifrm = document.createElement("iframe");
                var src = kc.createLoginUrl({prompt: 'none', redirectUri: kc.silentCheckSsoRedirectUri});
                ifrm.setAttribute("src", src);
                ifrm.setAttribute("title", "keycloak-silent-check-sso");
                ifrm.style.display = "none";
                document.body.appendChild(ifrm);

                var messageCallback = function(event) {
                    if (event.origin !== window.location.origin || ifrm.contentWindow !== event.source) {
                        return;
                    }

                    var oauth = parseCallback(event.data);
                    processCallback(oauth, initPromise);

                    document.body.removeChild(ifrm);
                    window.removeEventListener("message", messageCallback);
                };

                window.addEventListener("message", messageCallback);
            };

            var options = {};
            switch (initOptions.onLoad) {
                case 'check-sso':
                    if (loginIframe.enable) {
                        setupCheckLoginIframe().then(function() {
                            checkLoginIframe().then(function (unchanged) {
                                if (!unchanged) {
                                    kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                                } else {
                                    initPromise.setSuccess();
                                }
                            }).catch(function (error) {
                                initPromise.setError(error);
                            });
                        });
                    } else {
                        kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                    }
                    break;
                case 'login-required':
                    doLogin(true);
                    break;
                default:
                    throw 'Invalid value for onLoad';
            }
        }

        function processInit() {
            var callback = parseCallback(window.location.href);

            if (callback) {
                window.history.replaceState(window.history.state, null, callback.newUrl);
            }

            if (callback && callback.valid) {
                return setupCheckLoginIframe().then(function() {
                    processCallback(callback, initPromise);
                }).catch(function (error) {
                    initPromise.setError(error);
                });
            } else if (initOptions) {
                if (initOptions.token && initOptions.refreshToken) {
                    setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);

                    if (loginIframe.enable) {
                        setupCheckLoginIframe().then(function() {
                            checkLoginIframe().then(function (unchanged) {
                                if (unchanged) {
                                    kc.onAuthSuccess && kc.onAuthSuccess();
                                    initPromise.setSuccess();
                                    scheduleCheckIframe();
                                } else {
                                    initPromise.setSuccess();
                                }
                            }).catch(function (error) {
                                initPromise.setError(error);
                            });
                        });
                    } else {
                        kc.updateToken(-1).then(function() {
                            kc.onAuthSuccess && kc.onAuthSuccess();
                            initPromise.setSuccess();
                        }).catch(function(error) {
                            kc.onAuthError && kc.onAuthError();
                            if (initOptions.onLoad) {
                                onLoad();
                            } else {
                                initPromise.setError(error);
                            }
                        });
                    }
                } else if (initOptions.onLoad) {
                    onLoad();
                } else {
                    initPromise.setSuccess();
                }
            } else {
                initPromise.setSuccess();
            }
        }

        function domReady() {
            var promise = createPromise();

            var checkReadyState = function () {
                if (document.readyState === 'interactive' || document.readyState === 'complete') {
                    document.removeEventListener('readystatechange', checkReadyState);
                    promise.setSuccess();
                }
            };
            document.addEventListener('readystatechange', checkReadyState);

            checkReadyState(); // just in case the event was already fired and we missed it (in case the init is done later than at the load time, i.e. it's done from code)

            return promise.promise;
        }

        configPromise.then(function () {
            domReady()
                .then(check3pCookiesSupported)
                .then(processInit)
                .catch(function (error) {
                    promise.setError(error);
                });
        });
        configPromise.catch(function (error) {
            promise.setError(error);
        });

        return promise.promise;
    };

    kc.login = function (options) {
        return adapter.login(options);
    };

    function generateRandomData(len) {
        // use web crypto APIs if possible
        var array = null;
        var crypto = window.crypto || window.msCrypto;
        if (crypto && crypto.getRandomValues && window.Uint8Array) {
            array = new Uint8Array(len);
            crypto.getRandomValues(array);
            return array;
        }

        // fallback to Math random
        array = new Array(len);
        for (var j = 0; j < array.length; j++) {
            array[j] = Math.floor(256 * Math.random());
        }
        return array;
    }

    function generateCodeVerifier(len) {
        return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
    }

    function generateRandomString(len, alphabet){
        var randomData = generateRandomData(len);
        var chars = new Array(len);
        for (var i = 0; i < len; i++) {
            chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
        }
        return String.fromCharCode.apply(null, chars);
    }

    function generatePkceChallenge(pkceMethod, codeVerifier) {
        switch (pkceMethod) {
            // The use of the "plain" method is considered insecure and therefore not supported.
            case "S256":
                // hash codeVerifier, then encode as url-safe base64 without padding
                var hashBytes = new Uint8Array(sha256.arrayBuffer(codeVerifier));
                var encodedHash = base64Js.fromByteArray(hashBytes)
                    .replace(/\+/g, '-')
                    .replace(/\//g, '_')
                    .replace(/\=/g, '');
                return encodedHash;
            default:
                throw 'Invalid value for pkceMethod';
        }
    }

    function buildClaimsParameter(requestedAcr){
        var claims = {
            id_token: {
                acr: requestedAcr
            }
        };
        return JSON.stringify(claims);
    }

    kc.createLoginUrl = function(options) {
        var state = createUUID();
        var nonce = createUUID();

        var redirectUri = adapter.redirectUri(options);

        var callbackState = {
            state: state,
            nonce: nonce,
            redirectUri: encodeURIComponent(redirectUri)
        };

        if (options && options.prompt) {
            callbackState.prompt = options.prompt;
        }

        var baseUrl;
        if (options && options.action == 'register') {
            baseUrl = kc.endpoints.register();
        } else {
            baseUrl = kc.endpoints.authorize();
        }

        var scope = options && options.scope || kc.scope;
        if (!scope) {
            // if scope is not set, default to "openid"
            scope = "openid";
        } else if (scope.indexOf("openid") === -1) {
            // if openid scope is missing, prefix the given scopes with it
            scope = "openid " + scope;
        }

        var url = baseUrl
            + '?client_id=' + encodeURIComponent(kc.clientId)
            + '&redirect_uri=' + encodeURIComponent(redirectUri)
            + '&state=' + encodeURIComponent(state)
            + '&response_mode=' + encodeURIComponent(kc.responseMode)
            + '&response_type=' + encodeURIComponent(kc.responseType)
            + '&scope=' + encodeURIComponent(scope);
        if (useNonce) {
            url = url + '&nonce=' + encodeURIComponent(nonce);
        }

        if (options && options.prompt) {
            url += '&prompt=' + encodeURIComponent(options.prompt);
        }

        if (options && options.maxAge) {
            url += '&max_age=' + encodeURIComponent(options.maxAge);
        }

        if (options && options.loginHint) {
            url += '&login_hint=' + encodeURIComponent(options.loginHint);
        }

        if (options && options.idpHint) {
            url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
        }

        if (options && options.action && options.action != 'register') {
            url += '&kc_action=' + encodeURIComponent(options.action);
        }

        if (options && options.locale) {
            url += '&ui_locales=' + encodeURIComponent(options.locale);
        }

        if (options && options.acr) {
            var claimsParameter = buildClaimsParameter(options.acr);
            url += '&claims=' + encodeURIComponent(claimsParameter);
        }

        if (kc.pkceMethod) {
            var codeVerifier = generateCodeVerifier(96);
            callbackState.pkceCodeVerifier = codeVerifier;
            var pkceChallenge = generatePkceChallenge(kc.pkceMethod, codeVerifier);
            url += '&code_challenge=' + pkceChallenge;
            url += '&code_challenge_method=' + kc.pkceMethod;
        }

        callbackStorage.add(callbackState);

        return url;
    };

    kc.logout = function(options) {
        return adapter.logout(options);
    };

    kc.createLogoutUrl = function(options) {
        var url = kc.endpoints.logout()
            + '?post_logout_redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false))
            + '&id_token_hint=' + encodeURIComponent(kc.idToken);

        return url;
    };

    kc.register = function (options) {
        return adapter.register(options);
    };

    kc.createRegisterUrl = function(options) {
        if (!options) {
            options = {};
        }
        options.action = 'register';
        return kc.createLoginUrl(options);
    };

    kc.createAccountUrl = function(options) {
        var realm = getRealmUrl();
        var url = undefined;
        if (typeof realm !== 'undefined') {
            url = realm
            + '/account'
            + '?referrer=' + encodeURIComponent(kc.clientId)
            + '&referrer_uri=' + encodeURIComponent(adapter.redirectUri(options));
        }
        return url;
    };

    kc.accountManagement = function() {
        return adapter.accountManagement();
    };

    kc.hasRealmRole = function (role) {
        var access = kc.realmAccess;
        return !!access && access.roles.indexOf(role) >= 0;
    };

    kc.hasResourceRole = function(role, resource) {
        if (!kc.resourceAccess) {
            return false;
        }

        var access = kc.resourceAccess[resource || kc.clientId];
        return !!access && access.roles.indexOf(role) >= 0;
    };

    kc.loadUserProfile = function() {
        var url = getRealmUrl() + '/account';
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);

        var promise = createPromise();

        req.onreadystatechange = function () {
            if (req.readyState == 4) {
                if (req.status == 200) {
                    kc.profile = JSON.parse(req.responseText);
                    promise.setSuccess(kc.profile);
                } else {
                    promise.setError();
                }
            }
        };

        req.send();

        return promise.promise;
    };

    kc.loadUserInfo = function() {
        var url = kc.endpoints.userinfo();
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);

        var promise = createPromise();

        req.onreadystatechange = function () {
            if (req.readyState == 4) {
                if (req.status == 200) {
                    kc.userInfo = JSON.parse(req.responseText);
                    promise.setSuccess(kc.userInfo);
                } else {
                    promise.setError();
                }
            }
        };

        req.send();

        return promise.promise;
    };

    kc.isTokenExpired = function(minValidity) {
        if (!kc.tokenParsed || (!kc.refreshToken && kc.flow != 'implicit' )) {
            throw 'Not authenticated';
        }

        if (kc.timeSkew == null) {
            logInfo('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
            return true;
        }

        var expiresIn = kc.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + kc.timeSkew;
        if (minValidity) {
            if (isNaN(minValidity)) {
                throw 'Invalid minValidity';
            }
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    };

    kc.updateToken = function(minValidity) {
        var promise = createPromise();

        if (!kc.refreshToken) {
            promise.setError();
            return promise.promise;
        }

        minValidity = minValidity || 5;

        var exec = function() {
            var refreshToken = false;
            if (minValidity == -1) {
                refreshToken = true;
                logInfo('[KEYCLOAK] Refreshing token: forced refresh');
            } else if (!kc.tokenParsed || kc.isTokenExpired(minValidity)) {
                refreshToken = true;
                logInfo('[KEYCLOAK] Refreshing token: token expired');
            }

            if (!refreshToken) {
                promise.setSuccess(false);
            } else {
                var params = 'grant_type=refresh_token&' + 'refresh_token=' + kc.refreshToken;
                var url = kc.endpoints.token();

                refreshQueue.push(promise);

                if (refreshQueue.length == 1) {
                    var req = new XMLHttpRequest();
                    req.open('POST', url, true);
                    req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                    req.withCredentials = true;

                    params += '&client_id=' + encodeURIComponent(kc.clientId);

                    var timeLocal = new Date().getTime();

                    req.onreadystatechange = function () {
                        if (req.readyState == 4) {
                            if (req.status == 200) {
                                logInfo('[KEYCLOAK] Token refreshed');

                                timeLocal = (timeLocal + new Date().getTime()) / 2;

                                var tokenResponse = JSON.parse(req.responseText);

                                setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], timeLocal);

                                kc.onAuthRefreshSuccess && kc.onAuthRefreshSuccess();
                                for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                    p.setSuccess(true);
                                }
                            } else {
                                logWarn('[KEYCLOAK] Failed to refresh token');

                                if (req.status == 400) {
                                    kc.clearToken();
                                }

                                kc.onAuthRefreshError && kc.onAuthRefreshError();
                                for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                    p.setError(true);
                                }
                            }
                        }
                    };

                    req.send(params);
                }
            }
        };

        if (loginIframe.enable) {
            var iframePromise = checkLoginIframe();
            iframePromise.then(function() {
                exec();
            }).catch(function(error) {
                promise.setError(error);
            });
        } else {
            exec();
        }

        return promise.promise;
    };

    kc.clearToken = function() {
        if (kc.token) {
            setToken(null, null, null);
            kc.onAuthLogout && kc.onAuthLogout();
            if (kc.loginRequired) {
                kc.login();
            }
        }
    };

    function getRealmUrl() {
        if (typeof kc.authServerUrl !== 'undefined') {
            if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == '/') {
                return kc.authServerUrl + 'realms/' + encodeURIComponent(kc.realm);
            } else {
                return kc.authServerUrl + '/realms/' + encodeURIComponent(kc.realm);
            }
        } else {
            return undefined;
        }
    }

    function getOrigin() {
        if (!window.location.origin) {
            return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
        } else {
            return window.location.origin;
        }
    }

    function processCallback(oauth, promise) {
        var code = oauth.code;
        var error = oauth.error;
        var prompt = oauth.prompt;

        var timeLocal = new Date().getTime();

        if (oauth['kc_action_status']) {
            kc.onActionUpdate && kc.onActionUpdate(oauth['kc_action_status']);
        }

        if (error) {
            if (prompt != 'none') {
                var errorData = { error: error, error_description: oauth.error_description };
                kc.onAuthError && kc.onAuthError(errorData);
                promise && promise.setError(errorData);
            } else {
                promise && promise.setSuccess();
            }
            return;
        } else if ((kc.flow != 'standard') && (oauth.access_token || oauth.id_token)) {
            authSuccess(oauth.access_token, null, oauth.id_token, true);
        }

        if ((kc.flow != 'implicit') && code) {
            var params = 'code=' + code + '&grant_type=authorization_code';
            var url = kc.endpoints.token();

            var req = new XMLHttpRequest();
            req.open('POST', url, true);
            req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            params += '&client_id=' + encodeURIComponent(kc.clientId);
            params += '&redirect_uri=' + oauth.redirectUri;

            if (oauth.pkceCodeVerifier) {
                params += '&code_verifier=' + oauth.pkceCodeVerifier;
            }

            req.withCredentials = true;

            req.onreadystatechange = function() {
                if (req.readyState == 4) {
                    if (req.status == 200) {

                        var tokenResponse = JSON.parse(req.responseText);
                        authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], kc.flow === 'standard');
                        scheduleCheckIframe();
                    } else {
                        kc.onAuthError && kc.onAuthError();
                        promise && promise.setError();
                    }
                }
            };

            req.send(params);
        }

        function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
            timeLocal = (timeLocal + new Date().getTime()) / 2;

            setToken(accessToken, refreshToken, idToken, timeLocal);

            if (useNonce && ((kc.tokenParsed && kc.tokenParsed.nonce != oauth.storedNonce) ||
                (kc.refreshTokenParsed && kc.refreshTokenParsed.nonce != oauth.storedNonce) ||
                (kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce))) {

                logInfo('[KEYCLOAK] Invalid nonce, clearing token');
                kc.clearToken();
                promise && promise.setError();
            } else {
                if (fulfillPromise) {
                    kc.onAuthSuccess && kc.onAuthSuccess();
                    promise && promise.setSuccess();
                }
            }
        }

    }

    function loadConfig(url) {
        var promise = createPromise();
        var configUrl;

        if (!config) {
            configUrl = 'keycloak.json';
        } else if (typeof config === 'string') {
            configUrl = config;
        }

        function setupOidcEndoints(oidcConfiguration) {
            if (! oidcConfiguration) {
                kc.endpoints = {
                    authorize: function() {
                        return getRealmUrl() + '/protocol/openid-connect/auth';
                    },
                    token: function() {
                        return getRealmUrl() + '/protocol/openid-connect/token';
                    },
                    logout: function() {
                        return getRealmUrl() + '/protocol/openid-connect/logout';
                    },
                    checkSessionIframe: function() {
                        var src = getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
                        if (kc.iframeVersion) {
                            src = src + '?version=' + kc.iframeVersion;
                        }
                        return src;
                    },
                    thirdPartyCookiesIframe: function() {
                        var src = getRealmUrl() + '/protocol/openid-connect/3p-cookies/step1.html';
                        if (kc.iframeVersion) {
                            src = src + '?version=' + kc.iframeVersion;
                        }
                        return src;
                    },
                    register: function() {
                        return getRealmUrl() + '/protocol/openid-connect/registrations';
                    },
                    userinfo: function() {
                        return getRealmUrl() + '/protocol/openid-connect/userinfo';
                    }
                };
            } else {
                kc.endpoints = {
                    authorize: function() {
                        return oidcConfiguration.authorization_endpoint;
                    },
                    token: function() {
                        return oidcConfiguration.token_endpoint;
                    },
                    logout: function() {
                        if (!oidcConfiguration.end_session_endpoint) {
                            throw "Not supported by the OIDC server";
                        }
                        return oidcConfiguration.end_session_endpoint;
                    },
                    checkSessionIframe: function() {
                        if (!oidcConfiguration.check_session_iframe) {
                            throw "Not supported by the OIDC server";
                        }
                        return oidcConfiguration.check_session_iframe;
                    },
                    register: function() {
                        throw 'Redirection to "Register user" page not supported in standard OIDC mode';
                    },
                    userinfo: function() {
                        if (!oidcConfiguration.userinfo_endpoint) {
                            throw "Not supported by the OIDC server";
                        }
                        return oidcConfiguration.userinfo_endpoint;
                    }
                };
            }
        }

        if (configUrl) {
            var req = new XMLHttpRequest();
            req.open('GET', configUrl, true);
            req.setRequestHeader('Accept', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200 || fileLoaded(req)) {
                        var config = JSON.parse(req.responseText);

                        kc.authServerUrl = config['auth-server-url'];
                        kc.realm = config['realm'];
                        kc.clientId = config['resource'];
                        setupOidcEndoints(null);
                        promise.setSuccess();
                    } else {
                        promise.setError();
                    }
                }
            };

            req.send();
        } else {
            if (!config.clientId) {
                throw 'clientId missing';
            }

            kc.clientId = config.clientId;

            var oidcProvider = config['oidcProvider'];
            if (!oidcProvider) {
                if (!config['url']) {
                    var scripts = document.getElementsByTagName('script');
                    for (var i = 0; i < scripts.length; i++) {
                        if (scripts[i].src.match(/.*keycloak\.js/)) {
                            config.url = scripts[i].src.substr(0, scripts[i].src.indexOf('/js/keycloak.js'));
                            break;
                        }
                    }
                }
                if (!config.realm) {
                    throw 'realm missing';
                }

                kc.authServerUrl = config.url;
                kc.realm = config.realm;
                setupOidcEndoints(null);
                promise.setSuccess();
            } else {
                if (typeof oidcProvider === 'string') {
                    var oidcProviderConfigUrl;
                    if (oidcProvider.charAt(oidcProvider.length - 1) == '/') {
                        oidcProviderConfigUrl = oidcProvider + '.well-known/openid-configuration';
                    } else {
                        oidcProviderConfigUrl = oidcProvider + '/.well-known/openid-configuration';
                    }
                    var req = new XMLHttpRequest();
                    req.open('GET', oidcProviderConfigUrl, true);
                    req.setRequestHeader('Accept', 'application/json');

                    req.onreadystatechange = function () {
                        if (req.readyState == 4) {
                            if (req.status == 200 || fileLoaded(req)) {
                                var oidcProviderConfig = JSON.parse(req.responseText);
                                setupOidcEndoints(oidcProviderConfig);
                                promise.setSuccess();
                            } else {
                                promise.setError();
                            }
                        }
                    };

                    req.send();
                } else {
                    setupOidcEndoints(oidcProvider);
                    promise.setSuccess();
                }
            }
        }

        return promise.promise;
    }

    function fileLoaded(xhr) {
        return xhr.status == 0 && xhr.responseText && xhr.responseURL.startsWith('file:');
    }

    function setToken(token, refreshToken, idToken, timeLocal) {
        if (kc.tokenTimeoutHandle) {
            clearTimeout(kc.tokenTimeoutHandle);
            kc.tokenTimeoutHandle = null;
        }

        if (refreshToken) {
            kc.refreshToken = refreshToken;
            kc.refreshTokenParsed = decodeToken(refreshToken);
        } else {
            delete kc.refreshToken;
            delete kc.refreshTokenParsed;
        }

        if (idToken) {
            kc.idToken = idToken;
            kc.idTokenParsed = decodeToken(idToken);
        } else {
            delete kc.idToken;
            delete kc.idTokenParsed;
        }

        if (token) {
            kc.token = token;
            kc.tokenParsed = decodeToken(token);
            kc.sessionId = kc.tokenParsed.session_state;
            kc.authenticated = true;
            kc.subject = kc.tokenParsed.sub;
            kc.realmAccess = kc.tokenParsed.realm_access;
            kc.resourceAccess = kc.tokenParsed.resource_access;

            if (timeLocal) {
                kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
            }

            if (kc.timeSkew != null) {
                logInfo('[KEYCLOAK] Estimated time difference between browser and server is ' + kc.timeSkew + ' seconds');

                if (kc.onTokenExpired) {
                    var expiresIn = (kc.tokenParsed['exp'] - (new Date().getTime() / 1000) + kc.timeSkew) * 1000;
                    logInfo('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
                    if (expiresIn <= 0) {
                        kc.onTokenExpired();
                    } else {
                        kc.tokenTimeoutHandle = setTimeout(kc.onTokenExpired, expiresIn);
                    }
                }
            }
        } else {
            delete kc.token;
            delete kc.tokenParsed;
            delete kc.subject;
            delete kc.realmAccess;
            delete kc.resourceAccess;

            kc.authenticated = false;
        }
    }

    function decodeToken(str) {
        str = str.split('.')[1];

        str = str.replace(/-/g, '+');
        str = str.replace(/_/g, '/');
        switch (str.length % 4) {
            case 0:
                break;
            case 2:
                str += '==';
                break;
            case 3:
                str += '=';
                break;
            default:
                throw 'Invalid token';
        }

        str = decodeURIComponent(escape(atob(str)));

        str = JSON.parse(str);
        return str;
    }

    function createUUID() {
        var hexDigits = '0123456789abcdef';
        var s = generateRandomString(36, hexDigits).split("");
        s[14] = '4';
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = '-';
        var uuid = s.join('');
        return uuid;
    }

    function parseCallback(url) {
        var oauth = parseCallbackUrl(url);
        if (!oauth) {
            return;
        }

        var oauthState = callbackStorage.get(oauth.state);

        if (oauthState) {
            oauth.valid = true;
            oauth.redirectUri = oauthState.redirectUri;
            oauth.storedNonce = oauthState.nonce;
            oauth.prompt = oauthState.prompt;
            oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
        }

        return oauth;
    }

    function parseCallbackUrl(url) {
        var supportedParams;
        switch (kc.flow) {
            case 'standard':
                supportedParams = ['code', 'state', 'session_state', 'kc_action_status'];
                break;
            case 'implicit':
                supportedParams = ['access_token', 'token_type', 'id_token', 'state', 'session_state', 'expires_in', 'kc_action_status'];
                break;
            case 'hybrid':
                supportedParams = ['access_token', 'token_type', 'id_token', 'code', 'state', 'session_state', 'expires_in', 'kc_action_status'];
                break;
        }

        supportedParams.push('error');
        supportedParams.push('error_description');
        supportedParams.push('error_uri');

        var queryIndex = url.indexOf('?');
        var fragmentIndex = url.indexOf('#');

        var newUrl;
        var parsed;

        if (kc.responseMode === 'query' && queryIndex !== -1) {
            newUrl = url.substring(0, queryIndex);
            parsed = parseCallbackParams(url.substring(queryIndex + 1, fragmentIndex !== -1 ? fragmentIndex : url.length), supportedParams);
            if (parsed.paramsString !== '') {
                newUrl += '?' + parsed.paramsString;
            }
            if (fragmentIndex !== -1) {
                newUrl += url.substring(fragmentIndex);
            }
        } else if (kc.responseMode === 'fragment' && fragmentIndex !== -1) {
            newUrl = url.substring(0, fragmentIndex);
            parsed = parseCallbackParams(url.substring(fragmentIndex + 1), supportedParams);
            if (parsed.paramsString !== '') {
                newUrl += '#' + parsed.paramsString;
            }
        }

        if (parsed && parsed.oauthParams) {
            if (kc.flow === 'standard' || kc.flow === 'hybrid') {
                if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            } else if (kc.flow === 'implicit') {
                if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            }
        }
    }

    function parseCallbackParams(paramsString, supportedParams) {
        var p = paramsString.split('&');
        var result = {
            paramsString: '',
            oauthParams: {}
        };
        for (var i = 0; i < p.length; i++) {
            var split = p[i].indexOf("=");
            var key = p[i].slice(0, split);
            if (supportedParams.indexOf(key) !== -1) {
                result.oauthParams[key] = p[i].slice(split + 1);
            } else {
                if (result.paramsString !== '') {
                    result.paramsString += '&';
                }
                result.paramsString += p[i];
            }
        }
        return result;
    }

    function createPromise() {
        // Need to create a native Promise which also preserves the
        // interface of the custom promise type previously used by the API
        var p = {
            setSuccess: function(result) {
                p.resolve(result);
            },

            setError: function(result) {
                p.reject(result);
            }
        };
        p.promise = new Promise(function(resolve, reject) {
            p.resolve = resolve;
            p.reject = reject;
        });

        p.promise.success = function(callback) {
            logPromiseDeprecation();

            this.then(function handleSuccess(value) {
                callback(value);
            });

            return this;
        };

        p.promise.error = function(callback) {
            logPromiseDeprecation();

            this.catch(function handleError(error) {
                callback(error);
            });

            return this;
        };

        return p;
    }

    // Function to extend existing native Promise with timeout
    function applyTimeoutToPromise(promise, timeout, errorMessage) {
        var timeoutHandle = null;
        var timeoutPromise = new Promise(function (resolve, reject) {
            timeoutHandle = setTimeout(function () {
                reject({ "error": errorMessage || "Promise is not settled within timeout of " + timeout + "ms" });
            }, timeout);
        });

        return Promise.race([promise, timeoutPromise]).finally(function () {
            clearTimeout(timeoutHandle);
        });
    }

    function setupCheckLoginIframe() {
        var promise = createPromise();

        if (!loginIframe.enable) {
            promise.setSuccess();
            return promise.promise;
        }

        if (loginIframe.iframe) {
            promise.setSuccess();
            return promise.promise;
        }

        var iframe = document.createElement('iframe');
        loginIframe.iframe = iframe;

        iframe.onload = function() {
            var authUrl = kc.endpoints.authorize();
            if (authUrl.charAt(0) === '/') {
                loginIframe.iframeOrigin = getOrigin();
            } else {
                loginIframe.iframeOrigin = authUrl.substring(0, authUrl.indexOf('/', 8));
            }
            promise.setSuccess();
        };

        var src = kc.endpoints.checkSessionIframe();
        iframe.setAttribute('src', src );
        iframe.setAttribute('title', 'keycloak-session-iframe' );
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        var messageCallback = function(event) {
            if ((event.origin !== loginIframe.iframeOrigin) || (loginIframe.iframe.contentWindow !== event.source)) {
                return;
            }

            if (!(event.data == 'unchanged' || event.data == 'changed' || event.data == 'error')) {
                return;
            }


            if (event.data != 'unchanged') {
                kc.clearToken();
            }

            var callbacks = loginIframe.callbackList.splice(0, loginIframe.callbackList.length);

            for (var i = callbacks.length - 1; i >= 0; --i) {
                var promise = callbacks[i];
                if (event.data == 'error') {
                    promise.setError();
                } else {
                    promise.setSuccess(event.data == 'unchanged');
                }
            }
        };

        window.addEventListener('message', messageCallback, false);

        return promise.promise;
    }

    function scheduleCheckIframe() {
        if (loginIframe.enable) {
            if (kc.token) {
                setTimeout(function() {
                    checkLoginIframe().then(function(unchanged) {
                        if (unchanged) {
                            scheduleCheckIframe();
                        }
                    });
                }, loginIframe.interval * 1000);
            }
        }
    }

    function checkLoginIframe() {
        var promise = createPromise();

        if (loginIframe.iframe && loginIframe.iframeOrigin ) {
            var msg = kc.clientId + ' ' + (kc.sessionId ? kc.sessionId : '');
            loginIframe.callbackList.push(promise);
            var origin = loginIframe.iframeOrigin;
            if (loginIframe.callbackList.length == 1) {
                loginIframe.iframe.contentWindow.postMessage(msg, origin);
            }
        } else {
            promise.setSuccess();
        }

        return promise.promise;
    }

    function check3pCookiesSupported() {
        var promise = createPromise();

        if (loginIframe.enable || kc.silentCheckSsoRedirectUri) {
            var iframe = document.createElement('iframe');
            iframe.setAttribute('src', kc.endpoints.thirdPartyCookiesIframe());
            iframe.setAttribute('title', 'keycloak-3p-check-iframe' );
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            var messageCallback = function(event) {
                if (iframe.contentWindow !== event.source) {
                    return;
                }

                if (event.data !== "supported" && event.data !== "unsupported") {
                    return;
                } else if (event.data === "unsupported") {
                    loginIframe.enable = false;
                    if (kc.silentCheckSsoFallback) {
                        kc.silentCheckSsoRedirectUri = false;
                    }
                    logWarn("[KEYCLOAK] 3rd party cookies aren't supported by this browser. checkLoginIframe and " +
                        "silent check-sso are not available.");
                }

                document.body.removeChild(iframe);
                window.removeEventListener("message", messageCallback);
                promise.setSuccess();
            };

            window.addEventListener('message', messageCallback, false);
        } else {
            promise.setSuccess();
        }

        return applyTimeoutToPromise(promise.promise, kc.messageReceiveTimeout, "Timeout when waiting for 3rd party check iframe message.");
    }

    function loadAdapter(type) {
        if (!type || type == 'default') {
            return {
                login: function(options) {
                    window.location.replace(kc.createLoginUrl(options));
                    return createPromise().promise;
                },

                logout: function(options) {
                    window.location.replace(kc.createLogoutUrl(options));
                    return createPromise().promise;
                },

                register: function(options) {
                    window.location.replace(kc.createRegisterUrl(options));
                    return createPromise().promise;
                },

                accountManagement : function() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') {
                        window.location.href = accountUrl;
                    } else {
                        throw "Not supported by the OIDC server";
                    }
                    return createPromise().promise;
                },

                redirectUri: function(options, encodeHash) {

                    if (options && options.redirectUri) {
                        return options.redirectUri;
                    } else if (kc.redirectUri) {
                        return kc.redirectUri;
                    } else {
                        return location.href;
                    }
                }
            };
        }

        if (type == 'cordova') {
            loginIframe.enable = false;
            var cordovaOpenWindowWrapper = function(loginUrl, target, options) {
                if (window.cordova && window.cordova.InAppBrowser) {
                    // Use inappbrowser for IOS and Android if available
                    return window.cordova.InAppBrowser.open(loginUrl, target, options);
                } else {
                    return window.open(loginUrl, target, options);
                }
            };

            var shallowCloneCordovaOptions = function (userOptions) {
                if (userOptions && userOptions.cordovaOptions) {
                    return Object.keys(userOptions.cordovaOptions).reduce(function (options, optionName) {
                        options[optionName] = userOptions.cordovaOptions[optionName];
                        return options;
                    }, {});
                } else {
                    return {};
                }
            };

            var formatCordovaOptions = function (cordovaOptions) {
                return Object.keys(cordovaOptions).reduce(function (options, optionName) {
                    options.push(optionName+"="+cordovaOptions[optionName]);
                    return options;
                }, []).join(",");
            };

            var createCordovaOptions = function (userOptions) {
                var cordovaOptions = shallowCloneCordovaOptions(userOptions);
                cordovaOptions.location = 'no';
                if (userOptions && userOptions.prompt == 'none') {
                    cordovaOptions.hidden = 'yes';
                }
                return formatCordovaOptions(cordovaOptions);
            };

            return {
                login: function(options) {
                    var promise = createPromise();

                    var cordovaOptions = createCordovaOptions(options);
                    var loginUrl = kc.createLoginUrl(options);
                    var ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
                    var completed = false;

                    var closed = false;
                    var closeBrowser = function() {
                        closed = true;
                        ref.close();
                    };

                    ref.addEventListener('loadstart', function(event) {
                        if (event.url.indexOf('http://localhost') == 0) {
                            var callback = parseCallback(event.url);
                            processCallback(callback, promise);
                            closeBrowser();
                            completed = true;
                        }
                    });

                    ref.addEventListener('loaderror', function(event) {
                        if (!completed) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                var callback = parseCallback(event.url);
                                processCallback(callback, promise);
                                closeBrowser();
                                completed = true;
                            } else {
                                promise.setError();
                                closeBrowser();
                            }
                        }
                    });

                    ref.addEventListener('exit', function(event) {
                        if (!closed) {
                            promise.setError({
                                reason: "closed_by_user"
                            });
                        }
                    });

                    return promise.promise;
                },

                logout: function(options) {
                    var promise = createPromise();

                    var logoutUrl = kc.createLogoutUrl(options);
                    var ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes,clearcache=yes');

                    var error;

                    ref.addEventListener('loadstart', function(event) {
                        if (event.url.indexOf('http://localhost') == 0) {
                            ref.close();
                        }
                    });

                    ref.addEventListener('loaderror', function(event) {
                        if (event.url.indexOf('http://localhost') == 0) {
                            ref.close();
                        } else {
                            error = true;
                            ref.close();
                        }
                    });

                    ref.addEventListener('exit', function(event) {
                        if (error) {
                            promise.setError();
                        } else {
                            kc.clearToken();
                            promise.setSuccess();
                        }
                    });

                    return promise.promise;
                },

                register : function(options) {
                    var promise = createPromise();
                    var registerUrl = kc.createRegisterUrl();
                    var cordovaOptions = createCordovaOptions(options);
                    var ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);
                    ref.addEventListener('loadstart', function(event) {
                        if (event.url.indexOf('http://localhost') == 0) {
                            ref.close();
                            var oauth = parseCallback(event.url);
                            processCallback(oauth, promise);
                        }
                    });
                    return promise.promise;
                },

                accountManagement : function() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') {
                        var ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                ref.close();
                            }
                        });
                    } else {
                        throw "Not supported by the OIDC server";
                    }
                },

                redirectUri: function(options) {
                    return 'http://localhost';
                }
            }
        }

        if (type == 'cordova-native') {
            loginIframe.enable = false;

            return {
                login: function(options) {
                    var promise = createPromise();
                    var loginUrl = kc.createLoginUrl(options);

                    universalLinks.subscribe('keycloak', function(event) {
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        var oauth = parseCallback(event.url);
                        processCallback(oauth, promise);
                    });

                    window.cordova.plugins.browsertab.openUrl(loginUrl);
                    return promise.promise;
                },

                logout: function(options) {
                    var promise = createPromise();
                    var logoutUrl = kc.createLogoutUrl(options);

                    universalLinks.subscribe('keycloak', function(event) {
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        kc.clearToken();
                        promise.setSuccess();
                    });

                    window.cordova.plugins.browsertab.openUrl(logoutUrl);
                    return promise.promise;
                },

                register : function(options) {
                    var promise = createPromise();
                    var registerUrl = kc.createRegisterUrl(options);
                    universalLinks.subscribe('keycloak' , function(event) {
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        var oauth = parseCallback(event.url);
                        processCallback(oauth, promise);
                    });
                    window.cordova.plugins.browsertab.openUrl(registerUrl);
                    return promise.promise;

                },

                accountManagement : function() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') {
                        window.cordova.plugins.browsertab.openUrl(accountUrl);
                    } else {
                        throw "Not supported by the OIDC server";
                    }
                },

                redirectUri: function(options) {
                    if (options && options.redirectUri) {
                        return options.redirectUri;
                    } else if (kc.redirectUri) {
                        return kc.redirectUri;
                    } else {
                        return "http://localhost";
                    }
                }
            }
        }

        throw 'invalid adapter type: ' + type;
    }

    var LocalStorage = function() {
        if (!(this instanceof LocalStorage)) {
            return new LocalStorage();
        }

        localStorage.setItem('kc-test', 'test');
        localStorage.removeItem('kc-test');

        var cs = this;

        function clearExpired() {
            var time = new Date().getTime();
            for (var i = 0; i < localStorage.length; i++)  {
                var key = localStorage.key(i);
                if (key && key.indexOf('kc-callback-') == 0) {
                    var value = localStorage.getItem(key);
                    if (value) {
                        try {
                            var expires = JSON.parse(value).expires;
                            if (!expires || expires < time) {
                                localStorage.removeItem(key);
                            }
                        } catch (err) {
                            localStorage.removeItem(key);
                        }
                    }
                }
            }
        }

        cs.get = function(state) {
            if (!state) {
                return;
            }

            var key = 'kc-callback-' + state;
            var value = localStorage.getItem(key);
            if (value) {
                localStorage.removeItem(key);
                value = JSON.parse(value);
            }

            clearExpired();
            return value;
        };

        cs.add = function(state) {
            clearExpired();

            var key = 'kc-callback-' + state.state;
            state.expires = new Date().getTime() + (60 * 60 * 1000);
            localStorage.setItem(key, JSON.stringify(state));
        };
    };

    var CookieStorage = function() {
        if (!(this instanceof CookieStorage)) {
            return new CookieStorage();
        }

        var cs = this;

        cs.get = function(state) {
            if (!state) {
                return;
            }

            var value = getCookie('kc-callback-' + state);
            setCookie('kc-callback-' + state, '', cookieExpiration(-100));
            if (value) {
                return JSON.parse(value);
            }
        };

        cs.add = function(state) {
            setCookie('kc-callback-' + state.state, JSON.stringify(state), cookieExpiration(60));
        };

        cs.removeItem = function(key) {
            setCookie(key, '', cookieExpiration(-100));
        };

        var cookieExpiration = function (minutes) {
            var exp = new Date();
            exp.setTime(exp.getTime() + (minutes*60*1000));
            return exp;
        };

        var getCookie = function (key) {
            var name = key + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        };

        var setCookie = function (key, value, expirationDate) {
            var cookie = key + '=' + value + '; '
                + 'expires=' + expirationDate.toUTCString() + '; ';
            document.cookie = cookie;
        };
    };

    function createCallbackStorage() {
        try {
            return new LocalStorage();
        } catch (err) {
        }

        return new CookieStorage();
    }

    function createLogger(fn) {
        return function() {
            if (kc.enableLogging) {
                fn.apply(console, Array.prototype.slice.call(arguments));
            }
        };
    }
}

function throwIfMissing(value) {
  if (value) {
    return value;
  } else {
    throw new Error('Missing env variables for authentication. Make sure to specify "REACT_APP_AUTH_PROVIDER_URL", "REACT_APP_AUTH_REALM" und "REACT_APP_AUTH_CLIENT_ID"');
  }
}

function init() {
  return Keycloak({
    url: throwIfMissing(process.env.REACT_APP_AUTH_PROVIDER_URL),
    realm: throwIfMissing(process.env.REACT_APP_AUTH_REALM),
    clientId: throwIfMissing(process.env.REACT_APP_AUTH_CLIENT_ID)
  });
}

var AuthenticationProvider = function AuthenticationProvider(_ref) {
  var loadingComponent = _ref.loadingComponent,
      redirectUri = _ref.redirectUri,
      initConfig = _ref.initConfig,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(reactKeycloakProvider, {
    keycloak: init(),
    LoadingComponent: loadingComponent,
    initConfig: initConfig || {
      checkLoginIframe: false,
      redirectUri: redirectUri
    }
  }, children);
};

var propTypes = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$1.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var o = propTypes.exports;

function r(e){return (r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}function u(e){return (u=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function c(e,t){return (c=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function s(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function a(e,t){return !t||"object"!=typeof t&&"function"!=typeof t?s(e):t}function l(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return !1}}();return function(){var n,o=u(e);if(t){var r=u(this).constructor;n=Reflect.construct(o,arguments,r);}else n=o.apply(this,arguments);return a(this,n)}}var d="object"===("undefined"==typeof window||"undefined"==typeof window?"undefined":r(window)),f=d?document:{},v=["mousemove","keydown","wheel","DOMMouseScroll","mouseWheel","mousedown","touchstart","touchmove","MSPointerDown","MSPointerMove","visibilitychange"];function p(e,t){var n;return function(){for(var o=arguments.length,r=new Array(o),i=0;i<o;i++)r[i]=arguments[i];n&&clearTimeout(n),n=setTimeout((function(){e.apply(void 0,r),n=null;}),t);}}function h(e,t){var n=0;return function(){var o=(new Date).getTime();if(!(o-n<t))return n=o,e.apply(void 0,arguments)}}var m=function(t){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&c(e,t);}(a,Component);var n,o,u=l(a);function a(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),(t=u.call(this,e)).state={idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null,pageX:null,pageY:null},t.tId=null,t.eventsBound=!1,e.debounce>0&&e.throttle>0)throw new Error("onAction can either be throttled or debounced (not both)");return e.debounce>0?t._onAction=p(e.onAction,e.debounce):e.throttle>0?t._onAction=h(e.onAction,e.throttle):e.onAction?t._onAction=e.onAction:t._onAction=function(){},e.eventsThrottle>0?t._handleEvent=h(t._handleEvent.bind(s(t)),e.eventsThrottle):t._handleEvent=t._handleEvent.bind(s(t)),e.startOnMount||(t.state.idle=!0),t._toggleIdleState=t._toggleIdleState.bind(s(t)),t.reset=t.reset.bind(s(t)),t.pause=t.pause.bind(s(t)),t.resume=t.resume.bind(s(t)),t.getRemainingTime=t.getRemainingTime.bind(s(t)),t.getElapsedTime=t.getElapsedTime.bind(s(t)),t.getLastActiveTime=t.getLastActiveTime.bind(s(t)),t.isIdle=t.isIdle.bind(s(t)),t}return n=a,(o=[{key:"componentDidMount",value:function(){this._bindEvents(),this.props.startOnMount&&this.reset();}},{key:"componentDidUpdate",value:function(e){e.debounce!==this.props.debounce&&(this._onAction=p(this._onAction,this.props.debounce)),e.throttle!==this.props.throttle&&(this._onAction=h(this._onAction,this.props.throttle)),e.eventsThrottle!==this.props.eventsThrottle&&(this._handleEvent=h(this._handleEvent,this.props.eventsThrottle));}},{key:"componentWillUnmount",value:function(){clearTimeout(this.tId),this._unbindEvents(!0);}},{key:"render",value:function(){return this.props.children||null}},{key:"_bindEvents",value:function(){var e=this;if(d){var t=this.props,n=t.element,o=t.events,r=t.passive,i=t.capture;this.eventsBound||(o.forEach((function(t){n.addEventListener(t,e._handleEvent,{capture:i,passive:r});})),this.eventsBound=!0);}}},{key:"_unbindEvents",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(d){var n=this.props,o=n.element,r=n.events,i=n.passive,u=n.capture;(this.eventsBound||t)&&(r.forEach((function(t){o.removeEventListener(t,e._handleEvent,{capture:u,passive:i});})),this.eventsBound=!1);}}},{key:"_toggleIdleState",value:function(e){var t=this;this.setState((function(e){return {idle:!e.idle}}),(function(){var n=t.props,o=n.onActive,r=n.onIdle,i=n.stopOnIdle;t.state.idle?(i&&(clearTimeout(t.tId),t.tId=null,t._unbindEvents()),r(e)):i||(t._bindEvents(),o(e));}));}},{key:"_handleEvent",value:function(e){var t=this.state,n=t.remaining,o=t.pageX,r=t.pageY,i=t.idle,u=this.props,c=u.timeout,s=u.stopOnIdle;if(this._onAction(e),!n){if("mousemove"===e.type){if(e.pageX===o&&e.pageY===r)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(this.getElapsedTime()<200)return}clearTimeout(this.tId),this.tId=null;var a=+new Date-this.getLastActiveTime();(i&&!s||!i&&a>c)&&this._toggleIdleState(e),this.setState({lastActive:+new Date,pageX:e.pageX,pageY:e.pageY}),i&&s||(this.tId=setTimeout(this._toggleIdleState,c));}}},{key:"reset",value:function(){clearTimeout(this.tId),this.tId=null,this._bindEvents(),this.setState({idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null});var e=this.props.timeout;this.tId=setTimeout(this._toggleIdleState,e);}},{key:"pause",value:function(){null===this.state.remaining&&(this._unbindEvents(),clearTimeout(this.tId),this.tId=null,this.setState({remaining:this.getRemainingTime()}));}},{key:"resume",value:function(){var e=this.state,t=e.remaining,n=e.idle;null!==t&&(this._bindEvents(),n||(this.tId=setTimeout(this._toggleIdleState,t),this.setState({remaining:null,lastActive:+new Date})));}},{key:"getRemainingTime",value:function(){var e=this.state,t=e.remaining,n=e.lastActive,o=this.props.timeout;if(null!==t)return t<0?0:t;var r=o-(+new Date-n);return r<0?0:r}},{key:"getElapsedTime",value:function(){var e=this.state.oldDate;return +new Date-e}},{key:"getLastActiveTime",value:function(){return this.state.lastActive}},{key:"isIdle",value:function(){return this.state.idle}}])&&i(n.prototype,o),a}();function b(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=e.timeout,r=void 0===o?12e5:o,i=e.element,u=void 0===i?f:i,c=e.events,s=void 0===c?v:c,a=e.onIdle,l=void 0===a?function(){}:a,m=e.onActive,b=void 0===m?function(){}:m,g=e.onAction,y=void 0===g?function(){}:g,T=e.debounce,w=void 0===T?0:T,_=e.throttle,A=void 0===_?0:_,I=e.eventsThrottle,E=void 0===I?200:I,O=e.startOnMount,D=void 0===O||O,S=e.stopOnIdle,k=void 0!==S&&S,M=e.capture,R=void 0===M||M,j=e.passive,P=void 0===j||j,L=useRef(!1),X=useRef(!0),Y=useRef(+new Date),B=useRef(+new Date),x=useRef(null),U=useRef(null),W=useRef(null),C=useRef(null),q=useRef(l),z=useRef(b),F=useRef(y),G=function(e){var t=!X.current;X.current=t,t?(k&&(clearTimeout(C.current),C.current=null,K()),q.current(e)):k||(J(),z.current(e));},H=function(e){if(F.current(e),!x.current){if("mousemove"===e.type){if(e.pageX===U&&e.pageY===W)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(Q()<200)return}clearTimeout(C.current),C.current=null;var t=+new Date-V();(X.current&&!k||!X.current&&t>r)&&G(e),B.current=+new Date,U.current=e.pageX,W.current=e.pageY,X.current&&k||(C.current=setTimeout(G,r));}},J=function(){d&&(L.current||(s.forEach((function(e){u.addEventListener(e,H,{capture:R,passive:P});})),L.current=!0));},K=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];d&&(L.current||e)&&(s.forEach((function(e){u.removeEventListener(e,H,{capture:R,passive:P});})),L.current=!1);},N=function(){if(null!==x.current)return x.current<0?0:x.current;var e=r-(+new Date-B.current);return e<0?0:e},Q=function(){return +new Date-Y.current},V=function(){return B.current},Z=function(){return X.current},$=function(){clearTimeout(C.current),C.current=null,J(),X.current=!1,Y.current=+new Date,B.current=+new Date,x.current=null,C.current=setTimeout(G,r);},ee=function(){null===x.current&&(K(),clearTimeout(C.current),C.current=null,x.current=N());},te=function(){null!==x.current&&(J(),X.current||(C.current=setTimeout(G,x.current),x.current=null,B.current=+new Date));};return useEffect((function(){if(w>0&&A>0)throw new Error("onAction can either be throttled or debounced (not both)");return E>0&&(H=h(H,E)),J(),D&&$(),function(){clearTimeout(C.current),K(!0);}}),[]),useEffect((function(){q.current=l;}),[l]),useEffect((function(){z.current=b;}),[b]),useEffect((function(){F.current=w>0?p(y,w):A>0?h(y,A):y;}),[y]),{isIdle:Z,pause:ee,reset:$,resume:te,getLastActiveTime:V,getElapsedTime:Q,getRemainingTime:N}}m.propTypes={timeout:o.number,events:o.arrayOf(o.string),onIdle:o.func,onActive:o.func,onAction:o.func,debounce:o.number,throttle:o.number,eventsThrottle:o.number,element:o.oneOfType([o.object,o.element]),startOnMount:o.bool,stopOnIdle:o.bool,passive:o.bool,capture:o.bool},m.defaultProps={timeout:12e5,element:f,events:v,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0},b.propTypes={timeout:o.number,events:o.arrayOf(o.string),onIdle:o.func,onActive:o.func,onAction:o.func,debounce:o.number,throttle:o.number,eventsThrottle:o.number,element:o.oneOfType([o.object,o.element]),startOnMount:o.bool,stopOnIdle:o.bool,passive:o.bool,capture:o.bool},b.defaultProps={timeout:12e5,element:f,events:v,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0};

function useAuthentication() {
  var _useKeycloak = useKeycloak(),
      _useKeycloak2 = _slicedToArray(_useKeycloak, 1),
      keycloak = _useKeycloak2[0];

  var redirectWithHistoryEntry = function redirectWithHistoryEntry(url) {
    window.location.assign(url);
    return Promise.resolve();
  };

  if ((keycloak === null || keycloak === void 0 ? void 0 : keycloak.authenticated) && (keycloak === null || keycloak === void 0 ? void 0 : keycloak.token) && (keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed)) {
    return {
      isAuthenticated: keycloak.authenticated,
      token: keycloak.token,
      tokenParsed: keycloak.tokenParsed,
      idToken: keycloak.idToken,
      idTokenParsed: keycloak.idTokenParsed,
      login: function login(options) {
        return redirectWithHistoryEntry(keycloak.createLoginUrl(options));
      },
      logout: function logout(options) {
        return redirectWithHistoryEntry(keycloak.createLogoutUrl(options));
      }
    };
  } else {
    return {
      isAuthenticated: false,
      login: function login(options) {
        if (!keycloak) return Promise.resolve();
        return redirectWithHistoryEntry(keycloak.createLoginUrl(options));
      },
      logout: function logout(options) {
        if (!keycloak) return Promise.resolve();
        return redirectWithHistoryEntry(keycloak.createLogoutUrl(options));
      }
    };
  }
}

var AutoLogout = function AutoLogout(_ref) {
  var redirectUri = _ref.redirectUri,
      idleTimeInMinutes = _ref.idleTimeInMinutes,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 1000 : _ref$debounce,
      children = _ref.children;
  var timeout = 1000 * 60 * idleTimeInMinutes;

  var _useAuthentication = useAuthentication(),
      isAuthenticated = _useAuthentication.isAuthenticated,
      logout = _useAuthentication.logout;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAutoLogoutPolling = _useState2[0],
      setAutoLogoutPolling = _useState2[1];

  useEffect(function () {
    var interval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var lastActive;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(isAuthenticated && isAutoLogoutPolling)) {
                _context.next = 5;
                break;
              }

              lastActive = Number(localStorage.getItem('last-active'));

              if (!(Date.now() - lastActive > timeout)) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return logout({
                redirectUri: redirectUri
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), debounce);
    return function () {
      return clearInterval(interval);
    };
  }, [isAutoLogoutPolling, debounce]);
  b({
    timeout: timeout,
    debounce: debounce,
    onIdle: function onIdle() {
      if (isAuthenticated) {
        setAutoLogoutPolling(true);
      }
    },
    onActive: function onActive() {
      if (isAuthenticated) {
        setAutoLogoutPolling(false);
      }
    },
    onAction: function onAction() {
      if (isAuthenticated) {
        localStorage.setItem('last-active', Date.now().toString());
      }
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};

function createAuthenticationComponent(_ref) {
  var onMissingAuthentication = _ref.onMissingAuthentication;

  var Authentication = function Authentication(_ref2) {
    var children = _ref2.children;

    var _useKeycloak = useKeycloak(),
        _useKeycloak2 = _slicedToArray(_useKeycloak, 1),
        keycloak = _useKeycloak2[0];

    if (keycloak.authenticated && keycloak.token && keycloak.tokenParsed) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
    } else {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, onMissingAuthentication);
    }
  };

  return Authentication;
}

var AuthenticationWrapper = function AuthenticationWrapper(storyFn) {
  var adapter = {
    accountManagement: function accountManagement() {
      return Promise.resolve();
    },
    redirectUri: function redirectUri(_options, _encodeHash) {
      return '';
    },
    register: function register(_options) {
      return Promise.resolve();
    },
    login: function login(_options) {
      return Promise.resolve();
    },
    logout: function logout(_options) {
      return Promise.resolve();
    }
  };
  var keycloak = Keycloak({
    realm: 'realm',
    clientId: 'storybook'
  });
  return /*#__PURE__*/React__default.createElement(reactKeycloakProvider, {
    keycloak: _objectSpread2$1(_objectSpread2$1({}, keycloak), {}, {
      authenticated: true,
      token: 'token',
      // @ts-expect-error: error is expected
      tokenParsed: 'tokenParsed'
    }),
    initConfig: {
      adapter: adapter,
      onLoad: 'login-required',
      checkLoginIframe: false
    }
  }, storyFn());
};

function useAuthProfile() {
  var _useKeycloak = useKeycloak(),
      _useKeycloak2 = _slicedToArray(_useKeycloak, 1),
      keycloak = _useKeycloak2[0];

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      profile = _useState2[0],
      setProfile = _useState2[1];

  useEffect(function () {
    keycloak.loadUserProfile().then(function (value) {
      setProfile(value);
    });
  }, [keycloak, profile]);
  return profile;
}

function useAuthUserInfo() {
  var _useKeycloak = useKeycloak(),
      _useKeycloak2 = _slicedToArray(_useKeycloak, 1),
      keycloak = _useKeycloak2[0];

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      userInfo = _useState2[0],
      setUserInfo = _useState2[1];

  useEffect(function () {
    keycloak.loadUserInfo().then(function (value) {
      setUserInfo(value);
    });
  }, [keycloak]);
  return userInfo;
}

function isLoading(result) {
  return result.isLoading;
}
function hasError(result) {
  return result.hasError;
}
function notInitiated(result) {
  return result.notInitiated;
}

function createAuthorizationComponent(_ref) {
  var useAuthorizationFlow = _ref.useAuthorizationFlow,
      onLoading = _ref.onLoading,
      onError = _ref.onError,
      onMissingAuthorization = _ref.onMissingAuthorization,
      displayName = _ref.displayName;

  var Component = function Component(_ref2) {
    var children = _ref2.children;

    var _useAuthorizationFlow = useAuthorizationFlow(),
        state = _useAuthorizationFlow.state,
        initiate = _useAuthorizationFlow.initiate;

    useEffect(function () {
      if (notInitiated(state)) {
        initiate();
      }
    }, []);

    if (notInitiated(state) || isLoading(state)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, onLoading);
    }

    if (hasError(state)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, onError);
    }

    if (state.isAuthorized) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
    } else {
      if (onMissingAuthorization instanceof Function) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, onMissingAuthorization(state));
      }

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, onMissingAuthorization);
    }
  };

  Component.displayName = displayName;
  return Component;
}

function createAuthorizationDataHook(useAuthorizationFlow) {
  return function useAuthorizationData() {
    var _useAuthorizationFlow = useAuthorizationFlow(),
        state = _useAuthorizationFlow.state;

    if (notInitiated(state) || isLoading(state) || hasError(state)) {
      return {
        isAuthorized: false
      };
    } else {
      return state;
    }
  };
}

function createInitiateAuthorizationFunction(authorizationDataProvider, state, setResult) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!notInitiated(state)) {
              _context.next = 4;
              break;
            }

            setResult({
              isLoading: true
            });
            _context.next = 4;
            return authorizationDataProvider().then(function (authorizationData) {
              return setResult(authorizationData);
            })["catch"](function () {
              return setResult({
                hasError: true
              });
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function useAuthorizationState(AuthorizationContext) {
  var context = useContext(AuthorizationContext);
  var localState = useState({
    notInitiated: true
  });

  if (context) {
    return context;
  } else {
    return localState;
  }
}

function createAuthorizationFlowHook(AuthorizationContext, authorizationDataProvider) {
  return function () {
    var _useAuthorizationStat = useAuthorizationState(AuthorizationContext),
        _useAuthorizationStat2 = _slicedToArray(_useAuthorizationStat, 2),
        state = _useAuthorizationStat2[0],
        setState = _useAuthorizationStat2[1];

    return {
      state: state,
      initiate: createInitiateAuthorizationFunction(authorizationDataProvider, state, setState),
      confirm: setState
    };
  };
}

function createAuthorizationContext(displayName) {
  var AuthorizationContext = /*#__PURE__*/createContext(undefined);
  AuthorizationContext.displayName = displayName;
  return AuthorizationContext;
}

function createAuthorizationProvider(displayName, AuthorizationContext) {
  var Provider = function Provider(_ref) {
    var children = _ref.children;

    var _useState = useState({
      notInitiated: true
    }),
        _useState2 = _slicedToArray(_useState, 2),
        localState = _useState2[0],
        setLocalState = _useState2[1];

    return /*#__PURE__*/React__default.createElement(AuthorizationContext.Provider, {
      value: [localState, setLocalState]
    }, children);
  };

  Provider.displayName = displayName;
  return Provider;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
function createAuthorization(_ref) {
  var authorizationDataProvider = _ref.authorizationDataProvider,
      onLoading = _ref.onLoading,
      onError = _ref.onError,
      onMissingAuthorization = _ref.onMissingAuthorization,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? 'Authorization' : _ref$displayName;
  var AuthorizationContext = createAuthorizationContext("".concat(displayName, "Context"));
  var AuthorizationProvider = createAuthorizationProvider("".concat(displayName, "Provider"), AuthorizationContext);
  var useAuthorizationFlow = createAuthorizationFlowHook(AuthorizationContext, authorizationDataProvider);
  var useAuthorizationData = createAuthorizationDataHook(useAuthorizationFlow);
  var Authorization = createAuthorizationComponent({
    useAuthorizationFlow: useAuthorizationFlow,
    onLoading: onLoading,
    onError: onError,
    onMissingAuthorization: onMissingAuthorization,
    displayName: displayName
  });
  return {
    useAuthorizationData: useAuthorizationData,
    useAuthorizationFlow: useAuthorizationFlow,
    Authorization: Authorization,
    AuthorizationProvider: AuthorizationProvider
  };
}

function useExcludeChatbotFromPath(excludedPathNames) {
  var location = useLocation();
  useEffect(function () {
    var widgetElement = document.getElementById('mercury-widget');

    if (!widgetElement) {
      return;
    }

    if (excludedPathNames === null || excludedPathNames === void 0 ? void 0 : excludedPathNames.includes(location.pathname)) {
      widgetElement.style.display = 'none';
    } else {
      widgetElement.style.display = 'block';
    }
  }, [location.pathname]);
}

var Chatbot = function Chatbot(_ref) {
  var excludedPaths = _ref.excludedPaths,
      context = _ref.context,
      userId = _ref.userId,
      mercuryApiKey = _ref.mercuryApiKey,
      mercuryCssUrl = _ref.mercuryCssUrl,
      jestWorkerId = _ref.jestWorkerId;
  var auth = useAuthentication();
  useExcludeChatbotFromPath(excludedPaths);
  var scriptAlreadyExists = useCallback(function () {
    return document.querySelector('script#mercury-widget-snippet') !== null;
  }, []);
  var _ref2 = auth.tokenParsed,
      customerID = _ref2.idpSub;
  var freezeProp = useCallback(function (target, propertyName) {
    if (!jestWorkerId) {
      var descriptor = Object.getOwnPropertyDescriptor(target, propertyName);

      if (descriptor !== undefined) {
        var set = function set() {
          return void 0;
        };

        var get = function get() {
          return descriptor.value;
        };

        Object.defineProperty(target, propertyName, {
          enumerable: true,
          set: set,
          get: get,
          configurable: false
        });
      }
    }
  }, []);
  var appendScript = useCallback(function () {
    var generatedUserId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    var config = {
      userId: userId || generatedUserId,
      context: context
    };
    var scriptWithGlobalData = document.createElement('script');
    scriptWithGlobalData.type = 'text/javascript';
    scriptWithGlobalData.text = "window.mercuryUser = ".concat(JSON.stringify(config), ";");
    var script = document.createElement('script');
    script.type = 'application/javascript';
    script.src = 'https://cdn.mercury.ai/widget/v4/widget.js';
    script.async = true;
    script.id = 'mercury-widget-snippet';
    script.setAttribute('data-key', mercuryApiKey || '');
    document.body.appendChild(script);
    document.body.appendChild(scriptWithGlobalData);
  }, [customerID, context]);
  useEffect(function () {
    if (customerID && context && !scriptAlreadyExists()) {
      appendScript();
      freezeProp(window, 'mercuryUser');
    }
  }, [scriptAlreadyExists, appendScript, freezeProp, context, customerID]);

  var cleanupScript = function cleanupScript() {
    var widgetElement = document.getElementById('mercury-widget');
    widgetElement === null || widgetElement === void 0 ? void 0 : widgetElement.remove();
    var widgetScript = document.querySelector('script#mercury-widget-snippet');
    var dataScript = document.querySelector('script#mercury-widget-data');
    widgetScript === null || widgetScript === void 0 ? void 0 : widgetScript.remove();
    dataScript === null || dataScript === void 0 ? void 0 : dataScript.remove();
  };

  useEffect(function () {
    return function () {
      cleanupScript();
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "mercury-widget-snippet"
  }, /*#__PURE__*/React__default.createElement("link", {
    rel: "stylesheet",
    type: "text/css",
    href: mercuryCssUrl
  }));
};

//TODO: Fill all data layer fields, e.g. vehicle-data, contract-data
var DataLayer = /*#__PURE__*/function () {
  function DataLayer(market, version, releaseDate) {
    _classCallCheck$1(this, DataLayer);

    _defineProperty$3(this, "_template", void 0);

    _defineProperty$3(this, "_dataLayer", void 0);

    this._template = {
      core: {
        /*
        @Developers: Constant value.
        Acceptance criteria:
        - Do not change
        */
        dataLayerVersion: '2.4',
        pageInfo: {
          /*
          The values for pagename are defined in tracking specification
          document.
          */
          pageName: null,

          /*
          @Developers: Constant value.
          Acceptance criteria:
          - Do not change
          */
          intendedCustomerDeviceType: 'all',

          /*
          @Developers: The version of application.
          */
          version: version,

          /*
          @Developers: Constant value (format YYYY-MM-DD): Date of rollout.
          */
          releaseDate: releaseDate,

          /*
          @Developers: Current display language.
          Type: Enum
          ISO-639-2; lower case two letter code
          Hint: Visitor can change the language while his visit (e.g. in
          Switzerland).
          */
          language: null,

          /*
          Type: Enum
          The country name of the market this site is serving
          (e.g. DE: W&I -> DE, UK: S&I -> UK).
          ISO-3166-1-alpha-2; upper case two letter code
          */
          market: market,

          /*
          @Developers: Constant value.
          */
          publisher: 'DU'
        },
        category: {
          /*
          @Developers: Constant value.
          */
          primaryCategory: 'customerportal',

          /*
          @Developers: Constant value.
          Acceptance criteria:
          - Do not change
          */
          siteType: 'standalone',

          /*
          @Developers: Constant value.
          Acceptance criteria:
          - Do not change
          */
          maturityLevel: 'Portal'
        },
        attributes: {
          /*
          @Developers: Constant value.
          Acceptance criteria:
          - Do not change
          */
          journeyType: 'after-sales-journey',

          /*
          Refers to the branding of the site.
           Never include design versions here: This should not be changed to
          vw6 when a new design is released. The brand is still vw. vwcv
          refers to VW Commercial Vehicles. BFF’s data model supplies vwn,
          but we expect vwcv.
           @Developers: Please fill in the correct value here based on the
          site's branding
           Type: Enum
          seat
          vw
          skoda
          vwcv
          audi
          */
          brand: null,

          /*
          @Developers:
          Acceptance criteria:
          - If the viewChange relates to a selection of a FAQ please out the question text (not the answer text) here
           */
          faqText: null
        }
      },

      /*
      Write here if the customer sees a 404, 401, etc. page
      */
      error: {
        //Error code of application exceptions or caught errors
        errorCode: null,
        //Error message for caught errors with available message
        errorMessage: null,
        //Full URL which caused the error
        errorCausingURL: null
      },
      universally: {
        /* The number of contracts the customer has concluded
         */
        numberOfProducts: null
      },

      /*
      Please note that this structure is an array structure. We expect one entry
      for each contract sold. If the customer can bundle his contract (i.e. get
      a leasing contract, a service and maintenance package, and a tire package,
      this array should have three entries.
      */
      product: [{
        /*
        External (contract) ID; at least the brand of the website
        Note: right now it was decided to use transactionId for this field
        Type: String
        */
        productID: null,

        /*
        The name of the product from the given list. If you cannot find a
        suitable entry for the product sold in the journey, please reach out
        to the web analytics team. Please do not add any products to this list
        on your own.
        Type: Enum
        AutoCredit
        CarSharingProtection
        ChargeAndFuel
        ClassicCredit
        CreditProtectionInsurance
        LeasingRateInsurance
        DigitalRenewal
        ExtendedWarranty
        FinanceLease
        GuaranteedAssetProtection
        MotorInsurance
        OperateLease
        RentalCarProtection
        ServiceInspection
        ServiceLimitedMaintenance
        TestDriveProtection
        ThirdPartyProtection
        UsedCarWarranty
        TirePackage
        */
        name: null,

        /*
        Further sub-categories of the product, e.g. deductibles in an insurance
        contract which the customer can choose
        */
        productVariants: [],

        /*
        The main category of the current contract.
        Type: Enum
        Finance
        Insurance
        Leasing
        Service
        Other
        */
        category: null,
        attributes: {
          /*
          E.g. monthly payment for insurance or leasing contract or an
          installment. Please provide exact (float) value
          Type: Float
          */
          recurringPayment: null,

          /*
          Relates to installment.
          Type: Enum
          WEEK
          TWO-WEEKS
          MONTH
          TWO-MONTHS
          QUARTER
          SIX-MONTHS
          YEAR
          */
          durationUnit: null,

          /*
          Relates to installment. Planned duration of contract; please use
          value -1 if indefinite
          Type: Integer
          */
          duration: null,

          /*
          Only if part of the contract
          Type: Integer
          */
          yearlyMileage: null,

          /*
          The maximum agreed excess of the yearly mileage. This is the
          difference of the actual yearly mileage and the expected yearly
          mileage (yearlyMileage).
          Type: Integer
          */
          excessMileage: null,

          /*The unit of yearlyMileage, excessMileage or undrivenMileage.
          Should always be KILOMETERS in the european region.
          Type: Enum
          KILOMETERS,
          MILES
          */
          mileageUnit: null,

          /*
          Specifies the type of complete sales process
          Type: Enum
          Hybrid sales
          Online sales
          Partner sales
          */
          typeOfSale: null,

          /*
          The start date of contract in focus.
          Type: Date (YYYY-MM-DD)
          */
          startDateOfContract: null,

          /*
          The end date of contract in focus.
          Type: Date (YYYY-MM-DD)
          */
          endDateOfContract: null,

          /*
          The type of payment.
          Type: Enum
          Automatic Bank Transfer
          Credit Card
          Direct Deposit
          E-Wallet
          Mobile Payment
          */
          paymentType: null,

          /*
          The date of actual registration. Only if part of the contract.
          Type: Date (YYYY-MM-DD)
          This is a particular important value. Do not skip it due to
          management request!
          */
          registrationDateOwner: null,

          /*
          If the contract is entitled to deduct input tax.
          Type: Boolean
          */
          preTaxSubstraction: null,

          /*
          Single special payment in euro
          Type: Float
          */
          specialPayment: null,

          /*
          This is the repayment of the outstanding principal sum made at the
          end of a loan period, interest only having been paid hitherto.
          Type: Float
          */
          balloonPayment: null,

          /*
          The gross loan amount. This value is the total sum of the net loan
          amount plus all credit costs (including all interests and all
          fixed costs). It is also the amount which the customer will pay in
          the end. The currency is €.
          Type: Float
          */
          grossLoanAmount: null,

          /*
          The amount of deposit that the customer makes in the context of a
          financing product. The currency is €.
          Type: Float
          */
          downPaymentAmount: null,

          /*
          The nominal interest rate expressed as a factor applied to the net
          loan amount. It includes only the credit costs that are caused by
          the nominal interest itself.
          Type: Float
          */
          nominalInterestRate: null,

          /*
          The amount of interests caused by the nominalInterestRate over the
          entire timespan of the credit. It does not include other credit
          costs than nominal interests. The currency is €.
          Type: Float
          */
          nominalInterestAmount: null,

          /*
          Currency used for the product.
          Type: string
          */
          currency: null
        }
      }],
      //Aligned with BFF data model!
      vehicleModel: [{
        /*
        The manufacturer of the current vehicle.
        Type: Enum
        audi
        bentley
        cupra
        ducati
        man
        porsche
        scania
        seat
        skoda
        vw
        vwcv
        vwfs
        */
        manufacturer: null,

        /*
        The main name of the current car.
        Type: string, for example
        A3
        Kodiaq
        XC60
        Auris
        Golf
        */
        name: null,

        /*
        The first subcategory of the current car in manufacturers product
        program.
        Type: string
        For example
        GTI
        */
        modelVariation: null,

        /*
        The year when the model has been released.
        Type: string
        Format: YYYY
        */
        year: null,

        /*
        The second subcategory of the current car in manufacturers product
        program.
        Type: string
        For example
        Sportline
        Momentum
        Sportback
        Performance
        */
        modelLine: null,

        /*
        Long description of the vehicle model
        Type: String
        Example:
        Golf GTI Performance
        */
        descriptionLong: null,

        /*
        For tracking of hybrid sales, the sales id which is handed over
        Type: String
        */
        salesID: null,

        /*
        Describes the body type of the vehicle.
        Type: Enum
        CONVERTIBLE
        COUPE
        CROSSOVER
        CABRIO
        LUXURY CAR
        SEDAN
        SPORTS CAR
        SUV
        TRUCK
        VAN
        WAGON
        */
        bodyType: null,

        /*
        If it is a vehicle with a special warranty (Das Weltauto, TradePort),
        true, otherwise false
        Type: Boolean
        */
        certifiedPreOwned: null,

        /*
        The current mileage of the car
        Original value: 15388 km
        Data layer value: 15388
        Type: Integer
        */
        currentMileage: null,

        /*
        The unit of the current mileage of the car
        Type: Enum
        KILOMETERS,
        MILES
        */
        currentMileageUnit: null,

        /*
        The date when the vehicle has been registered first (In german
        "Tag der Erstzulassung").
        This value is of special importance to be tracked correctly as it
        serves as a measure for customer loyalty. Tracking this value
        correctly is of high importance for our management.
        Type: String
        Format: YYYY-MM-DD
        */
        initialRegistrationDate: null,

        /*
        The base price of current vehicle
        Type: Integer
        Unit local currency
        Original value: 15388 PLN
        Data layer value: 15388
        */
        basePrice_localCurrency: null,

        /*
        Local currency
        ISO-4217 alphabetic code upper case letters
        Example: PLN
        */
        currency: null,

        /*
        The final vehicle price (local currency). The unit is not part of the
        value.
        Type: Integer
        Unit local currency
        Original value: 15388 PLN
        Data layer value: 15388
        */
        endPrice_localCurrency: null,

        /*
        The base color of the current vehicle
        Enum:
        Black
        Blue
        Brown
        Green
        Grey
        Red
        Violet
        White
        Yellow
        */
        colorExterior: null,

        /*
        The type of usage
        Enum:
        Private
        Business
        Both
        */
        typeOfUse: null,
        engine: {
          /*
          The engines fuel type of the vehicle
          Enum:
          CNG
          Diesel
          Electric
          Hybrid
          Hydrogen
          LPG
          Petrol
          */
          fuelType: null
        }
      }],
      form: {
        /*
        The main subject of the form. Search forms are handled by the search
        element of this data layer.
        */
        type: null,

        /*
        The meaningful descriptive name of the form in context of the
        current site.
        */
        name: null,

        /*
        If the form is aborted the meaningful name of last touched field.
        */
        lastTouchedField: null,

        /*
        In case of user input errors, a semicolon-separated list of
        meaningful names of all erroneous fields and shortened error messages:
         <field name 1>: <error message 1>;<field name 2>: <error message 2>
        */
        errorFields: null,
        fieldValues: null
      },
      design: {
        /*
        For responsive design: Thresholds when design changes. E.g. Customer
        has a size of 1500 x 900 -> 1024 x 768 (if this is your threshold)
        Type: string
        Example: 800 x 600
        */
        browserResolutionBreakpoint: null
      },
      customerData: {
        /*
        Indicates whether the user is currently logged in or not
        Type: Boolean
        */
        loginStatus: null,

        /*
        The user group the customer belongs to. Specified values are:
        - private
        - business
        */
        loggedInUserGroup: null,

        /*
        The year the customer was born.
         Format: YYYY
        */
        yearOfBirth: null,

        /*
        The gender of the customer
        Type: Enum
        MALE
        FEMALE
        */
        gender: null
      },
      //Aligned with BFF data model!
      CMS: {
        /*
        Internal unique identifier. Should identify a page uniquely, preferred
        a reference to the corresponding page in authoring system. This value
        is set as a CMS generated fixed value.
        */
        pageID: null
      },
      //For Marketing Hook Page
      dataPrivacyStatement: {
        allowPostalAds: null,
        allowPhoneAds: null,
        allowElectronicAds: null,
        allowMailAds: null,
        allowElectronicInvoices: null
      },

      /*
      Together with the PO or BA we map our standard events to your journey and
      provide you an annotated version of the journey. Please fill these values
      based on the annotated journey.
      */
      event: [{
        eventInfo: {
          /*
          The type of events which occurred. This information describes the
          context in which the current events occurred.
          */
          eventType: null,

          /*
          The event which occurred.
          */
          eventAction: null,

          /*
          If a link or button triggers this event, please provide the target
          url of this link
          */
          eventTargetURL: null,

          /* If additional information in context of an interaction element
          is needed a short but meaningful description is placed here:
          */
          linkInformation: null
        }
      }]
    };
    this._dataLayer = _.cloneDeep(this._template);
  }

  _createClass$1(DataLayer, [{
    key: "addDefaults",
    value: function addDefaults(props) {
      this._template = _objectSpread2$1(_objectSpread2$1({}, _.cloneDeep(this._template)), props);
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      this._dataLayer = _.cloneDeep(this._template);
      return this;
    }
  }, {
    key: "set",
    value: function set(key, value, value2, value3) {
      switch (key) {
        case 'pageName':
          this._dataLayer.core.pageInfo.pageName = value;
          break;

        case 'viewChange':
          this._dataLayer.core.attributes.viewChange = value;
          break;

        case 'eventType':
          this._dataLayer.event[0].eventInfo.eventType = value;
          break;

        case 'additionalEvent':
          this._dataLayer.event.push({
            eventInfo: {
              eventType: value
            }
          });

          this._dataLayer.event[1].eventInfo.eventAction = value2;
          this._dataLayer.event[1].eventInfo.linkInformation = value3;
          break;

        case 'eventAction':
          this._dataLayer.event[0].eventInfo.eventAction = value;
          break;

        case 'linkInformation':
          this._dataLayer.event[0].eventInfo.linkInformation = value;
          break;

        case 'eventTargetURL':
          this._dataLayer.event[0].eventInfo.eventTargetURL = value;
          break;

        case 'formType':
          this._dataLayer.form.type = value;
          break;

        case 'formName':
          this._dataLayer.form.name = value;
          break;

        case 'formErrorFields':
          this._dataLayer.form.errorFields = value;
          break;

        case 'formLastTouchedField':
          this._dataLayer.form.lastTouchedField = value;
          break;

        case 'formFieldValues':
          this._dataLayer.form.fieldValues = value;
          break;

        case 'currentLanguage':
          this._dataLayer.core.pageInfo.language = value;
          break;

        case 'events':
          this._dataLayer.event = value;
          break;

        case 'privacyStatement':
          this._dataLayer.dataPrivacyStatement.allowElectronicInvoices = value;
          break;

        case 'privacyStatementPostalAds':
          this._dataLayer.dataPrivacyStatement.allowPostalAds = value;
          break;

        case 'privacyStatementPhoneAds':
          this._dataLayer.dataPrivacyStatement.allowPhoneAds = value;
          break;

        case 'privacyStatementElectronicAds':
          this._dataLayer.dataPrivacyStatement.allowElectronicAds = value;
          break;

        case 'privacyStatementMailAds':
          this._dataLayer.dataPrivacyStatement.allowMailAds = value;
          break;

        case 'userGroup':
          this._dataLayer.customerData.loggedInUserGroup = value;
          break;

        case 'loginStatus':
          this._dataLayer.customerData.loginStatus = value;
          break;

        case 'errorCode':
          this._dataLayer.error.errorCode = value;
          break;

        case 'errorMessage':
          this._dataLayer.error.errorMessage = value;
          break;

        case 'errorCausingUrl':
          this._dataLayer.error.errorCausingURL = value;
          break;

        case 'currentBrand':
          this._dataLayer.core.attributes.brand = value;
          break;

        case 'productCategory':
          this._dataLayer.product[0].category = value;
          break;

        case 'productName':
          this._dataLayer.product[0].name = value;
          break;

        case 'productId':
          this._dataLayer.product[0].productID = value;
      }

      return this;
    }
  }, {
    key: "write",
    value: function write() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.du_digitalData = this._dataLayer;
    }
  }]);

  return DataLayer;
}();

var DataPrivacyStatements;

(function (DataPrivacyStatements) {
  DataPrivacyStatements["EMAIL"] = "email";
  DataPrivacyStatements["PHONE"] = "phone";
  DataPrivacyStatements["SMS"] = "sms";
  DataPrivacyStatements["POST"] = "post";
})(DataPrivacyStatements || (DataPrivacyStatements = {}));

var TrackingPageName;

(function (TrackingPageName) {
  TrackingPageName["HOOKPAGE"] = "Hookpage";
  TrackingPageName["PROFILE"] = "Profile";
})(TrackingPageName || (TrackingPageName = {}));

var getDataPrivacyStatementValue = function getDataPrivacyStatementValue(statementType, marketingPreferences) {
  var vwfsStatement = marketingPreferences === null || marketingPreferences === void 0 ? void 0 : marketingPreferences.vwfs[statementType];
  var bpStatement = marketingPreferences === null || marketingPreferences === void 0 ? void 0 : marketingPreferences.businessPartners[statementType];
  if (vwfsStatement && bpStatement) return 'true';else if (vwfsStatement && !bpStatement) return 'true (VWFS)';else if (!vwfsStatement && bpStatement) return 'true (BP)';else return 'false';
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


var dropNullValues = function dropNullValues(_key, value) {
  if (_.isEmpty(value)) {
    return undefined;
  }

  return value;
};

//HINT: structured the "API" of the class Analytics in different categories, e.g. general, dashboard
// when this class/file becomes to big its valid to split it up e.g. using own classes and composition
var Analytics = /*#__PURE__*/function () {
  function Analytics(market, version, releaseDate) {
    var _this = this;

    _classCallCheck$1(this, Analytics);

    _defineProperty$3(this, "_firstVisit", true);

    _defineProperty$3(this, "dataLayer", void 0);

    _defineProperty$3(this, "intervalDelay", 1000);

    _defineProperty$3(this, "trackingItemsList", []);

    _defineProperty$3(this, "interval", void 0);

    _defineProperty$3(this, "clearTimeOut", function () {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      _this.interval && clearInterval(_this.interval);
    });

    _defineProperty$3(this, "irapPage", {
      onIrapPage: function onIrapPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'IRAP calculation').set('viewChange', 'IRAP calculation').set('eventType', 'pageView').set('eventAction', 'Success').write();
        };

        _this.track('page', updateDataLayer);
      },
      onIrapDownload: function onIrapDownload(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDashboardDefaults(dl).set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', 'Download IRAP calculation').write();
        };

        _this.track('download', updateDataLayer);
      }
    });

    _defineProperty$3(this, "cookieWarning", {
      // Not specified in the new documentation
      onShowCookiesLayer: function onShowCookiesLayer(pageName, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', pageName).set('viewChange', 'Cookie layer').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Not specified in the new documentation
      onAcceptCookies: function onAcceptCookies(pageName, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._onCookiesActions(dl, pageName).set('linkInformation', 'Cookies accepted').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Not specified in the new documentation
      onShowCookiePolicy: function onShowCookiePolicy(pageName, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._onCookiesActions(dl, pageName).set('linkInformation', 'Cookie policy').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "login", {
      // Login.goto
      onShowLogin: function onShowLogin(defaults, pageName) {
        var noDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', pageName || 'Home').set('viewChange', 'Login start').set('eventType', 'Login').set('eventAction', 'Start').set('linkInformation', 'Login start').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      },
      // Login.vwid & Login.external
      onExternalLogin: function onExternalLogin(defaults, selectedLogin) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          var externalValue = "Login start via external provider (".concat(selectedLogin, ")");
          var brandValue = "Login start via ".concat(selectedLogin, " ID");

          switch (selectedLogin) {
            case 'Verimi':
              dl.set('linkInformation', externalValue).set('viewChange', externalValue);
              break;

            case 'Volkswagen':
            case 'Audi':
            case 'Seat':
            case 'Cupra':
            case 'Skoda':
            case 'VWFS':
              dl.set('linkInformation', brandValue).set('viewChange', brandValue);
              break;
          }

          dl.set('pageName', 'Home').set('eventType', 'Login').set('eventAction', 'Start').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "contactDetailsHookPage", {
      // (Contact details hook page).view
      onContactDetailsHookPage: function onContactDetailsHookPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDetailsHookPageDefaults(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // (Contact details hook page).changes
      onSubmitChanges: function onSubmitChanges(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDetailsHookPageDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Contact details updated').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (Contact details hook page).cancel w/o changes
      onNoChangesCancel: function onNoChangesCancel(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDetailsHookPageDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Contact details unchanged').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (Contact details hook page).cancel with change
      onChangesCancel: function onChangesCancel(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDetailsHookPageDefaults(dl).set('eventAction', 'Success').set('linkInformation', 'Contact data change canceled').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (Contact details hook page).cancel confirmed
      onCancel: function onCancel(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDetailsHookPageDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Confirmation of discarding contact data change').set('linkInformation', 'Contact data change cancellation confirmed').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (Contact details hook page).cancel aborted
      onCancelAborted: function onCancelAborted(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDetailsHookPageDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Confirmation of discarding contact data change').set('linkInformation', 'Contact data change confirmed').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "kycHookPage", {
      // (KYC hook page).view
      onKycHookPage: function onKycHookPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setKycHookPageDefaults(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // (KYC hook page).noContract
      onNoContract: function onNoContract(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Identity confirmation').set('viewChange', 'Contract number unknown').write();
        };

        _this.track('page', updateDataLayer);
      },
      // (KYC hook page).serviceNumber
      onServicePhoneNumber: function onServicePhoneNumber(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'Identity confirmation').set('viewChange', 'Identity confirmation').set('linkInformation', 'Click on service number').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "mainNavigation", {
      // Main navigation.logout
      onLogout: function onLogout(defaults, pageName) {
        var noDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', pageName || 'Home').set('viewChange', 'Logout').set('linkInformation', 'Logout').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      },
      // Main navigation.dealerRequest
      onDealerRequestClicked: function onDealerRequestClicked(defaults, currentPage) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Dealer request').set('pageName', currentPage).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "digitalRenewal", {
      // Digital Renewal.view
      onDigitalRenewalPage: function onDigitalRenewalPage(from, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('viewChange', 'Digital renewal invitation');

          _this._setDigitalRenewalDefaults(dl);

          switch (from) {
            case 'login':
              dl.set('additionalEvent', 'Login', 'Success');
              break;

            case 'registration':
              dl.set('additionalEvent', 'Registration', 'Success');
              break;
          }

          dl.write();
        };

        _this.track('page', updateDataLayer);
      },
      // Digital Renewal.start
      onDigitalRenewalStart: function onDigitalRenewalStart(from, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', from).set('viewChange', 'Digital renewal invitation').set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Start digital renewal').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "marketingAgreement", {
      // Marketing Agreement.view
      onMarketingAgreement: function onMarketingAgreement(from, marketingPreference, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('viewChange', 'Marketing agreement notification');

          _this._setMarketingAgreementDefaults(dl);

          switch (from) {
            case 'login':
              dl.set('additionalEvent', 'Login', 'Success');
              break;

            case 'registration':
              dl.set('additionalEvent', 'Registration', 'Success');
              break;
          }

          if (marketingPreference.post !== undefined) dl.set('privacyStatementPostalAds', marketingPreference.post);
          if (marketingPreference.phone !== undefined) dl.set('privacyStatementPhoneAds', marketingPreference.phone);
          if (marketingPreference.sms !== undefined) dl.set('privacyStatementElectronicAds', marketingPreference.sms);
          if (marketingPreference.email !== undefined) dl.set('privacyStatementMailAds', marketingPreference.email);
          dl.write();
        };

        _this.track('page', updateDataLayer);
      },
      // Marketing Agreement.saveyes
      onMarketingAgreementSaveYes: function onMarketingAgreementSaveYes(defaults, marketingPreference) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setMarketingAgreementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Marketing consent form saved');

          if (marketingPreference.post !== undefined) dl.set('privacyStatementPostalAds', marketingPreference.post);
          if (marketingPreference.phone !== undefined) dl.set('privacyStatementPhoneAds', marketingPreference.phone);
          if (marketingPreference.sms !== undefined) dl.set('privacyStatementElectronicAds', marketingPreference.sms);
          if (marketingPreference.email !== undefined) dl.set('privacyStatementMailAds', marketingPreference.email);
          dl.write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Marketing Agreement.saveno
      onMarketingAgreementSaveNo: function onMarketingAgreementSaveNo(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setMarketingAgreementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Marketing preferences not saved').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Marketing Agreement.no-email
      onMarketingAgreementNoEmail: function onMarketingAgreementNoEmail(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setMarketingAgreementDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'No email address available').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Marketing Agreement.changes
      onMarketingAgreementSubmitChanges: function onMarketingAgreementSubmitChanges(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setMarketingAgreementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Email address for optin entered').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Marketing Agreement.cancel w/o changes
      onMarketingAgreementCancelWithoutChanges: function onMarketingAgreementCancelWithoutChanges(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setMarketingAgreementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Email address for optin not entered').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Marketing Agreement.changed
      onMarketingAgreementChanged: function onMarketingAgreementChanged(defaults, marketingPreference, initialValues, marketingType, forthAdditionalValue) {
        if (!_.isEqual(marketingPreference, initialValues)) {
          var type = marketingType === '(VWFS)' ? '(VWFS)' : '(BP)';

          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            if (forthAdditionalValue === TrackingPageName.HOOKPAGE) _this._setMarketingAgreementDefaults(dl);else _this._setProfileDefaults(dl);

            _this._setPageInteractionEvent(dl).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Marketing consent form changed');

            if (marketingPreference.post !== initialValues.post) dl.set('privacyStatementPostalAds', marketingPreference.post ? "+Postal ".concat(type) : "-Postal ".concat(type));else dl.set('privacyStatementPostalAds', '');
            if (marketingPreference.phone !== initialValues.phone) dl.set('privacyStatementPhoneAds', marketingPreference.phone ? "+Phone ".concat(type) : "-Phone ".concat(type));else dl.set('privacyStatementPhoneAds', '');
            if (marketingPreference.sms !== initialValues.sms) dl.set('privacyStatementElectronicAds', marketingPreference.sms ? "+SMS ".concat(type) : "-SMS ".concat(type));else dl.set('privacyStatementElectronicAds', '');
            if (marketingPreference.email !== initialValues.email) dl.set('privacyStatementMailAds', marketingPreference.email ? "+EMAIL ".concat(type) : "-EMAIL ".concat(type));else dl.set('privacyStatementMailAds', '');
            dl.write();
          };

          _this.track('interaction', updateDataLayer);
        }
      }
    });

    _defineProperty$3(this, "contactTeaser", {
      // Contact teaser.view (email)
      onClickEmailLink: function onClickEmailLink(defaults, linkTitleEN, pageName) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._onIconFooterActions(dl, "Email ".concat(linkTitleEN), pageName).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Contact teaser.view (phone)
      onClickCallUsLink: function onClickCallUsLink(defaults, linkTitleEN, pageName) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._onIconFooterActions(dl, "Phone ".concat(linkTitleEN), pageName).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "landingPage", {
      // LandingPage.view
      onLandingPage: function onLandingPage(defaults) {
        var loggedOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'home').set('viewChange', 'home'); // loggedOut variable is needed because if user logged out he is not starting the journey but _firstVist
          // variable was reset while redirecting to other application for login


          if (_this._firstVisit && !loggedOut) {
            _this.dataLayer.set('additionalEvent', 'Journey', 'Start');

            _this._firstVisit = false;
          }

          _this.dataLayer.write();
        };

        _this.track('page', updateDataLayer);
      },
      onLandingPageOffer: function onLandingPageOffer(defaults) {
        var loggedOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Home Offer').set('viewChange', 'Home Offer'); // loggedOut variable is needed because if user logged out he is not starting the journey but _firstVist
          // variable was reset while redirecting to other application for login


          if (_this._firstVisit && !loggedOut) {
            _this.dataLayer.set('additionalEvent', 'Journey', 'Start');

            _this._firstVisit = false;
          }

          _this.dataLayer.write();
        };

        _this.track('page', updateDataLayer);
      },
      // LandingPage.learnMore
      onClickMarketingCard: function onClickMarketingCard(marketingTitleEN, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'home').set('linkInformation', "Internal campaign: ".concat(marketingTitleEN)).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "authentication", {
      // Authentication.view
      onConfirmIdentityPage: function onConfirmIdentityPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl).set('viewChange', 'Authentication').set('eventType', 'Authentication').set('eventAction', 'Start').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Authentication.startTyping
      onStartTypingConfirmIdentityPage: function onStartTypingConfirmIdentityPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl).set('linkInformation', 'Authentication start typing').set('viewChange', 'Authentication').set('eventType', 'Form').set('eventAction', 'Start typing').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication.confirm.error
      onFormValidationErrorConfirmIdentityPage: function onFormValidationErrorConfirmIdentityPage(fieldErrors, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl).set('linkInformation', 'Authentication input error').set('formErrorFields', fieldErrors).set('viewChange', 'Input error').set('eventType', 'Form').set('eventAction', 'Input error').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication.confirm.success (when next authentication step exists e.g. SMS code verification)
      onConfirmConfirmIdentityPage: function onConfirmConfirmIdentityPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl);

          _this._setAuthConfirmSuccessDefaults(dl).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication.confirm.success (when this is the last step of authentication process)
      onConfirmIdentityPageConfirmSuccess: function onConfirmIdentityPageConfirmSuccess(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl);

          _this._setAuthConfirmSuccessDefaults(dl).set('additionalEvent', 'Authentication', 'Success').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      },
      // Authentication.confirm.technicalError
      onConfirmIdentityPageTechnicalError: function onConfirmIdentityPageTechnicalError(defaults, error) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl).set('viewChange', 'Authentication error').set('linkInformation', 'Authentication request (technical error)').set('eventType', 'Authentication').set('eventAction', 'Request').set('errorMessage', error.errorMessage).set('errorCode', error.errorCode).set('errorCausingUrl', error.errorCausingUrl);
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "authenticationVerification", {
      // Authentication (verification).view
      onVerificationPage: function onVerificationPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthVerificationDefaults(dl).set('viewChange', 'Verification').set('eventType', 'pageView').set('eventAction', 'Success').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Authentication (verification).startTyping
      onStartTypingVerificationPage: function onStartTypingVerificationPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthVerificationDefaults(dl).set('linkInformation', 'Authentication verification start typing').set('eventType', 'Form').set('eventAction', 'Start typing').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication (verification).confirm.error
      onFormValidationErrorVerificationPage: function onFormValidationErrorVerificationPage(fieldErrors, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthVerificationDefaults(dl).set('viewChange', 'Input error').set('linkInformation', 'Authentication input error').set('formErrorFields', fieldErrors).set('eventType', 'Form').set('eventAction', 'Input error').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication (verification).confirm.success (when next authentication step exists e.g. SMS code verification)
      onVerificationPageConfirmButton: function onVerificationPageConfirmButton(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthVerificationDefaults(dl).set('viewChange', 'Authentication').set('eventType', 'Authentication').set('eventAction', 'Request').set('linkInformation', 'Authentication request').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication (verification).confirm.success (when this is the last step of authentication process)
      onVerificationPageConfirmSuccess: function onVerificationPageConfirmSuccess(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthVerificationDefaults(dl).set('viewChange', 'Authentication').set('eventType', 'Authentication').set('eventAction', 'Request').set('additionalEvent', 'Authentication', 'Success', 'Authentication success').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      },
      // Authentication (verification).confirm.technicalError
      onConfirmVerificationPageTechnicalError: function onConfirmVerificationPageTechnicalError(defaults, error) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthVerificationDefaults(dl).set('viewChange', 'Authentication error').set('linkInformation', 'Authentication request (technical error)').set('eventType', 'Authentication').set('eventAction', 'Request').set('errorMessage', error.errorMessage).set('errorCode', error.errorCode).set('errorCausingUrl', error.errorCausingUrl);
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "authenticationTan", {
      // Authentication (TAN).submit
      onEnterSmsCode: function onEnterSmsCode(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._onEnterSmsCodeDefaults(dl).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication (TAN).confirm.success
      onEnterSmsCodeSuccess: function onEnterSmsCodeSuccess(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'Authentication').set('viewChange', 'Authentication').set('eventType', 'Authentication').set('eventAction', 'Request').set('linkInformation', 'Authentication request').set('additionalEvent', 'Authentication', 'Success', 'Authentication success').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      }
    });

    _defineProperty$3(this, "authenticationFailed", {
      // Authentication failed.confirm.error
      onConfirmIdentityPageAuthFailed: function onConfirmIdentityPageAuthFailed(defaults, formName) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'Authentication').set('viewChange', 'Authentication failed').set('formType', 'Authentication').set('formName', formName || 'Personal data').set('eventType', 'Authentication').set('eventAction', 'Failed').set('eventAction', 'Authentication failed').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Authentication failed.abort
      onConfirmIdentityAborted: function onConfirmIdentityAborted(lastTouchedField, defaults) {
        var noDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var formName = arguments.length > 3 ? arguments[3] : undefined;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'Authentication').set('formType', 'Authentication').set('formName', formName || 'Personal data').set('formLastTouchedField', lastTouchedField).set('linkInformation', 'Authentication aborted').set('eventType', 'Form').set('eventAction', 'Aborted').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      }
    });

    _defineProperty$3(this, "introduction", {
      // Introduction.view
      onIntroductionPage: function onIntroductionPage(defaults) {
        var isAfterRegistration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Introduction').set('viewChange', 'Introduction');

          if (isAfterRegistration) {
            dl.set('additionalEvent', 'Registration', 'Success');
          }

          dl.write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "dashboard", {
      //As values for view use: Financial Details, Products / Services included, Vehicle details, Contract parties
      // Dashboard.view
      onDashboardWithoutUnpaid: function onDashboardWithoutUnpaid(from) {
        var digitalRenewal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var defaults = arguments.length > 2 ? arguments[2] : undefined;
        var bankAccountUpdate = arguments.length > 3 ? arguments[3] : undefined;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDashboardDefaults(dl).set('eventAction', 'Success').set('eventType', 'pageView');

          switch (from) {
            case 'login':
              dl.set('additionalEvent', 'Login', 'Success');
              break;

            case 'registration':
              dl.set('additionalEvent', 'Registration', 'Success');
              break;
          }

          if (digitalRenewal) dl.set('viewChange', 'Digital renewal invitation');
          if (bankAccountUpdate) dl.set('viewChange', 'Bank account update necessary');
          if (digitalRenewal && bankAccountUpdate) dl.set('viewChange', 'Digital renewal invitation / Bank account update necessary');
          if (!digitalRenewal && !bankAccountUpdate) dl.set('viewChange', 'Dashboard');
          dl.write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard.inactiveContracts
      onDashboardWithInactiveContracts: function onDashboardWithInactiveContracts(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Inactive contracts').set('eventType', 'pageView').set('eventAction', 'Success').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard.addContract
      onAddContract: function onAddContract(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Add contract').set('eventType', 'pageView').set('eventAction', 'Success').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard.filter
      filterPage: function filterPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Filter').set('eventType', 'pageView').set('eventAction', 'Success').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard.changePaymentDate
      onDashboardChangePaymentDate: function onDashboardChangePaymentDate(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'End of contract').set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Change payment date').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard.changePaymentDate
      onChangePaymentDate: function onChangePaymentDate(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          dl.set('viewChange', 'Request purchase price').set('pageName', 'End of contract').set('viewChange', 'Change payment date').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard.changePaymentDate.submit
      onChangePaymentDateSubmit: function onChangePaymentDateSubmit(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'End of contract').set('linkInformation', 'Changed payment date submitted').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard.addContractError
      onAddContractError: function onAddContractError(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl).set('linkInformation', 'Add contract - Error').set('eventType', 'Success').set('eventAction', 'interAction').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard.infoTip
      onMonthlyPaymentInfoTip: function onMonthlyPaymentInfoTip(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl).set('linkInformation', 'Info monthly base rate').set('eventType', 'Success').set('eventAction', 'interAction').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard.cancelContract
      onCancelNonStandardContract: function onCancelNonStandardContract(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAuthFormDefaults(dl).set('linkInformation', 'Cancel contract').set('eventType', 'Success').set('eventAction', 'interAction').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard.suspendInstallment
      onOpenSuspendInstallment: function onOpenSuspendInstallment(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Dashboard').set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Suspend installment').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Dashboard.learnMore
      onLearnMore: function onLearnMore(linkLabelEN, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Dashboard').set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', "Internal campaign: ".concat(linkLabelEN)).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Dashboard.chi
      chi: function chi(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Determine customer happiness index').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard.vehicleDetails
      onVehicleDetails: function onVehicleDetails(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Dashboard').set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Vehicle details').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Dashboard.digitalRenewal
      onDashboardDigitalRenewal: function onDashboardDigitalRenewal(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Start digital renewal').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Dashboard.reportDamage
      onReportDamage: function onReportDamage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Dashboard').set('linkInformation', 'Report damage').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Dashboard.updateBankAccountClick
      onBankAccountUpdateClick: function onBankAccountUpdateClick(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('linkInformation', 'Bank account update necessary: Update bank account').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (outstanding-1) & Dashboard (outstanding-2) & Dashboard (outstanding-3)
      outstandingPayment: {
        // Dashboard (outstanding-1).view
        onDashboard: function onDashboard(from, outstandingPayment) {
          var digitalRenewal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var defaults = arguments.length > 3 ? arguments[3] : undefined;

          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setDashboardDefaults(dl).set('eventAction', 'Success').set('eventType', 'pageView');

            switch (from) {
              case 'login':
                dl.set('additionalEvent', 'Login', 'Success');
                break;

              case 'registration':
                dl.set('additionalEvent', 'Registration', 'Success');
                break;
            }

            if (outstandingPayment && digitalRenewal) dl.set('viewChange', 'Outstanding payment / Digital renewal invitation');
            if (outstandingPayment && !digitalRenewal) dl.set('viewChange', 'Outstanding payment');
            if (!outstandingPayment && digitalRenewal) dl.set('viewChange', 'Digital renewal invitation');
            dl.write();
          };

          _this.track('page', updateDataLayer);
        },
        // Dashboard (outstanding-2).view
        onOverview: function onOverview(defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageViewEvent(dl);

            _this._setDashboardDefaults(dl).set('viewChange', 'Outstanding payment - overview').write();
          };

          _this.track('page', updateDataLayer);
        },
        // Dashboard (outstanding-3).view
        onPayment: function onPayment(defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageViewEvent(dl);

            _this._setDashboardDefaults(dl).set('viewChange', 'Outstanding payment - payment page').write();
          };

          _this.track('page', updateDataLayer);
        },
        // Dashboard (outstanding-3).payNow.submit
        onPay: function onPay(defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageInteractionEvent(dl);

            _this._setDashboardDefaults(dl).set('viewChange', 'Outstanding payment - payment page').set('linkInformation', 'Pay now').write();
          };

          _this.track('interaction', updateDataLayer);
        },
        // Dashboard (outstanding-3).payNow.success
        onPaymentSuccess: function onPaymentSuccess(defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageViewEvent(dl);

            _this._setDashboardDefaults(dl).set('viewChange', 'Outstanding payment - success').write();
          };

          _this.track('page', updateDataLayer);
        },
        // Dashboard (outstanding-3).payNow.failed
        onPaymentNoSuccess: function onPaymentNoSuccess(defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageViewEvent(dl);

            _this._setDashboardDefaults(dl).set('viewChange', 'Outstanding payment - no success').write();
          };

          _this.track('page', updateDataLayer);
        }
      },
      onDashboardStartMatchmaker: function onDashboardStartMatchmaker(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDashboardDefaults(dl);

          _this._setStartMatchmakerInteractionDefaults(dl);

          _this._setPageInteractionEvent(dl).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Dashboard.onClickContractActionEntryPoint
      onClickContractActionEntryPoint: function onClickContractActionEntryPoint(entrypointName, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('linkInformation', "".concat(entrypointName)).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "dashboardEdit", {
      // Dashboard (edit).accordionOpen
      onOpenDashboardAccordion: function onOpenDashboardAccordion(view, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', view).set('linkInformation', "Open section ".concat(view)).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).bankAccount
      onBankAccountChange: function onBankAccountChange(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Financial Details - Payment Information').set('formType', 'Finance').set('formName', 'Bank account').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard (edit).SEPA
      onSepa: function onSepa(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Financial details - Bank account').set('formType', 'Finance').set('formName', 'Bank account').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard (edit).SEPAsign
      onSepaSign: function onSepaSign(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Financial details - SEPA digital sign').set('formType', 'Finance').set('formName', 'Financial details').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard (edit).SEPAsignSuccess
      onSepaSignSuccess: function onSepaSignSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Financial details - SEPA digital sign - Request').set('formType', 'Finance').set('formName', 'Financial details').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard (edit).SEPAsignError
      onSepaSignError: function onSepaSignError(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', 'Financial details - SEPA digital sign - Error').set('formType', 'Finance').set('formName', 'Financial details').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dashboard (edit).accordion.edit
      onEditDashboardSection: function onEditDashboardSection(view, item, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setEditDashboardDefaults(dl, view, item).set('linkInformation', 'Profile edit').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).accordion.startTyping
      onStartTypingEditDashboardSection: function onStartTypingEditDashboardSection(view, item, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEditDashboardDefaults(dl, view, item).set('eventType', 'Form').set('eventAction', 'Start typing').set('linkInformation', 'Profile edit').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).accordion.error
      onFormValidationErrorEditDashboardSection: function onFormValidationErrorEditDashboardSection(view, item, fieldErrors, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDashboardDefaults(dl).set('viewChange', "".concat(view, " - ").concat(item, " input error")).set('formType', 'Finance').set('formName', item).set('formErrorFields', fieldErrors).set('eventType', 'Form').set('eventAction', 'Input error').set('linkInformation', 'Profile edit input error').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).accordion.abort
      onCancelEditDashboardSection: function onCancelEditDashboardSection(view, item, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setEditDashboardDefaults(dl, view, item).set('linkInformation', 'Edit cancelled').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).accordion.failed
      onSubmitErrorEditDashboardSection: function onSubmitErrorEditDashboardSection(view, item, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDashboardDefaults(dl).set('viewChange', "".concat(view, " - ").concat(item, " edit failed")).set('formType', 'Finance').set('formName', item).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Edit input error').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).accordion.areYouSure
      onConfirmEditDashboardSection: function onConfirmEditDashboardSection(view, item, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', "".concat(view, " - ").concat(item, " edit confirmation")).set('formType', 'Finance').set('formName', item).set('linkInformation', 'Edit confirmation question').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).accordion.canceled
      onCancelConfirmationEditDashboardSection: function onCancelConfirmationEditDashboardSection(view, item, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', "".concat(view, " - ").concat(item, " edit confirmation")).set('linkInformation', 'Edit confirmation canceled').set('formType', 'Finance').set('formName', item).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dashboard (edit).accordion.success
      onSuccessEditDashboardSection: function onSuccessEditDashboardSection(view, item, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setDashboardDefaults(dl).set('viewChange', "".concat(view, " - ").concat(item, " edit success")).set('linkInformation', 'Edit success').set('formType', 'Finance').set('formName', item).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      sepaMandate: {
        // Dashboard (edit).SEPA.technicalError
        sepaMandateDownloadError: function sepaMandateDownloadError(defaults, error, section) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setDashboardDefaults(dl).set('viewChange', "".concat(section || 'Financial Details', " - download error")).set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).set('errorCausingUrl', error.errorCausingUrl).set('formType', 'Finance').set('formName', section || 'Financial Details').set('eventType', 'Error').set('eventAction', 'Technical error').set('linkInformation', 'Download SEPA mandate failed').write();
          };

          _this.track('interaction', updateDataLayer);
        },
        // Dashboard (edit).SEPA.success
        onSepaMandateDownload: function onSepaMandateDownload(defaults, section) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setDashboardDefaults(dl).set('viewChange', section || 'Financial Details').set('formType', 'Finance').set('formName', section || 'Financial Details').set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', 'Download SEPA mandate').write();
          };

          _this.track('download', updateDataLayer);
        }
      }
    });

    _defineProperty$3(this, "requestCertificate", {
      // Request certificate.view
      onRequestCertificate: function onRequestCertificate(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setRequestCertificateDefaults(dl).set('viewChange', 'Document request').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Request certificate.success
      onSuccessRequestCertificate: function onSuccessRequestCertificate(documentNameEN, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setRequestCertificateDefaults(dl).set('viewChange', 'Document request success').set('linkInformation', "Document ".concat(documentNameEN)).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Request certificate.failed
      onRequestCertificateSubmitFailed: function onRequestCertificateSubmitFailed(documentNameEN, error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestCertificateDefaults(dl).set('viewChange', 'Document request failed').set('eventType', 'interAction').set('eventAction', 'Failed').set('linkInformation', "Document ".concat(documentNameEN)).set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Request certificate.technicalError
      onRequestCertificateSubmitAPIError: function onRequestCertificateSubmitAPIError(documentNameEN, error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestCertificateDefaults(dl).set('viewChange', 'Document request failed').set('eventType', 'API').set('eventAction', 'Error').set('linkInformation', "Document ".concat(documentNameEN)).set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "requestSubrogation", {
      // Request subrogation.view
      onClickEntryPointAction: function onClickEntryPointAction(entrypointName, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setRequestSubrogationDefaults(dl).set('viewChange', "".concat(entrypointName)).write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "contractRecalculation", {
      //Contract recalculation.success
      onContractRecalculationFormSubmitSuccess: function onContractRecalculationFormSubmitSuccess(type, change, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', "Recalculation: ".concat(type, " ").concat(change)).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "amortizationTable", {
      // Amortization.view
      onAmortizationTable: function onAmortizationTable(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAmortizationTableDefaults(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Amortization.download
      onAmortizationTableDownload: function onAmortizationTableDownload(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAmortizationTableDefaults(dl).set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', 'Download amortization table').write();
        };

        _this.track('download', updateDataLayer);
      },
      // Amortization.download2
      onBundledProductsDownload: function onBundledProductsDownload(defaults, fieldValues) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setAmortizationTableDefaults(dl).set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', fieldValues || 'Download bundled products').write();
        };

        _this.track('download', updateDataLayer);
      }
    });

    _defineProperty$3(this, "earlySettlement", {
      //Early Settlement.view
      onEarlySettlement: function onEarlySettlement(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlySettlementDefaults(dl).set('viewChange', 'Early Settlement');

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      //Early SettlementSummary.view
      onEarlySettlementSummaryPage: function onEarlySettlementSummaryPage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).write();

          _this._setPageViewEvent(dl).set('pageName', 'Early Settlement summary').set('viewChange', 'Early Settlement summary').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Early Settlement.payment.goto
      onEarlySettlementProceedToPayment: function onEarlySettlementProceedToPayment(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlySettlementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Early Settlement').set('linkInformation', 'Proceed to payment').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Early Settlement.accordion.settlementDetails
      onEarlySettlementDetails: function onEarlySettlementDetails(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlySettlementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Settlement details').set('linkInformation', 'Settlement details').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Early Settlement.simulation
      onEarlySettlementSimulation: function onEarlySettlementSimulation(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlySettlementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Settlement simulation').set('linkInformation', 'Settlement simulation').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Early Settlement.calculation
      onEarlySettlementCalculate: function onEarlySettlementCalculate(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlySettlementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Settlement simulation').set('linkInformation', 'Settlement simulated').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Early Settlement.summary
      onEarlySettlementSummary: function onEarlySettlementSummary(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Early Settlement summary').set('viewChange', 'Early Settlement summary').set('linkInformation', 'Early Settlement summary').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Early Settlement.success
      onEarlySettlementSummaryLayerDisplayed: function onEarlySettlementSummaryLayerDisplayed(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'Early Settlement summary').set('viewChange', 'Submit success').set('linkInformation', 'Payment details per email').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Early Settlement.failed
      onEarlySettlementSummarySubmitFailed: function onEarlySettlementSummarySubmitFailed(defaults, error) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'Early Settlement summary').set('viewChange', 'Submit fail').set('linkInformation', 'Payment details per email').set('errorCode', error === null || error === void 0 ? void 0 : error.errorCode).set('errorMessage', error === null || error === void 0 ? void 0 : error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Settlement.COVID
      onCOVID19: function onCOVID19(defaults, error) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', 'Early Settlement summary').set('viewChange', 'Submit fail').set('linkInformation', 'Payment details per email').set('errorCode', error === null || error === void 0 ? void 0 : error.errorCode).set('errorMessage', error === null || error === void 0 ? void 0 : error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      hirePurchase: {
        // Early settlement (purchase+hire).view
        onEarlySettlementGenerate: function onEarlySettlementGenerate(discriminator, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setEarlySettlementDefaults(dl);

            _this._setPageViewEvent(dl).set('viewChange', 'Generate settlement quote').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).write();
          };

          _this.track('page', updateDataLayer);
        },
        // Early settlement (purchase+hire).generateQuote
        onEarlySettlementGenerateQuote: function onEarlySettlementGenerateQuote(discriminator, linkInformation, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setEarlySettlementDefaults(dl);

            _this._setPageInteractionEvent(dl).set('viewChange', 'Generate settlement quote').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).set('linkInformation', linkInformation) //"Request quote (by email)", "Request quote (by post)", "Request quote (by email and post)"
            .write();
          };

          _this.track('interaction', updateDataLayer);
        },
        // Early settlement (purchase+hire).view.enquiry
        onEarlySettlementEnquiry: function onEarlySettlementEnquiry(discriminator, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setEarlySettlementDefaults(dl);

            _this._setPageViewEvent(dl).set('viewChange', 'Quote').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).write();
          };

          _this.track('page', updateDataLayer);
        },
        // Early settlement (purchase+hire).print
        onEarlySettlementEnquiryPrint: function onEarlySettlementEnquiryPrint(discriminator, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setEarlySettlementDefaults(dl);

            _this._setPageInteractionEvent(dl).set('viewChange', 'Generate settlement quote').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).set('linkInformation', 'Print settlement quote').write();
          };

          _this.track('interaction', updateDataLayer);
        },
        // Early settlement (purchase+hire).view.summary
        onEarlySettlementComplete: function onEarlySettlementComplete(discriminator, cardPayAvailable, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageViewEvent(dl);

            _this._setEarlySettlementSummaryDefaults(dl, cardPayAvailable).set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).write();
          };

          _this.track('page', updateDataLayer);
        },
        // Early settlement (purchase+hire).Button Print
        onEarlySettlementCompletePrint: function onEarlySettlementCompletePrint(discriminator, cardPayAvailable, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setEarlySettlementSummaryDefaults(dl, cardPayAvailable);

            _this._setPageInteractionEvent(dl).set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).set('linkInformation', 'Print settlement quote').write();
          };

          _this.track('interaction', updateDataLayer);
        },
        onEarlySettlementPaymentSelectBankTransfer: function onEarlySettlementPaymentSelectBankTransfer(discriminator, cardPayAvailable, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setEarlySettlementSummaryDefaults(dl, cardPayAvailable).set('eventType', 'Payment').set('eventAction', 'Request').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).set('linkInformation', 'Pay by bank transfer requested').write();
          };

          _this.track('interaction', updateDataLayer);
        },
        onEarlySettlementPaymentProceedToPayByCard: function onEarlySettlementPaymentProceedToPayByCard(discriminator, cardPayAvailable, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setEarlySettlementSummaryDefaults(dl, cardPayAvailable).set('eventType', 'Payment').set('eventAction', 'Request').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).set('linkInformation', 'Pay by card requested').write();
          };

          _this.track('interaction', updateDataLayer);
        },
        onEarlySettlementPaymentSuccess: function onEarlySettlementPaymentSuccess(discriminator, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageViewEvent(dl).set('pageName', 'Pay by credit card confirmation').set('viewChange', 'Pay by card successful').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).set('eventType', 'Payment').set('eventAction', 'Success').write();
          };

          _this.track('page', updateDataLayer);
        },
        onEarlySettlementPaymentError: function onEarlySettlementPaymentError(discriminator, defaults) {
          var updateDataLayer = function updateDataLayer() {
            var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

            _this._setPageViewEvent(dl).set('pageName', 'Pay by credit card confirmation').set('viewChange', 'Pay by card not successful').set('productCategory', 'Finance').set('productName', _this._getEarlySettlementProductName(discriminator)).set('eventType', 'Payment').set('eventAction', 'Failed').write();
          };

          _this.track('page', updateDataLayer);
        }
      },
      // Not specified in the new documentation
      onHeyCarLinkClick: function onHeyCarLinkClick(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlySettlementDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Hey Car').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Choice partial or total
      onClickEntryPointAction: function onClickEntryPointAction(entrypointName, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setRequestSubrogationDefaults(dl).set('viewChange', "".concat(entrypointName)).write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "earlyTermination", {
      // Early termination (Leasing).view
      onEarlyTerminationLeasingContract: function onEarlyTerminationLeasingContract(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Early termination leasing contract').set('viewChange', 'Early termination leasing contract - Info page').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Early termination (Credit) Info.view
      onEarlyTerminationCreditContractView: function onEarlyTerminationCreditContractView(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlyTerminationCreditContractDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Early termination credit contract - Info page').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Early termination (Credit) Upload.view
      onEarlyTerminationCreditContractUpload: function onEarlyTerminationCreditContractUpload(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlyTerminationCreditContractDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Early termination credit contract - Document upload').set('formType', 'Contract termination').set('formType', 'Document upload').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Early termination (Credit) Upload.error
      onEarlyTerminationCreditContractValidationError: function onEarlyTerminationCreditContractValidationError(fieldErrors, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlyTerminationCreditContractDefaults(dl).set('viewChange', 'Early termination credit contract - form error').set('formType', 'Contract termination').set('formName', 'Document upload').set('formErrorFields', fieldErrors).set('eventType', 'Form').set('eventAction', 'Input error').set('viewChange', 'Early termination credit contract - form error').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Early termination (Credit) Upload.success
      onEarlyTerminationCreditContractSendRequest: function onEarlyTerminationCreditContractSendRequest(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEarlyTerminationCreditContractDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Early termination credit contract - Request sent').set('viewChange', 'Early termination credit contract - Request sent').write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "endOfContractPcp", {
      // EndOfContractPcpStart.requestPrice
      requestPrice: function requestPrice(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('viewChange', 'Request purchase price').set('pageName', 'End of contract').write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpStart.requestPriceSubmit
      onRequestPriceSubmit: function onRequestPriceSubmit(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('linkInformation', 'Request purchase price submitted').set('eventType', 'interAction').set('eventAction', 'Success').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpStart.requestPriceSubmit
      silentContractExtension: function silentContractExtension(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'End of contract').set('viewChange', 'Silent contract extension').write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpStart.requestPriceSubmit
      silentContractExtensionSubmit: function silentContractExtensionSubmit(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('linkInformation', 'Silent contract extension submitted').set('eventType', 'interAction').set('eventAction', 'Success').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpStart.view
      onEndOfContractPcpStart: function onEndOfContractPcpStart(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpOptions(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpExchange.view
      onEndOfContractPcpExchange: function onEndOfContractPcpExchange(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpExchange(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpKeep.view
      onEndOfContractPcpKeep: function onEndOfContractPcpKeep(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpKeep(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpHandBack.view
      onEndOfContractPcpHandBack: function onEndOfContractPcpHandBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpHandBack(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpRefinance.view
      onEndOfContractPcpRefinance: function onEndOfContractPcpRefinance(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpRefinance(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpRefinanceSuccess.view
      onEndOfContractPcpRefinanceSuccess: function onEndOfContractPcpRefinanceSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Refinance request submitted').write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpRefinanceFailure.view
      onEndOfContractPcpRefinanceFailure: function onEndOfContractPcpRefinanceFailure(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Refinance request submit failed').write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpSell.view
      onEndOfContractPcpSell: function onEndOfContractPcpSell(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpSell(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpExchangeContactRetailer.Contact your dealer
      onEndOfContractPcpExchangeContactRetailer: function onEndOfContractPcpExchangeContactRetailer(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpExchange(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Contact your dealer').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpExchangeRequestCallback.Request a call-back
      onEndOfContractPcpExchangeRequestCallback: function onEndOfContractPcpExchangeRequestCallback(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpExchange(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Request a call-back').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpExchangeFinanceOffers.Find out more
      onEndOfContractPcpExchangeFinanceOffers: function onEndOfContractPcpExchangeFinanceOffers(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpExchange(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Find out more').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpExchangeConfigurator.Configure your next car
      onEndOfContractPcpExchangeConfigurator: function onEndOfContractPcpExchangeConfigurator(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpExchange(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Configure your next car').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpExchangeBack.Click
      onEndOfContractPcpExchangeBack: function onEndOfContractPcpExchangeBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpExchange(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpExchangeDashboard.Back to dashboard
      onEndOfContractPcpExchangeDashboard: function onEndOfContractPcpExchangeDashboard(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpExchange(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to dashboard').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpExchangeDashboard.dashboard-4
      onEndOfContractPcpRenewalSelected: function onEndOfContractPcpRenewalSelected(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpOptions(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Go to match maker').write();
        };

        _this.track('exit', updateDataLayer);
      },
      // EndOfContractPcpExchangeDashboard.dealer
      onEndOfContractPcpDealerData: function onEndOfContractPcpDealerData(defaults, renewalOption) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpOptions(dl);

          _this._setPageViewEvent(dl).set('viewChange', renewalOption).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractPcpKeepBack.Back to options
      onEndOfContractPcpKeepBack: function onEndOfContractPcpKeepBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpKeep(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpKeepDashboard.Back to dashboard
      onEndOfContractPcpKeepDashboard: function onEndOfContractPcpKeepDashboard(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpKeep(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to dashboard').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpHandBackPersonalisedPlates.Get private plate
      onEndOfContractPcpHandBackPersonalisedPlates: function onEndOfContractPcpHandBackPersonalisedPlates(eventTargetURL, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpHandBack(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Get private plate').set('eventTargetURL', eventTargetURL).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpHandBackBvrlaGuidelines.Fair wear & tear guide
      onEndOfContractPcpHandBackBvrlaGuidelines: function onEndOfContractPcpHandBackBvrlaGuidelines(eventTargetURL, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpHandBack(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Fair wear & tear guide').set('eventTargetURL', eventTargetURL).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpHandBackEndOfContractCharges.Charges for Damage or Missing Items
      onEndOfContractPcpHandBackEndOfContractCharges: function onEndOfContractPcpHandBackEndOfContractCharges(eventTargetURL, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpHandBack(dl).set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', 'Charges for Damage or Missing Items').set('eventTargetURL', eventTargetURL).write();
        };

        _this.track('download', updateDataLayer);
      },
      // EndOfContractPcpHandBackBack.Back to options
      onEndOfContractPcpHandBackBack: function onEndOfContractPcpHandBackBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpHandBack(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpHandBackDashboard.Back to dashboard
      onEndOfContractPcpHandBackDashboard: function onEndOfContractPcpHandBackDashboard(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpHandBack(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to dashboard').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpRefinanceBack.Back to options
      onEndOfContractPcpRefinanceBack: function onEndOfContractPcpRefinanceBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpRefinance(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpRefinanceRequest.Refinance request
      onEndOfContractPcpRefinanceRequest: function onEndOfContractPcpRefinanceRequest(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpRefinance(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Refinance request').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpSell.Back to options
      onEndOfContractPcpSellBack: function onEndOfContractPcpSellBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpSell(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpSell.Back to dashboard
      onEndOfContractPcpSellDashboard: function onEndOfContractPcpSellDashboard(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpSell(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to dashboard').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractPcpSell.Value and inspect my car
      onEndOfContractPcpSellInspect: function onEndOfContractPcpSellInspect(eventTargetURL, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpSell(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Value my car').set('eventTargetURL', eventTargetURL).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      onEndOfContractPcpStartMatchmaker: function onEndOfContractPcpStartMatchmaker(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractPcpDefaults(dl);

          _this._setStartMatchmakerInteractionDefaults(dl);

          _this._setPageInteractionEvent(dl).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "endOfContractRch", {
      // EndOfContractRchStart.view
      onEndOfContractRchStart: function onEndOfContractRchStart(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchOptions(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchNew.View
      onEndOfContractRchNew: function onEndOfContractRchNew(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchNew(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchExtend.View
      onEndOfContractRchExtend: function onEndOfContractRchExtend(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtend(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchExtension.View
      onEndOfContractRchExtension: function onEndOfContractRchExtension(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtension(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchExtensionSuccess.View
      onEndOfContractRchExtensionSuccess: function onEndOfContractRchExtensionSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtension(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'RCH Extension Request submitted').write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchExtensionFailure.View
      onEndOfContractRchExtensionFailure: function onEndOfContractRchExtensionFailure(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtension(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'RCH Extension Request submit failed').write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchReturn.View
      onEndOfContractRchReturn: function onEndOfContractRchReturn(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchReturn(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchCallBack.View
      onEndOfContractRchCallBack: function onEndOfContractRchCallBack(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchCallBack(section, dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchCallBackSuccess.View
      onEndOfContractRchCallBackSuccess: function onEndOfContractRchCallBackSuccess(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchCallBack(section, dl);

          _this._setPageViewEvent(dl).set('viewChange', "RCH ".concat(section, ": Callback request submitted")).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchCallBackFailure.View
      onEndOfContractRchCallBackFailure: function onEndOfContractRchCallBackFailure(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchCallBack(section, dl);

          _this._setPageViewEvent(dl).set('viewChange', "RCH ".concat(section, ": Callback request submit failed")).write();
        };

        _this.track('page', updateDataLayer);
      },
      // EndOfContractRchNewContactRetailer.Contact your dealer
      onEndOfContractRchNewContactRetailer: function onEndOfContractRchNewContactRetailer(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchNew(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Contact your dealer').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchNewFinanceOffers.Find out more
      onEndOfContractRchNewFinanceOffers: function onEndOfContractRchNewFinanceOffers(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchNew(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Find out more').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchNewNewFromStock.Find your next car
      onEndOfContractRchNewNewFromStock: function onEndOfContractRchNewNewFromStock(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchNew(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Find your next car').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchNewConfigurator.Configure your next car
      onEndOfContractRchNewConfigurator: function onEndOfContractRchNewConfigurator(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchNew(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Configure your next car').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchNewBack.Back to options
      onEndOfContractRchNewBack: function onEndOfContractRchNewBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchNew(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchNewDashboard.Back to dashboard
      onEndOfContractRchNewDashboard: function onEndOfContractRchNewDashboard(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchNew(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to dashboard').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchExtendShortTermExtension.Apply for short-term extension (FEATURE TOGGLED OFF)
      onEndOfContractRchExtendShortTermExtension: function onEndOfContractRchExtendShortTermExtension(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtend(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Apply for short-term extension').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchExtendFormalExtension.Apply for formal extension (FEATURE TOGGLED OFF)
      onEndOfContractRchExtendFormalExtension: function onEndOfContractRchExtendFormalExtension(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtend(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Apply for formal extension').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchExtendBack.Back to options
      onEndOfContractRchExtendBack: function onEndOfContractRchExtendBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtend(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchExtendDashboard.Back to dashboard
      onEndOfContractRchExtendDashboard: function onEndOfContractRchExtendDashboard(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtend(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to dashboard').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchExtension.Back to options
      onEndOfContractRchExtensionBack: function onEndOfContractRchExtensionBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtension(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchExtension.RCH Extension Request
      onEndOfContractRchExtensionRequest: function onEndOfContractRchExtensionRequest(formName, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchExtension(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'RCH Extension Request').set('formName', formName).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchReturnBvrlaGuidelines.Fair wear & tear guide
      onEndOfContractRchReturnBvrlaGuidelines: function onEndOfContractRchReturnBvrlaGuidelines(eventTargetURL, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchReturn(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Fair wear & tear guide').set('eventTargetURL', eventTargetURL).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchReturnEndOfContractCharges.Charges for Damage or Missing Items
      onEndOfContractRchReturnEndOfContractCharges: function onEndOfContractRchReturnEndOfContractCharges(eventTargetURL, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchReturn(dl).set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', 'Charges for Damage or Missing Items').set('eventTargetURL', eventTargetURL).write();
        };

        _this.track('download', updateDataLayer);
      },
      // EndOfContractRchReturnBack.Back to options
      onEndOfContractRchReturnBack: function onEndOfContractRchReturnBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchReturn(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchReturnDashboard.Back to dashboard
      onEndOfContractRchReturnDashboard: function onEndOfContractRchReturnDashboard(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchReturn(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to dashboard').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchCallBackBack.Back to options
      onEndOfContractRchCallBackBack: function onEndOfContractRchCallBackBack(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchCallBack(section, dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back to options').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // EndOfContractRchCallBackRequest.Request
      onEndOfContractRchCallBackRequest: function onEndOfContractRchCallBackRequest(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchCallBack(section, dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'RCH Callback Request').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      onEndOfContractRchStartMatchmaker: function onEndOfContractRchStartMatchmaker(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setEndOfContractRchDefaults(dl);

          _this._setStartMatchmakerInteractionDefaults(dl);

          _this._setPageInteractionEvent(dl).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "profile", {
      //As values for section use: Identification, Address, Contact, Consent settings, Dealer
      // My profile.view
      onProfile: function onProfile(defaults, marketingPreferences) {
        var vwfsPreferences = marketingPreferences === null || marketingPreferences === void 0 ? void 0 : marketingPreferences.vwfs;
        var bpPreferences = marketingPreferences === null || marketingPreferences === void 0 ? void 0 : marketingPreferences.businessPartners;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl).set('viewChange', 'Profile');

          _this._setPageViewEvent(dl).write();

          if ((vwfsPreferences === null || vwfsPreferences === void 0 ? void 0 : vwfsPreferences.post) !== undefined || (bpPreferences === null || bpPreferences === void 0 ? void 0 : bpPreferences.post) !== undefined) dl.set('privacyStatementPostalAds', getDataPrivacyStatementValue(DataPrivacyStatements.POST, marketingPreferences));
          if ((vwfsPreferences === null || vwfsPreferences === void 0 ? void 0 : vwfsPreferences.phone) !== undefined || (bpPreferences === null || bpPreferences === void 0 ? void 0 : bpPreferences.phone) !== undefined) dl.set('privacyStatementPhoneAds', getDataPrivacyStatementValue(DataPrivacyStatements.PHONE, marketingPreferences));
          if ((vwfsPreferences === null || vwfsPreferences === void 0 ? void 0 : vwfsPreferences.sms) !== undefined || (bpPreferences === null || bpPreferences === void 0 ? void 0 : bpPreferences.sms) !== undefined) dl.set('privacyStatementElectronicAds', getDataPrivacyStatementValue(DataPrivacyStatements.SMS, marketingPreferences));
          if ((vwfsPreferences === null || vwfsPreferences === void 0 ? void 0 : vwfsPreferences.email) !== undefined || (bpPreferences === null || bpPreferences === void 0 ? void 0 : bpPreferences.email) !== undefined) dl.set('privacyStatementMailAds', getDataPrivacyStatementValue(DataPrivacyStatements.EMAIL, marketingPreferences));
          dl.write();
        };

        _this.track('page', updateDataLayer);
      },
      // My profile.edit
      onEditProfile: function onEditProfile(section, defaults, sectionType) {
        var updateDataLayer = function updateDataLayer() {
          var fullSectionName = !!sectionType ? "".concat(section, " ").concat(sectionType) : section;

          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Profile edit').set('viewChange', fullSectionName).set('formType', 'Profile').set('formName', fullSectionName).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.view.section
      onEditProfileSectionDisplayed: function onEditProfileSectionDisplayed(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Profile edit section displayed').set('viewChange', section).set('formType', 'Profile').set('formName', section).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.startTyping
      onEditProfileTypedIn: function onEditProfileTypedIn(section, defaults, sectionType) {
        var updateDataLayer = function updateDataLayer() {
          var fullSectionName = !!sectionType ? "".concat(section, " ").concat(sectionType) : section;

          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl).set('linkInformation', 'Profile edit started').set('viewChange', fullSectionName).set('eventType', 'Form').set('eventAction', 'Start typing').set('formType', 'Profile').set('formName', fullSectionName).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.abort
      onEditProfileCancel: function onEditProfileCancel(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', section).set('linkInformation', 'Profile edit cancelled').set('formType', 'Profile').set('formName', section).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.error
      onEditProfileValidationError: function onEditProfileValidationError(fieldErrors, section, defaults, sectionType) {
        var updateDataLayer = function updateDataLayer() {
          var fullSectionName = !!sectionType ? "".concat(section, " ").concat(sectionType) : section;

          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl).set('linkInformation', 'Profile edit - form error').set('viewChange', "".concat(fullSectionName, " input error")).set('eventType', 'Form').set('eventAction', 'Input error').set('formType', 'Profile').set('formName', fullSectionName).set('formErrorFields', fieldErrors).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.failed
      onEditProfileSubmitFailed: function onEditProfileSubmitFailed(section, defaults, sectionType) {
        var updateDataLayer = function updateDataLayer() {
          var fullSectionName = !!sectionType ? "".concat(section, " ").concat(sectionType) : section;

          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl).set('linkInformation', 'Profile edit - change rejected').set('viewChange', "".concat(fullSectionName, " edit failed")).set('eventType', 'interAction').set('eventAction', 'Failed').set('formType', 'Profile').set('formName', fullSectionName).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.accordion.areYouSure
      onEditProfileConfirmation: function onEditProfileConfirmation(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Profile edit - confirmation requested').set('viewChange', "".concat(section, " edit confirmation")).set('formType', 'Profile').set('formName', section).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.accordion.areYouSure.abort
      onEditProfileConfirmationCancel: function onEditProfileConfirmationCancel(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', "".concat(section, " edit confirmation")).set('linkInformation', 'Edit confirmation cancelled').set('formType', 'Profile').set('formName', section).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Not specified in the new documentation
      onEditProfileDownload: function onEditProfileDownload(section, documentType, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', section).set('linkInformation', "Download ".concat(documentType)).write();
        };

        _this.track('download', updateDataLayer);
      },
      // My profile.accordion.success
      onEditProfileSuccess: function onEditProfileSuccess(section, defaults, sectionType, electronicInvoicesStatus, marketingPreference) {
        var updateDataLayer = function updateDataLayer() {
          var fullSectionName = !!sectionType ? "".concat(section, " ").concat(sectionType) : section;

          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', "".concat(fullSectionName, " edit success")).set('formType', 'Profile').set('formName', fullSectionName);

          if (!!electronicInvoicesStatus) {
            dl.set('linkInformation', "Electronic invoices: ".concat(electronicInvoicesStatus));
          } else {
            dl.set('linkInformation', 'Edit success');
          }

          if ((marketingPreference === null || marketingPreference === void 0 ? void 0 : marketingPreference.post) !== undefined) dl.set('privacyStatementPostalAds', marketingPreference.post);
          if ((marketingPreference === null || marketingPreference === void 0 ? void 0 : marketingPreference.phone) !== undefined) dl.set('privacyStatementPhoneAds', marketingPreference.phone);
          if ((marketingPreference === null || marketingPreference === void 0 ? void 0 : marketingPreference.sms) !== undefined) dl.set('privacyStatementElectronicAds', marketingPreference.sms);
          if ((marketingPreference === null || marketingPreference === void 0 ? void 0 : marketingPreference.email) !== undefined) dl.set('privacyStatementMailAds', marketingPreference.email);
          dl.write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.documentUpload
      onEditProfileDocumentUpload: function onEditProfileDocumentUpload(section, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageViewEvent(dl).set('formName', section).set('formType', 'Profile').set('viewChange', 'Document upload').write();
        };

        _this.track('page', updateDataLayer);
      },
      // My profile.documentUpload.failed
      onEditProfileDocumentUploadFailed: function onEditProfileDocumentUploadFailed(section, error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Document upload').set('linkInformation', 'Document upload failed').set('formType', 'Profile').set('formName', section).set('errorMessage', error.errorMessage).set('errorCode', error.errorCode).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.accountDelete
      onDeleteAccountSuccess: function onDeleteAccountSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Delete account').set('linkInformation', 'Delete account request').set('formType', 'Profile').set('formName', 'Account').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.accountDelete.areYouSure
      onConfirmDeleteAccount: function onConfirmDeleteAccount(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Security question delete account').set('formType', 'Profile').set('formName', 'Account').set('linkInformation', 'Security question delete account').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // My profile.accountDelete.success
      onConfirmDeleteAccountSuccess: function onConfirmDeleteAccountSuccess(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Security question delete account').set('formType', 'Profile').set('formName', 'Account').set('linkInformation', 'Delete account confirmation').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      },
      // My profile.dealer.call
      onCallDealerClicked: function onCallDealerClicked(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Dealer').set('formType', 'Profile').set('formName', 'Dealer').set('linkInformation', 'Dealer phone number clicked').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      },
      // My profile.dealer.request
      onCallDealerRequest: function onCallDealerRequest(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setProfileDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Dealer').set('formType', 'Profile').set('formName', 'Dealer').set('linkInformation', 'Send a request').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      }
    });

    _defineProperty$3(this, "motorPropertyTax", {
      //Motor property tax.view
      onMotorTax: function onMotorTax(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('viewChange', 'Motor property tax');

          _this._setPropertyTaxDefaults(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      //Motor property tax.download
      onMotorTaxDownload: function onMotorTaxDownload(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPropertyTaxDefaults(dl);

          _this._setPageInteractionEvent(dl).set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', 'Download motor property tax').write();
        };

        _this.track('download', updateDataLayer);
      }
    });

    _defineProperty$3(this, "dealerRequest", {
      // Dealer Request.view
      onDealerRequest: function onDealerRequest(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('viewChange', 'Dealer request');

          _this._setDealerDefaults(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dealer Request.success
      onDealerRequestSuccess: function onDealerRequestSuccess(defaults, fieldValues) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDealerDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Submit successful').set('formType', 'Contact').set('formName', 'Dealer request').set('linkInformation', 'Dealer request submit successful').set('formFieldValues', fieldValues || '').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dealer Request.failed
      onDealerRequestFailed: function onDealerRequestFailed(defaults, fieldValues, error) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDealerDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Submit failed').set('formType', 'Contact').set('formName', 'Dealer request').set('linkInformation', 'Dealer request submit failed').set('formFieldValues', fieldValues || '').set('errorCode', error === null || error === void 0 ? void 0 : error.errorCode).set('errorMessage', error === null || error === void 0 ? void 0 : error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "dealerCard", {
      // Dealer Card.choose
      onChooseDealer: function onChooseDealer(defaults, currentPage) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Dealer card').set('linkInformation', 'Choose your dealer').set('pageName', currentPage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dealer Card.change
      onChangeDealer: function onChangeDealer(defaults, currentPage) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Dealer card').set('linkInformation', 'Change your dealer').set('pageName', currentPage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dealer Card.request
      onRequestDealer: function onRequestDealer(defaults, currentPage) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Dealer card').set('linkInformation', 'Send a request').set('pageName', currentPage).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "dealerSelection", {
      // Dealer Selection.view
      onDealerSelection: function onDealerSelection(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('viewChange', 'Dealer selection');

          _this._setDealerSelectionDefaults(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Dealer Selection.save
      onDealerSelectionSave: function onDealerSelectionSave(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDealerSelectionDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Dealer save clicked').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Dealer Selection.dealer.call
      onDealerSelectionCall: function onDealerSelectionCall(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setDealerSelectionDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Dealer phone number clicked').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "postbox", {
      // Postbox.view
      onPostbox: function onPostbox(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('viewChange', 'Postbox');

          _this._setPostboxDefaults(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Postbox.download
      onPostboxDownload: function onPostboxDownload(documentTypeEN, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPostboxDefaults(dl).set('viewChange', 'Postbox').set('eventType', 'Download').set('eventAction', 'Request').set('linkInformation', "Download ".concat(documentTypeEN)).write();
        };

        _this.track('download', updateDataLayer);
      },
      // Postbox.technicalError
      onPostboxDownloadError: function onPostboxDownloadError(documentTypeEN, error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPostboxDefaults(dl).set('viewChange', 'Download error').set('eventType', 'Error').set('eventAction', 'Technical error').set('linkInformation', "Download ".concat(documentTypeEN)).set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).set('errorCausingUrl', error.errorCausingUrl).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Postbox.signUp.view
      onPostboxInvoiceSignUpView: function onPostboxInvoiceSignUpView(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl);

          _this._setPostboxDefaults(dl).set('viewChange', 'Electronic invoice sign up').write();
        };

        _this.track('page', updateDataLayer);
      },
      // Postbox.signUp.cancel
      onPostboxInvoiceSignUpCancel: function onPostboxInvoiceSignUpCancel(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPostboxDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Electronic invoice sign up').set('linkInformation', 'Electronic invoice sign up canceled').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Postbox.signUp.success
      onPostboxInvoiceSignUpConfirm: function onPostboxInvoiceSignUpConfirm(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPostboxDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', 'Electronic invoice sign up').set('linkInformation', 'Electronic invoice sign up successful').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Postbox.signUp.prohibited
      onPostboxDownloadErrorInvoiceDeactivated: function onPostboxDownloadErrorInvoiceDeactivated(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPostboxDefaults(dl).set('viewChange', 'Download invoice prohibited').set('eventType', 'Access').set('eventAction', 'Denied').set('linkInformation', 'Download invoice prohibited').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "faq", {
      // FAQ.view
      onFaq: function onFaq(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setFAQDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'FAQ').write();
        };

        _this.track('page', updateDataLayer);
      },
      // FAQ.accordion.opened
      onFaqQuestion: function onFaqQuestion(question, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setFAQDefaults(dl);

          _this._setPageInteractionEvent(dl).set('viewChange', question).set('linkInformation', 'FAQ question clicked').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "requestAdditionalHelp", {
      //Financial aid.view
      onRequestAdditionalHelpSituation: function onRequestAdditionalHelpSituation(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Current situation').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Financial aid.view.financialDetails
      onRequestAdditionalHelpIncomeAndExpenditure: function onRequestAdditionalHelpIncomeAndExpenditure(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Financial details').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Financial aid.Breathing space
      onRequestAdditionalHelpBreathingSpace: function onRequestAdditionalHelpBreathingSpace(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Payment interruption').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Financial aid.Payment by instalments
      onRequestAdditionalHelpArrangementToPay: function onRequestAdditionalHelpArrangementToPay(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Payment by instalments').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Financial aid.Payment delay
      onRequestAdditionalHelpPromiseToPay: function onRequestAdditionalHelpPromiseToPay(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'Payment delay').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Financial aid.End agreement
      requestAdditionalHelpEndAgreement: function requestAdditionalHelpEndAgreement(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageViewEvent(dl).set('viewChange', 'End agreement').write();
        };

        _this.track('page', updateDataLayer);
      },
      //Financial aid.view.financialDetails.Print
      onRequestAdditionalHelpIncomeAndExpenditurePrint: function onRequestAdditionalHelpIncomeAndExpenditurePrint(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Print financial details').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Financial aid.success
      onRequestAdditionalHelpSubmitSuccess: function onRequestAdditionalHelpSubmitSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Request financial aid - Success').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Financial aid.failed
      onRequestAdditionalHelpSubmitFailed: function onRequestAdditionalHelpSubmitFailed(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Request financial aid - Failed').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Financial aid.Button Back
      onRequestAdditionalHelpBack: function onRequestAdditionalHelpBack(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestAdditionalHelpDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', 'Back').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "contact", {
      //Contact.view
      onContact: function onContact(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDefaults(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      //Contact.success
      onContactSubmitSuccess: function onContactSubmitSuccess(reason, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', "Request contact - Success (".concat(reason, ")")).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      //Contact.failed
      onContactSubmitFailed: function onContactSubmitFailed(reason, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setContactDefaults(dl);

          _this._setPageInteractionEvent(dl).set('linkInformation', "Request contact - Failed (".concat(reason, ")")).write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "legalNotice", {
      // Mandatory pages.Legal.view
      onLegalNotice: function onLegalNotice(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Legal').set('viewChange', 'Legal').write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "privacyPolicy", {
      // Mandatory pages.Privacy policy.view
      onPrivacyPolicy: function onPrivacyPolicy(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Privacy policy').write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "cookiePolicy", {
      // Mandatory pages.Cookie policy.view
      onCookiePolicy: function onCookiePolicy(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Cookie policy').write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "modernSlaveryStatement", {
      // Mandatory pages.Modern slavery statement.view
      onModernSlaveryStatement: function onModernSlaveryStatement(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Modern slavery statement').write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "thirdPartyLicenses", {
      // Mandatory pages.Third party licences.view
      onThirdPartyLicenses: function onThirdPartyLicenses(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Third party licences').write();
        };

        _this.track('page', updateDataLayer);
      }
    });

    _defineProperty$3(this, "error", {
      // Error pages.API not available.view
      onApiError: function onApiError(defaults, url) {
        var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Connection Problem';

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'API Error').set('eventType', 'API').set('eventAction', 'Error').set('errorMessage', errorMessage).set('errorCausingUrl', url).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Error pages.Error: Unauthorized (401).view
      onNotAuthorizedError: function onNotAuthorizedError(defaults, url) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'Error: Unauthorized (401)').set('viewChange', 'Error: Unauthorized (401)').set('eventType', 'Login').set('eventAction', 'Unauthorized').set('errorCode', 401).set('errorMessage', 'Unauthorized').set('errorCausingUrl', url).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Error pages.Error: Access denied (403).view
      onAccessDeniedError: function onAccessDeniedError(defaults, url) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'Error: Access denied (403)').set('viewChange', 'Error: Access denied (403)').set('eventType', 'Access').set('eventAction', 'Denied').set('errorCode', 403).set('errorMessage', 'Access denied').set('errorCausingUrl', url).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Error pages.Error: Page not found (404).view
      onPageNotFoundError: function onPageNotFoundError(defaults, url) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'Error: Page not found (404)').set('viewChange', 'Error: Page not found (404)').set('eventType', 'Error').set('eventAction', 'Page not found').set('errorCode', 404).set('errorMessage', 'Page not found').set('errorCausingUrl', url).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Error pages.Error: Internal server error (500).view
      onConnectionProblemError: function onConnectionProblemError(defaults, url) {
        var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Connection Problem';

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          dl.set('pageName', 'Error: Internal server error (500)').set('viewChange', 'Error: Internal server error (500)').set('eventType', 'Error').set('eventAction', 'Technical error').set('errorCode', 500).set('errorMessage', errorMessage).set('errorCausingUrl', url).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Error pages.Error: Auto logout.view
      onAutoLogout: function onAutoLogout(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Auto logout').set('viewChange', 'Auto logout').write();
        };

        _this.track('page', updateDataLayer, undefined, noDelay);
      }
    });

    _defineProperty$3(this, "requests", {
      // Make a request.view
      onRequests: function onRequests(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setRequestsDefaults(dl).set('viewChange', 'Requests');

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      // Make a request.success
      onRequestSuccess: function onRequestSuccess(defaults, fieldValues) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setRequestsDefaults(dl).set('viewChange', 'Submit successful').set('linkInformation', 'Request submit successful').set('formType', 'Contact').set('formName', 'Request').set('formFieldValues', fieldValues || '').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // Make a request.failed
      onRequestFailure: function onRequestFailure(defaults, fieldValues) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl);

          _this._setRequestsDefaults(dl).set('viewChange', 'Submit failed').set('linkInformation', 'Request submit failed').set('formType', 'Contact').set('formName', 'Request').set('formFieldValues', fieldValues || '').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "reportDamage", {
      // Report Damage (RD).view
      onReportDamage: function onReportDamage(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', 'Report damage (RD)').set('viewChange', 'Report damage (RD)').write();
        };

        _this.track('page', updateDataLayer);
      },
      // (RD) Repair approval.view
      onRepairApproval: function onRepairApproval(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', '(RD) Repair approval').set('viewChange', '(RD) Repair approval').write();
        };

        _this.track('page', updateDataLayer);
      },
      // (RD) Repair approval.success
      onRepairApprovalSuccess: function onRepairApprovalSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Repair approval').set('viewChange', '(RD) Repair approval success').set('linkInformation', 'Repair approval success').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Repair approval.failed
      onRepairApprovalFailure: function onRepairApprovalFailure(error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Repair approval').set('viewChange', '(RD) Repair approval failed').set('linkInformation', 'Repair approval failed').set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Export Report.view
      onExpertReport: function onExpertReport(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', '(RD) Expert report').set('viewChange', '(RD) Expert report').write();
        };

        _this.track('page', updateDataLayer);
      },
      // (RD) Export Report.success
      onExpertReportSuccess: function onExpertReportSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Expert report').set('viewChange', '(RD) Expert report success').set('linkInformation', 'Expert report success').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Export Report.failed
      onExpertReportFailure: function onExpertReportFailure(error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Expert report').set('viewChange', '(RD) Expert report failed').set('linkInformation', 'Expert report failed').set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Export Report.download
      onExpertReportInsuranceClaimDownload: function onExpertReportInsuranceClaimDownload(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Expert report').set('viewChange', '(RD) Expert report').set('linkInformation', 'Expert report download').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Total loss.view
      onTotalLoss: function onTotalLoss(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', '(RD) Total loss').set('viewChange', '(RD) Total loss').write();
        };

        _this.track('page', updateDataLayer);
      },
      // (RD) Total loss.success
      onTotalLossSuccess: function onTotalLossSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Total loss').set('viewChange', '(RD) Total loss success').set('linkInformation', 'Total loss success').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Total loss.failed
      onTotalLossFailure: function onTotalLossFailure(error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Total loss').set('viewChange', '(RD) Total loss failed').set('linkInformation', 'Total loss failed').set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Total loss.download
      onTotalLossInsuranceClaimDownload: function onTotalLossInsuranceClaimDownload(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Total loss').set('viewChange', '(RD) Total loss').set('linkInformation', 'Total loss download').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Total loss.earlySettlementRedirect
      onTotalLossEarlySettlementRedirect: function onTotalLossEarlySettlementRedirect(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Total loss').set('viewChange', '(RD) Total loss redirect early settlement').set('linkInformation', 'Total loss redirect early settlement performed').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Theft.view
      onTheft: function onTheft(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageViewEvent(dl).set('pageName', '(RD) Theft report').set('viewChange', '(RD) Theft report').write();
        };

        _this.track('page', updateDataLayer);
      },
      // (RD) Theft.success
      onTheftSuccess: function onTheftSuccess(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Theft report').set('viewChange', '(RD) Theft report success').set('linkInformation', 'Theft report success').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Theft.failed
      onTheftFailure: function onTheftFailure(error, defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Theft report').set('viewChange', '(RD) Theft report failed').set('linkInformation', 'Theft report failed').set('errorCode', error.errorCode).set('errorMessage', error.errorMessage).write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Theft.download
      onTheftInsuranceClaimDownload: function onTheftInsuranceClaimDownload(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Theft report').set('viewChange', '(RD) Theft report').set('linkInformation', 'Theft report download').write();
        };

        _this.track('interaction', updateDataLayer);
      },
      // (RD) Theft.requestRegistrationCertRedirect
      onTheftRequestRegistrationCertRedirect: function onTheftRequestRegistrationCertRedirect(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setPageInteractionEvent(dl).set('pageName', '(RD) Theft report').set('viewChange', '(RD) Theft report success').set('linkInformation', 'Theft redirect request registration cert').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    _defineProperty$3(this, "matchmaker", {
      // UseOurMatchmaker.view
      onUseOurMatchmaker: function onUseOurMatchmaker(defaults) {
        var loggedOut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setMatchmakerLandingPageDefaults(dl);

          _this._setPageViewEvent(dl); // loggedOut variable is needed because if user logged out he is not starting the journey but _firstVist
          // variable was reset while redirecting to other application for login


          if (_this._firstVisit && !loggedOut) {
            _this.dataLayer.set('additionalEvent', 'Product journey', 'Start');

            _this._firstVisit = false;
          }

          _this.dataLayer.write();
        };

        _this.track('page', updateDataLayer);
      },
      onMatchmakerLogin: function onMatchmakerLogin(defaults) {
        var noDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setMatchmakerLandingPageDefaults(dl);

          _this._setPageInteractionEvent(dl).set('eventType', 'Login').set('eventAction', 'Start').set('linkInformation', 'Login start').write();
        };

        _this.track('interaction', updateDataLayer, undefined, noDelay);
      },
      onStartMatchmaker: function onStartMatchmaker(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setStartMatchmakerPageDefaults(dl);

          _this._setPageViewEvent(dl).write();
        };

        _this.track('page', updateDataLayer);
      },
      onContinueToMatchmaker: function onContinueToMatchmaker(defaults) {
        var updateDataLayer = function updateDataLayer() {
          var dl = _this._setDefaults(_this.dataLayer.clone(), defaults);

          _this._setStartMatchmakerPageDefaults(dl);

          _this._setPageInteractionEvent(dl).set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Go to match maker').write();
        };

        _this.track('interaction', updateDataLayer);
      }
    });

    this.dataLayer = new DataLayer(market, version, releaseDate);
    this.watch();
  }

  _createClass$1(Analytics, [{
    key: "watch",
    value: function watch() {
      var _this2 = this;

      this.clearTimeOut();
      this.interval = setInterval(function () {
        var item = _this2.trackingItemsList[0];

        if (item) {
          _this2.sendTrackedData(item.identifier, item.updateDataLayer, item.payload);

          _this2.trackingItemsList.shift();
        }
      }, this.intervalDelay);
    }
  }, {
    key: "track",
    value: function track(identifier, updateDataLayer, payload, noDelay) {
      if (noDelay) this.sendTrackedData(identifier, updateDataLayer, payload);else this.trackingItemsList.push({
        identifier: identifier,
        updateDataLayer: updateDataLayer,
        payload: payload
      });
    }
  }, {
    key: "sendTrackedData",
    value: function sendTrackedData(identifier, updateDataLayer, payload) {
      updateDataLayer();

      if (process.env.NODE_ENV === 'development') {
        //TODO: introduce logger e.g. winston
        var payloadStr = payload ? ' = ' + JSON.stringify(payload, dropNullValues, 2) : ''; // eslint-disable-next-line no-console, @typescript-eslint/no-explicit-any

        console.log("[Analytics.dataLayer] ".concat(JSON.stringify(window.du_digitalData, null, 2))); // eslint-disable-next-line no-console

        console.log("[Analytics.track] ".concat(identifier, " ").concat(payloadStr));
      } else {
        var _satellite;

        //TODO: add _satellite to window type
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (_satellite = window._satellite) === null || _satellite === void 0 ? void 0 : _satellite.track(identifier, payload);
      }
    }
  }, {
    key: "_setPageViewEvent",
    value: function _setPageViewEvent(dl) {
      dl.set('eventType', 'pageView').set('eventAction', 'Success');
      return dl;
    }
  }, {
    key: "_setPageInteractionEvent",
    value: function _setPageInteractionEvent(dl) {
      dl.set('eventType', 'interAction').set('eventAction', 'Success');
      return dl;
    } // TODO: Investigate deep cloning of data-layer and rework _setDefaults

  }, {
    key: "_setDefaults",
    value: function _setDefaults(dl, defaults) {
      dl.set('currentLanguage', defaults.currentLanguage).set('userGroup', defaults.userGroup || null).set('loginStatus', !!defaults.loginStatus).set('currentBrand', defaults.currentBrand).set('productId', defaults.productId);
      return dl;
    } // Cookie warning currently not in use

  }, {
    key: "_onCookiesActions",
    value: function _onCookiesActions(dl, pageName) {
      dl.set('pageName', pageName).set('eventType', 'interAction').set('eventAction', 'Success').set('viewChange', 'Cookie layer');
      return dl;
    } //IRAP calculation page

  }, {
    key: "_setContactDetailsHookPageDefaults",
    //Contact details hook page
    value: function _setContactDetailsHookPageDefaults(dl) {
      dl.set('pageName', 'Contact data confirmation request');
      dl.set('viewChange', 'Contact data confirmation request');
      return dl;
    }
  }, {
    key: "_setKycHookPageDefaults",
    // KYC hook page
    value: function _setKycHookPageDefaults(dl) {
      dl.set('pageName', 'Identity confirmation');
      dl.set('viewChange', 'Identity confirmation');
      return dl;
    }
  }, {
    key: "_setDigitalRenewalDefaults",
    // Digital Renewal (Hook Page)
    value: function _setDigitalRenewalDefaults(dl) {
      dl.set('pageName', 'Digital renewal invitation');
      return dl;
    }
  }, {
    key: "_setMarketingAgreementDefaults",
    // Marketing Agreement
    value: function _setMarketingAgreementDefaults(dl) {
      dl.set('pageName', 'Marketing agreement notification');
      return dl;
    }
  }, {
    key: "_onIconFooterActions",
    // Contact teaser
    value: function _onIconFooterActions(dl, linkInformation, pageName) {
      dl.set('pageName', pageName || 'Home').set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', linkInformation);
      return dl;
    }
  }, {
    key: "_setAuthFormDefaults",
    // Authentication
    value: function _setAuthFormDefaults(dl) {
      dl.set('pageName', 'Authentication').set('formType', 'Authentication').set('formName', 'Personal data');
      return dl;
    }
  }, {
    key: "_setAuthConfirmSuccessDefaults",
    value: function _setAuthConfirmSuccessDefaults(dl) {
      dl.set('viewChange', 'Authentication').set('linkInformation', 'Authentication request').set('eventType', 'Authentication').set('eventAction', 'Request');
      return dl;
    }
  }, {
    key: "_setAuthVerificationDefaults",
    // Authentication (verification)
    value: function _setAuthVerificationDefaults(dl) {
      dl.set('pageName', 'Authentication').set('formType', 'Authentication').set('formName', 'Verification');
      return dl;
    }
  }, {
    key: "_onEnterSmsCodeDefaults",
    // Authentication (TAN)
    value: function _onEnterSmsCodeDefaults(dl) {
      dl.set('pageName', 'Authentication').set('viewChange', 'One time code').set('eventType', 'interAction').set('eventAction', 'Success');
      return dl;
    }
  }, {
    key: "_setDashboardDefaults",
    value: function _setDashboardDefaults(dl) {
      dl.set('pageName', 'Dashboard');
      return dl;
    }
  }, {
    key: "_setEditDashboardDefaults",
    value: function _setEditDashboardDefaults(dl, view, item) {
      dl.set('pageName', 'Dashboard').set('viewChange', "".concat(view, " - ").concat(item)).set('formType', 'Finance').set('formName', item);
      return dl;
    } // Dashboard & Dashboard (outstanding-1) & Dashboard (outstanding-2) & Dashboard (outstanding-3)

  }, {
    key: "_setRequestCertificateDefaults",
    // Request certificate
    value: function _setRequestCertificateDefaults(dl) {
      dl.set('pageName', 'Document request');
      return dl;
    }
  }, {
    key: "_setRequestSubrogationDefaults",
    // Request Subrogation
    value: function _setRequestSubrogationDefaults(dl) {
      dl.set('pageName', 'Subrogation');
      return dl;
    }
  }, {
    key: "_setAmortizationTableDefaults",
    // Amortization
    value: function _setAmortizationTableDefaults(dl) {
      dl.set('pageName', 'Amortization Table').set('viewChange', 'Amortization Table');
      return dl;
    }
  }, {
    key: "_setEarlySettlementDefaults",
    // Early settlement & Early settlement (purchase+hire)
    value: function _setEarlySettlementDefaults(dl) {
      dl.set('pageName', 'Early Settlement');
      return dl;
    }
  }, {
    key: "_setEarlySettlementSummaryDefaults",
    value: function _setEarlySettlementSummaryDefaults(dl, cardPayAvailable) {
      dl.set('pageName', 'Early Settlement summary').set('viewChange', "Early settlement summary: ".concat(cardPayAvailable ? 'Pay by card possible' : 'Pay by card not possible'));
      return dl;
    }
  }, {
    key: "_setEarlyTerminationCreditContractDefaults",
    value: function _setEarlyTerminationCreditContractDefaults(dl) {
      dl.set('pageName', 'Early termination credit contract');
      return dl;
    }
  }, {
    key: "_getEarlySettlementProductName",
    value: function _getEarlySettlementProductName(discriminator) {
      return discriminator === 'settlement' ? 'AutoCredit' : 'Rental';
    }
  }, {
    key: "_setEndOfContractDefaults",
    // End of Contract - Common
    value: function _setEndOfContractDefaults(dl) {
      dl.set('pageName', 'End of contract').set('productCategory', 'Finance');
      return dl;
    } // End of Contract - PCP

  }, {
    key: "_setEndOfContractPcpDefaults",
    value: function _setEndOfContractPcpDefaults(dl) {
      this._setEndOfContractDefaults(dl);

      dl.set('productName', 'AutoCredit');
      return dl;
    }
  }, {
    key: "_setEndOfContractPcpOptions",
    value: function _setEndOfContractPcpOptions(dl) {
      this._setEndOfContractPcpDefaults(dl);

      dl.set('viewChange', 'End of contract options');
      return dl;
    }
  }, {
    key: "_setEndOfContractPcpExchange",
    value: function _setEndOfContractPcpExchange(dl) {
      this._setEndOfContractPcpDefaults(dl);

      dl.set('viewChange', 'Exchange car');
      return dl;
    }
  }, {
    key: "_setEndOfContractPcpKeep",
    value: function _setEndOfContractPcpKeep(dl) {
      this._setEndOfContractPcpDefaults(dl);

      dl.set('viewChange', 'Keep car');
      return dl;
    }
  }, {
    key: "_setEndOfContractPcpHandBack",
    value: function _setEndOfContractPcpHandBack(dl) {
      this._setEndOfContractPcpDefaults(dl);

      dl.set('viewChange', 'Returning your car');
      return dl;
    }
  }, {
    key: "_setEndOfContractPcpRefinance",
    value: function _setEndOfContractPcpRefinance(dl) {
      this._setEndOfContractPcpDefaults(dl);

      dl.set('viewChange', 'Refinance');
      return dl;
    }
  }, {
    key: "_setEndOfContractPcpSell",
    value: function _setEndOfContractPcpSell(dl) {
      this._setEndOfContractPcpDefaults(dl);

      dl.set('viewChange', 'Sell');
      return dl;
    }
  }, {
    key: "_setEndOfContractRchDefaults",
    // End Of Contract - RCH
    value: function _setEndOfContractRchDefaults(dl) {
      this._setEndOfContractDefaults(dl);

      dl.set('productName', 'Rental');
      return dl;
    }
  }, {
    key: "_setEndOfContractRchOptions",
    value: function _setEndOfContractRchOptions(dl) {
      this._setEndOfContractRchDefaults(dl);

      dl.set('viewChange', 'End of contract options');
      return dl;
    }
  }, {
    key: "_setEndOfContractRchNew",
    value: function _setEndOfContractRchNew(dl) {
      this._setEndOfContractRchDefaults(dl);

      dl.set('viewChange', 'Find new car');
      return dl;
    }
  }, {
    key: "_setEndOfContractRchExtend",
    value: function _setEndOfContractRchExtend(dl) {
      this._setEndOfContractRchDefaults(dl);

      dl.set('viewChange', 'Extend agreement');
      return dl;
    }
  }, {
    key: "_setEndOfContractRchExtension",
    value: function _setEndOfContractRchExtension(dl) {
      this._setEndOfContractRchDefaults(dl);

      dl.set('viewChange', 'Extension request - options');
      return dl;
    }
  }, {
    key: "_setEndOfContractRchReturn",
    value: function _setEndOfContractRchReturn(dl) {
      this._setEndOfContractRchDefaults(dl);

      dl.set('viewChange', 'Returning your car');
      return dl;
    }
  }, {
    key: "_setEndOfContractRchCallBack",
    value: function _setEndOfContractRchCallBack(section, dl) {
      this._setEndOfContractRchDefaults(dl);

      dl.set('viewChange', "RCH ".concat(section, ": Callback request"));
      return dl;
    }
  }, {
    key: "_setProfileDefaults",
    // My profile
    value: function _setProfileDefaults(dl) {
      dl.set('pageName', 'Profile');
      return dl;
    }
  }, {
    key: "_setPropertyTaxDefaults",
    //Motor property tax
    value: function _setPropertyTaxDefaults(dl) {
      dl.set('pageName', 'Motor property tax');
      return dl;
    }
  }, {
    key: "_setDealerDefaults",
    // Dealer Request
    value: function _setDealerDefaults(dl) {
      dl.set('pageName', 'Dealer request');
      return dl;
    }
  }, {
    key: "_setDealerSelectionDefaults",
    // Dealer Selection
    value: function _setDealerSelectionDefaults(dl) {
      dl.set('pageName', 'Dealer selection');
      return dl;
    }
  }, {
    key: "_setPostboxDefaults",
    // Postbox
    value: function _setPostboxDefaults(dl) {
      dl.set('pageName', 'Postbox');
      return dl;
    }
  }, {
    key: "_setFAQDefaults",
    // FAQ
    value: function _setFAQDefaults(dl) {
      dl.set('pageName', 'FAQ');
      return dl;
    }
  }, {
    key: "_setRequestAdditionalHelpDefaults",
    //Financial aid
    value: function _setRequestAdditionalHelpDefaults(dl) {
      dl.set('pageName', 'Financial aid');
      return dl;
    }
  }, {
    key: "_setContactDefaults",
    //Contact
    value: function _setContactDefaults(dl) {
      dl.set('pageName', 'Contact').set('viewChange', 'Contact');
      return dl;
    }
  }, {
    key: "_setRequestsDefaults",
    // Make a request
    value: function _setRequestsDefaults(dl) {
      dl.set('pageName', 'Requests');
      return dl;
    }
  }, {
    key: "_setMatchmakerLandingPageDefaults",
    // Matchmaker
    value: function _setMatchmakerLandingPageDefaults(dl) {
      dl.set('pageName', 'CRM Match maker landing page').set('viewChange', 'CRM Match maker landing page');
      return dl;
    }
  }, {
    key: "_setStartMatchmakerPageDefaults",
    value: function _setStartMatchmakerPageDefaults(dl) {
      dl.set('pageName', 'Match maker info page').set('viewChange', 'Match maker info page');
      return dl;
    }
  }, {
    key: "_setStartMatchmakerInteractionDefaults",
    value: function _setStartMatchmakerInteractionDefaults(dl) {
      dl.set('eventType', 'interAction').set('eventAction', 'Success').set('linkInformation', 'Go to Match maker info page');
      return dl;
    }
  }]);

  return Analytics;
}();

var AnalyticsTracker = function AnalyticsTracker(market, version, releaseDate) {
  var _this = this;

  _classCallCheck$1(this, AnalyticsTracker);

  _defineProperty$3(this, "analytics", void 0);

  _defineProperty$3(this, "clearTimeOut", function () {
    _this.analytics.clearTimeOut();
  });

  _defineProperty$3(this, "trackPageView", function (action, defaults, additionalValue, secondAdditionalValue, thirdAdditionalValue) {
    switch (action) {
      case 'contactDetailsHookPage':
        _this.analytics.contactDetailsHookPage.onContactDetailsHookPage(defaults);

        break;

      case 'kycHookPage':
        _this.analytics.kycHookPage.onKycHookPage(defaults);

        break;

      case 'onPayment':
        _this.analytics.dashboard.outstandingPayment.onPayment(defaults);

        break;

      case 'paymentSuccess':
        _this.analytics.dashboard.outstandingPayment.onPaymentSuccess(defaults);

        break;

      case 'paymentError':
        _this.analytics.dashboard.outstandingPayment.onPaymentNoSuccess(defaults);

        break;

      case 'requestCertificate':
        _this.analytics.requestCertificate.onRequestCertificate(defaults);

        break;

      case 'amortizationTable':
        _this.analytics.amortizationTable.onAmortizationTable(defaults);

        break;

      case 'irapCalculation':
        _this.analytics.irapPage.onIrapPage(defaults);

        break;

      case 'earlySettlement':
        _this.analytics.earlySettlement.onEarlySettlement(defaults);

        break;

      case 'earlySettlementSummaryPage':
        _this.analytics.earlySettlement.onEarlySettlementSummaryPage(defaults);

        break;

      case 'earlySettlementSimulation':
        _this.analytics.earlySettlement.onEarlySettlementSimulation(defaults);

        break;

      case 'earlySettlementDetails':
        _this.analytics.earlySettlement.onEarlySettlementDetails(defaults);

        break;

      case 'earlySettlementSummary':
        _this.analytics.earlySettlement.onEarlySettlementSummary(defaults);

        break;

      case 'earlySettlementGenerate':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementGenerate(additionalValue, defaults);

        break;

      case 'irapCalculation':
        _this.analytics.irapPage.onIrapPage(defaults);

        break;

      case 'earlySettlementEnquiry':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementEnquiry(additionalValue, defaults);

        break;

      case 'earlySettlementComplete':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementComplete(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'earlySettlementPaymentSuccess':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementPaymentSuccess(additionalValue, defaults);

        break;

      case 'earlySettlementPaymentError':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementPaymentError(additionalValue, defaults);

        break;

      case 'earlyTerminationLeasingContract':
        _this.analytics.earlyTermination.onEarlyTerminationLeasingContract(defaults);

        break;

      case 'earlyTerminationCreditContractView':
        _this.analytics.earlyTermination.onEarlyTerminationCreditContractView(defaults);

        break;

      case 'earlyTerminationCreditContract':
        _this.analytics.earlyTermination.onEarlyTerminationCreditContractUpload(defaults);

        break;

      case 'earlyTerminationCreditRequest':
        _this.analytics.earlyTermination.onEarlyTerminationCreditContractSendRequest(defaults);

        break;

      case 'authenticationVerification':
        _this.analytics.authenticationVerification.onVerificationPage(defaults);

        break;

      case 'confirmIdentity':
        _this.analytics.authentication.onConfirmIdentityPage(defaults);

        break;

      case 'enterSmsCode':
        _this.analytics.authenticationTan.onEnterSmsCode(defaults);

        break;

      case 'profile':
        _this.analytics.profile.onProfile(defaults, secondAdditionalValue);

        break;

      case 'editProfileDocumentUpload':
        _this.analytics.profile.onEditProfileDocumentUpload(additionalValue, defaults);

        break;

      case 'editProfileSectionDisplayed':
        _this.analytics.profile.onEditProfileSectionDisplayed(additionalValue, defaults);

        break;

      case 'dealerRequest':
        _this.analytics.dealerRequest.onDealerRequest(defaults);

        break;

      case 'dealerSelection':
        _this.analytics.dealerSelection.onDealerSelection(defaults);

        break;

      case 'digitalRenewalPage':
        _this.analytics.digitalRenewal.onDigitalRenewalPage(additionalValue, defaults);

        break;

      case 'marketingAgreement':
        _this.analytics.marketingAgreement.onMarketingAgreement(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'marketingAgreementNoEmail':
        _this.analytics.marketingAgreement.onMarketingAgreementNoEmail(defaults);

        break;

      case 'postbox':
        _this.analytics.postbox.onPostbox(defaults);

        break;

      case 'postboxInvoiceSignUp':
        _this.analytics.postbox.onPostboxInvoiceSignUpView(defaults);

        break;

      case 'faq':
        _this.analytics.faq.onFaq(defaults);

        break;

      case 'requestAdditionalHelpSituation':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpSituation(defaults);

        break;

      case 'requestAdditionalHelpIncomeAndExpenditure':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpIncomeAndExpenditure(defaults);

        break;

      case 'requestAdditionalHelpBreathingSpace':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpBreathingSpace(defaults);

        break;

      case 'requestAdditionalHelpArrangementToPay':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpArrangementToPay(defaults);

        break;

      case 'requestAdditionalHelpPromiseToPay':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpPromiseToPay(defaults);

        break;

      case 'requestAdditionalHelpEndAgreement':
        _this.analytics.requestAdditionalHelp.requestAdditionalHelpEndAgreement(defaults);

        break;

      case 'contact':
        _this.analytics.contact.onContact(defaults);

        break;

      case 'legalNotice':
        _this.analytics.legalNotice.onLegalNotice(defaults);

        break;

      case 'privacyPolicy':
        _this.analytics.privacyPolicy.onPrivacyPolicy(defaults);

        break;

      case 'cookiePolicy':
        _this.analytics.cookiePolicy.onCookiePolicy(defaults);

        break;

      case 'modernSlaveryStatement':
        _this.analytics.modernSlaveryStatement.onModernSlaveryStatement(defaults);

        break;

      case 'thirdPartyLicenses':
        _this.analytics.thirdPartyLicenses.onThirdPartyLicenses(defaults);

        break;

      case 'landingPage':
        _this.analytics.landingPage.onLandingPage(defaults, additionalValue);

        break;

      case 'landingPageOffer':
        _this.analytics.landingPage.onLandingPageOffer(defaults, additionalValue);

        break;

      case 'dashboard':
        _this.analytics.dashboard.outstandingPayment.onDashboard('', additionalValue, secondAdditionalValue, defaults);

        break;

      case 'dashboardAfterLogin':
        _this.analytics.dashboard.outstandingPayment.onDashboard('login', additionalValue, secondAdditionalValue, defaults);

        break;

      case 'dashboardWithoutUnpaid':
        _this.analytics.dashboard.onDashboardWithoutUnpaid(additionalValue, secondAdditionalValue, defaults, thirdAdditionalValue);

        break;

      case 'dashboardWithInactiveContracts':
        _this.analytics.dashboard.onDashboardWithInactiveContracts(defaults);

        break;

      case 'dashboardAfterRegistration':
        _this.analytics.dashboard.outstandingPayment.onDashboard('registration', additionalValue, secondAdditionalValue, defaults);

        break;

      case 'dashboardVehicleDetails':
        _this.analytics.dashboard.onVehicleDetails(defaults);

        break;

      case 'changePaymentDate':
        _this.analytics.dashboard.onChangePaymentDate(defaults);

        break;

      case 'silentContractExtension':
        _this.analytics.endOfContractPcp.silentContractExtension(defaults);

        break;

      case 'addContract':
        _this.analytics.dashboard.onAddContract(defaults);

        break;

      case 'filterPage':
        _this.analytics.dashboard.filterPage(defaults);

        break;

      case 'requestPrice':
        _this.analytics.endOfContractPcp.requestPrice(defaults);

        break;

      case 'dashboardEditSepa':
        _this.analytics.dashboardEdit.onSepa(defaults);

        break;

      case 'requests':
        _this.analytics.requests.onRequests(defaults);

        break;

      case 'onMotorTax':
        _this.analytics.motorPropertyTax.onMotorTax(defaults);

        break;

      case 'unpaidDetails':
        _this.analytics.dashboard.outstandingPayment.onOverview(defaults);

        break;

      case 'onShowCookiesLayer':
        _this.analytics.cookieWarning.onShowCookiesLayer(additionalValue, defaults);

        break;

      case 'introductionPage':
        _this.analytics.introduction.onIntroductionPage(defaults, additionalValue);

        break;

      case 'reportDamage':
        _this.analytics.reportDamage.onReportDamage(defaults);

        break;

      case 'reportDamageRepairApproval':
        _this.analytics.reportDamage.onRepairApproval(defaults);

        break;

      case 'reportDamageExpertReport':
        _this.analytics.reportDamage.onExpertReport(defaults);

        break;

      case 'reportDamageTotalLoss':
        _this.analytics.reportDamage.onTotalLoss(defaults);

        break;

      case 'reportDamageTheft':
        _this.analytics.reportDamage.onTheft(defaults);

        break;

      case 'onAutoLogout':
        _this.analytics.error.onAutoLogout(defaults, additionalValue);

        break;

      case 'endOfContractPcpStart':
        _this.analytics.endOfContractPcp.onEndOfContractPcpStart(defaults);

        break;

      case 'endOfContractPcpExchange':
        _this.analytics.endOfContractPcp.onEndOfContractPcpExchange(defaults);

        break;

      case 'endOfContractPcpKeep':
        _this.analytics.endOfContractPcp.onEndOfContractPcpKeep(defaults);

        break;

      case 'endOfContractPcpHandBack':
        _this.analytics.endOfContractPcp.onEndOfContractPcpHandBack(defaults);

        break;

      case 'endOfContractPcpRefinance':
        _this.analytics.endOfContractPcp.onEndOfContractPcpRefinance(defaults);

        break;

      case 'endOfContractPcpRefinanceSuccess':
        _this.analytics.endOfContractPcp.onEndOfContractPcpRefinanceSuccess(defaults);

        break;

      case 'endOfContractPcpRefinanceFailure':
        _this.analytics.endOfContractPcp.onEndOfContractPcpRefinanceFailure(defaults);

        break;

      case 'endOfContractPcpSell':
        _this.analytics.endOfContractPcp.onEndOfContractPcpSell(defaults);

        break;

      case 'endOfContractRchStart':
        _this.analytics.endOfContractRch.onEndOfContractRchStart(defaults);

        break;

      case 'endOfContractRchNew':
        _this.analytics.endOfContractRch.onEndOfContractRchNew(defaults);

        break;

      case 'endOfContractRchExtend':
        _this.analytics.endOfContractRch.onEndOfContractRchExtend(defaults);

        break;

      case 'endOfContractRchExtension':
        _this.analytics.endOfContractRch.onEndOfContractRchExtension(defaults);

        break;

      case 'endOfContractRchExtensionSuccess':
        _this.analytics.endOfContractRch.onEndOfContractRchExtensionSuccess(defaults);

        break;

      case 'endOfContractRchExtensionFailure':
        _this.analytics.endOfContractRch.onEndOfContractRchExtensionFailure(defaults);

        break;

      case 'endOfContractRchReturn':
        _this.analytics.endOfContractRch.onEndOfContractRchReturn(defaults);

        break;

      case 'endOfContractRchCallBack':
        _this.analytics.endOfContractRch.onEndOfContractRchCallBack(additionalValue, defaults);

        break;

      case 'endOfContractRchCallBackSuccess':
        _this.analytics.endOfContractRch.onEndOfContractRchCallBackSuccess(additionalValue, defaults);

        break;

      case 'endOfContractRchCallBackFailure':
        _this.analytics.endOfContractRch.onEndOfContractRchCallBackFailure(additionalValue, defaults);

        break;

      case 'useOurMatchmaker':
        _this.analytics.matchmaker.onUseOurMatchmaker(defaults, additionalValue);

        break;

      case 'startMatchmaker':
        _this.analytics.matchmaker.onStartMatchmaker(defaults);

        break;
    }
  });

  _defineProperty$3(this, "trackErrorPageView", function (action, defaults, additionalValue, secondAdditionalValue) {
    switch (action) {
      case 'onApiError':
        _this.analytics.error.onApiError(defaults, additionalValue, secondAdditionalValue);

        break;

      case 'unauthorizedError':
        _this.analytics.error.onNotAuthorizedError(defaults, additionalValue);

        break;

      case 'notFoundError':
        _this.analytics.error.onPageNotFoundError(defaults, additionalValue);

        break;

      case 'accessDeniedError':
        _this.analytics.error.onAccessDeniedError(defaults, additionalValue);

        break;

      case 'connectionProblemError':
        _this.analytics.error.onConnectionProblemError(defaults, additionalValue, secondAdditionalValue);

        break;
    }
  });

  _defineProperty$3(this, "trackAction", function (action, defaults, additionalValue, secondAdditionalValue, thirdAdditionalValue, forthAdditionalValue) {
    switch (action) {
      case 'login':
        _this.analytics.login.onShowLogin(defaults, additionalValue, secondAdditionalValue);

        break;

      case 'logout':
        _this.analytics.mainNavigation.onLogout(defaults, additionalValue, secondAdditionalValue);

        break;

      case 'dealerRequest':
        _this.analytics.mainNavigation.onDealerRequestClicked(defaults, additionalValue);

        break;

      case 'silentContractExtensionSubmit':
        _this.analytics.endOfContractPcp.silentContractExtensionSubmit(defaults);

        break;

      case 'onExternalLogin':
        _this.analytics.login.onExternalLogin(defaults, additionalValue);

        break;

      case 'onContactDetailsHookPageSubmitChanges':
        _this.analytics.contactDetailsHookPage.onSubmitChanges(defaults);

        break;

      case 'onContactDetailsHookPageNoChangesCancel':
        _this.analytics.contactDetailsHookPage.onNoChangesCancel(defaults);

        break;

      case 'onContactDetailsHookPageChangesCancel':
        _this.analytics.contactDetailsHookPage.onChangesCancel(defaults);

        break;

      case 'onContactDetailsHookPageCancel':
        _this.analytics.contactDetailsHookPage.onCancel(defaults);

        break;

      case 'onContactDetailsHookPageCancelAborted':
        _this.analytics.contactDetailsHookPage.onCancelAborted(defaults);

        break;

      case 'onKycHookPageNoContract':
        _this.analytics.kycHookPage.onNoContract(defaults);

        break;

      case 'onKycHookPageServicePhoneNumber':
        _this.analytics.kycHookPage.onServicePhoneNumber(defaults);

        break;

      case 'onClickEmailLink':
        _this.analytics.contactTeaser.onClickEmailLink(defaults, additionalValue, secondAdditionalValue);

        break;

      case 'onClickCallUsLink':
        _this.analytics.contactTeaser.onClickCallUsLink(defaults, additionalValue, secondAdditionalValue);

        break;

      case 'onPay':
        _this.analytics.dashboard.outstandingPayment.onPay(defaults);

        break;

      case 'onMotorTaxDownload':
        _this.analytics.motorPropertyTax.onMotorTaxDownload(defaults);

        break;

      case 'financialDetailsEditDueDateSection':
        _this.analytics.dashboardEdit.onEditDashboardSection('Financial Details', 'Change of due date', defaults);

        break;

      case 'financialDetailsEditDueDateSectionSuccess':
        _this.analytics.dashboardEdit.onSuccessEditDashboardSection('Financial Details', 'Change of due date', defaults);

        break;

      case 'financialDetailsEditDueDateSectionStartTyping':
        _this.analytics.dashboardEdit.onStartTypingEditDashboardSection('Financial Details', 'Change of due date', defaults);

        break;

      case 'financialDetailsEditDueDateSectionCancel':
        _this.analytics.dashboardEdit.onCancelEditDashboardSection('Financial Details', 'Change of due date', defaults);

        break;

      case 'financialDetailsEditDueDateSectionValidationError':
        _this.analytics.dashboardEdit.onFormValidationErrorEditDashboardSection('Financial Details', 'Change of due date', additionalValue, defaults);

        break;

      case 'financialDetailsEditDueDateSectionSubmitFailed':
        _this.analytics.dashboardEdit.onSubmitErrorEditDashboardSection('Financial Details', 'Change of due date', defaults);

        break;

      case 'financialDetailsEditDueDateSectionConfirmation':
        _this.analytics.dashboardEdit.onConfirmEditDashboardSection('Financial Details', 'Change of due date', defaults);

        break;

      case 'financialDetailsEditDueDateSectionConfirmationCancel':
        _this.analytics.dashboardEdit.onCancelConfirmationEditDashboardSection('Financial Details', 'Change of due date', defaults);

        break;

      case 'financialDetailsEditMileageSection':
        _this.analytics.dashboardEdit.onEditDashboardSection('Financial Details', 'Change of mileage', defaults);

        break;

      case 'financialDetailsEditMileageSectionSuccess':
        _this.analytics.dashboardEdit.onSuccessEditDashboardSection('Financial Details', 'Change of mileage', defaults);

        break;

      case 'financialDetailsEditMileageSectionStartTyping':
        _this.analytics.dashboardEdit.onStartTypingEditDashboardSection('Financial Details', 'Change of mileage', defaults);

        break;

      case 'financialDetailsEditMileageSectionCancel':
        _this.analytics.dashboardEdit.onCancelEditDashboardSection('Financial Details', 'Change of mileage', defaults);

        break;

      case 'financialDetailsEditMileageSectionValidationError':
        _this.analytics.dashboardEdit.onFormValidationErrorEditDashboardSection('Financial Details', 'Change of mileage', additionalValue, defaults);

        break;

      case 'financialDetailsEditMileageSectionSubmitFailed':
        _this.analytics.dashboardEdit.onSubmitErrorEditDashboardSection('Financial Details', 'Change of mileage', defaults);

        break;

      case 'financialDetailsEditIbanSection':
        _this.analytics.dashboardEdit.onEditDashboardSection('Financial Details', 'Payment Information', defaults);

        break;

      case 'financialDetailsEditIbanSectionSuccess':
        _this.analytics.dashboardEdit.onSuccessEditDashboardSection('Financial Details', 'Payment Information', defaults);

        break;

      case 'financialDetailsEditIbanSectionStartTyping':
        _this.analytics.dashboardEdit.onStartTypingEditDashboardSection('Financial Details', 'Payment Information', defaults);

        break;

      case 'financialDetailsEditIbanSectionCancel':
        _this.analytics.dashboardEdit.onCancelEditDashboardSection('Financial Details', 'Payment Information', defaults);

        break;

      case 'financialDetailsEditIbanSectionValidationError':
        _this.analytics.dashboardEdit.onFormValidationErrorEditDashboardSection('Financial Details', 'Payment Information', additionalValue, defaults);

        break;

      case 'financialDetailsEditIbanSectionSubmitFailed':
        _this.analytics.dashboardEdit.onSubmitErrorEditDashboardSection('Financial Details', 'Payment Information', defaults);

        break;

      case 'vehicleDetailsEditLicensePlate':
        _this.analytics.dashboardEdit.onEditDashboardSection('Vehicle Details', 'License Plate', defaults);

        break;

      case 'vehicleDetailsEditLicensePlateSuccess':
        _this.analytics.dashboardEdit.onSuccessEditDashboardSection('Vehicle Details', 'License Plate', defaults);

        break;

      case 'vehicleDetailsEditLicensePlateCancel':
        _this.analytics.dashboardEdit.onCancelEditDashboardSection('Vehicle Details', 'License Plate', defaults);

        break;

      case 'vehicleDetailsEditLicensePlateSubmitFailed':
        _this.analytics.dashboardEdit.onSubmitErrorEditDashboardSection('Vehicle Details', 'License Plate', defaults);

        break;

      case 'onLearnMore':
        _this.analytics.dashboard.onLearnMore(additionalValue, defaults);

        break;

      case 'chi':
        _this.analytics.dashboard.chi(defaults);

        break;

      case 'onReportDamage':
        _this.analytics.dashboard.onReportDamage(defaults);

        break;

      case 'onBankAccountUpdate':
        _this.analytics.dashboard.onBankAccountUpdateClick(defaults);

        break;

      case 'onContractActionEntryPointClick':
        _this.analytics.dashboard.onClickContractActionEntryPoint(additionalValue, defaults);

        break;

      case 'onRequestSubrogationActionEntryPointClick':
        _this.analytics.requestSubrogation.onClickEntryPointAction(additionalValue, defaults);

        break;

      case 'onEarlySettlementActionEntryPointClick':
        _this.analytics.earlySettlement.onClickEntryPointAction(additionalValue, defaults);

        break;

      case 'contractRecalculationOnSubmitSuccess':
        _this.analytics.contractRecalculation.onContractRecalculationFormSubmitSuccess(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onRequestCertificateSuccess':
        _this.analytics.requestCertificate.onSuccessRequestCertificate(additionalValue, defaults);

        break;

      case 'onRequestCertificateSubmitFailed':
        _this.analytics.requestCertificate.onRequestCertificateSubmitFailed(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onRequestCertificateSubmitAPIError':
        _this.analytics.requestCertificate.onRequestCertificateSubmitAPIError(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onOpenContractAccordion':
        _this.analytics.dashboardEdit.onOpenDashboardAccordion(additionalValue, defaults);

        break;

      case 'onStartTypingConfirmIdentity':
        _this.analytics.authentication.onStartTypingConfirmIdentityPage(defaults);

        break;

      case 'onFormValidationErrorConfirmIdentity':
        _this.analytics.authentication.onFormValidationErrorConfirmIdentityPage(additionalValue, defaults);

        break;

      case 'onConfirmConfirmIdentiy':
        _this.analytics.authentication.onConfirmConfirmIdentityPage(defaults);

        break;

      case 'onConfirmIdentiyAuthFailed':
        _this.analytics.authenticationFailed.onConfirmIdentityPageAuthFailed(defaults, additionalValue);

        break;

      case 'onCOVID19':
        _this.analytics.earlySettlement.onCOVID19(defaults, additionalValue);

        break;

      case 'onConfirmIdentiyAuthSuccess':
        _this.analytics.authentication.onConfirmIdentityPageConfirmSuccess(defaults, additionalValue);

        break;

      case 'onConfirmIdentityAuthTechnicalError':
        _this.analytics.authentication.onConfirmIdentityPageTechnicalError(defaults, additionalValue);

        break;

      case 'onConfirmIdentityAborted':
        _this.analytics.authenticationFailed.onConfirmIdentityAborted(additionalValue, defaults, secondAdditionalValue, thirdAdditionalValue);

        break;

      case 'onStartTypingVerificationPage':
        _this.analytics.authenticationVerification.onStartTypingVerificationPage(defaults);

        break;

      case 'onFormValidationErrorVerificationPage':
        _this.analytics.authenticationVerification.onFormValidationErrorVerificationPage(additionalValue, defaults);

        break;

      case 'onVerificationPageConfirm':
        _this.analytics.authenticationVerification.onVerificationPageConfirmButton(defaults);

        break;

      case 'onVerificationPageSuccess':
        _this.analytics.authenticationVerification.onVerificationPageConfirmSuccess(defaults, additionalValue);

        break;

      case 'onConfirmVerificationPageTechnicalError':
        _this.analytics.authenticationVerification.onConfirmVerificationPageTechnicalError(defaults, additionalValue);

        break;

      case 'onEditProfileIdentification':
        _this.analytics.profile.onEditProfile('Identification', defaults);

        break;

      case 'onEditProfileAddress':
        _this.analytics.profile.onEditProfile('Address', defaults);

        break;

      case 'onEditProfileContact':
        _this.analytics.profile.onEditProfile('Contact', defaults);

        break;

      case 'onEditProfileDealer':
        _this.analytics.profile.onEditProfile('Dealer', defaults);

        break;

      case 'onEditProfileConsentSettings':
        _this.analytics.profile.onEditProfile('Consent settings', defaults, additionalValue);

        break;

      case 'onEditProfileIdentificationSuccess':
        _this.analytics.profile.onEditProfileSuccess('Identification', defaults);

        break;

      case 'onEditProfileAddressSuccess':
        _this.analytics.profile.onEditProfileSuccess('Address', defaults);

        break;

      case 'onEditProfileContactSuccess':
        _this.analytics.profile.onEditProfileSuccess('Contact', defaults);

        break;

      case 'onEditProfileConsentSettingsSuccess':
        _this.analytics.profile.onEditProfileSuccess('Consent settings', defaults, additionalValue, secondAdditionalValue, thirdAdditionalValue);

        break;

      case 'onEditProfileIdentificationTypedIn':
        _this.analytics.profile.onEditProfileTypedIn('Identification', defaults);

        break;

      case 'onEditProfileAddressTypedIn':
        _this.analytics.profile.onEditProfileTypedIn('Address', defaults);

        break;

      case 'onEditProfileContactTypedIn':
        _this.analytics.profile.onEditProfileTypedIn('Contact', defaults);

        break;

      case 'onEditProfileConsentSettingsTypedIn':
        _this.analytics.profile.onEditProfileTypedIn('Consent settings', defaults, additionalValue);

        break;

      case 'onEditProfileCancel':
        _this.analytics.profile.onEditProfileCancel(additionalValue, defaults);

        break;

      case 'onEditProfileIdentificationValidationError':
        _this.analytics.profile.onEditProfileValidationError(additionalValue, 'Identification', defaults);

        break;

      case 'onEditProfileAddressValidationError':
        _this.analytics.profile.onEditProfileValidationError(additionalValue, 'Address', defaults);

        break;

      case 'onEditProfileContactValidationError':
        _this.analytics.profile.onEditProfileValidationError(additionalValue, 'Contact', defaults);

        break;

      case 'onEditProfileConsentSettingsValidationError':
        _this.analytics.profile.onEditProfileValidationError(additionalValue, 'Consent settings', defaults, secondAdditionalValue);

        break;

      case 'onEditProfileIdentificationSubmitFailed':
        _this.analytics.profile.onEditProfileSubmitFailed('Identification', defaults);

        break;

      case 'onEditProfileAddressSubmitFailed':
        _this.analytics.profile.onEditProfileSubmitFailed('Address', defaults);

        break;

      case 'onEditProfileContactSubmitFailed':
        _this.analytics.profile.onEditProfileSubmitFailed('Contact', defaults);

        break;

      case 'onEditProfileConsentSettingsSubmitFailed':
        _this.analytics.profile.onEditProfileSubmitFailed('Consent settings', defaults, additionalValue);

        break;

      case 'onEditProfileConfirmation':
        _this.analytics.profile.onEditProfileConfirmation(additionalValue, defaults);

        break;

      case 'onEditProfileConfirmationCancel':
        _this.analytics.profile.onEditProfileConfirmationCancel(additionalValue, defaults);

        break;

      case 'onEditProfileDownload':
        _this.analytics.profile.onEditProfileDownload(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onEditProfileDocumentUpload':
        _this.analytics.profile.onEditProfileDocumentUpload(additionalValue, defaults);

        break;

      case 'onEditProfileDocumentUploadFailed':
        _this.analytics.profile.onEditProfileDocumentUploadFailed(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onDeleteAccountSuccess':
        _this.analytics.profile.onDeleteAccountSuccess(defaults);

        break;

      case 'onConfirmDeleteAccount':
        _this.analytics.profile.onConfirmDeleteAccount(defaults);

        break;

      case 'onConfirmDeleteAccountSuccess':
        _this.analytics.profile.onConfirmDeleteAccountSuccess(defaults, additionalValue);

        break;

      case 'onDealerCall':
        _this.analytics.profile.onCallDealerClicked(defaults);

        break;

      case 'onCallDealerRequest':
        _this.analytics.profile.onCallDealerRequest(defaults);

        break;

      case 'onEditEarlySettlementSummaryLayerSuccess':
        _this.analytics.earlySettlement.onEarlySettlementSummaryLayerDisplayed(defaults);

        break;

      case 'onEarlySettlementSummarySubmitFailed':
        _this.analytics.earlySettlement.onEarlySettlementSummarySubmitFailed(defaults, additionalValue);

        break;

      case 'onEarlySettlementProceedToPayment':
        _this.analytics.earlySettlement.onEarlySettlementProceedToPayment(defaults);

        break;

      case 'onEarlySettlementCalculate':
        _this.analytics.earlySettlement.onEarlySettlementCalculate(defaults);

        break;

      case 'onEarlyTerminationContractValidationError':
        _this.analytics.earlyTermination.onEarlyTerminationCreditContractValidationError(additionalValue, defaults);

        break;

      case 'onOpenEarlySettlementDetails':
        _this.analytics.earlySettlement.onEarlySettlementDetails(defaults);

        break;

      case 'onOpenEarlySettlementSimulation':
        _this.analytics.earlySettlement.onEarlySettlementSimulation(defaults);

        break;

      case 'onOpenSuspendInstallment':
        _this.analytics.dashboard.onOpenSuspendInstallment(defaults);

        break;

      case 'onDashboardChangePaymentDate':
        _this.analytics.dashboard.onDashboardChangePaymentDate(defaults);

        break;

      case 'onAddContractError':
        _this.analytics.dashboard.onAddContractError(defaults);

        break;

      case 'onMonthlyPaymentInfoTip':
        _this.analytics.dashboard.onMonthlyPaymentInfoTip(defaults);

        break;

      case 'onCancelContract':
        _this.analytics.dashboard.onCancelNonStandardContract(defaults);

        break;

      case 'onChangePaymentDateSubmit':
        _this.analytics.dashboard.onChangePaymentDateSubmit(defaults);

        break;

      case 'onDealerRequestSuccess':
        _this.analytics.dealerRequest.onDealerRequestSuccess(defaults, additionalValue);

        break;

      case 'onDealerCardChoose':
        _this.analytics.dealerCard.onChooseDealer(defaults, additionalValue);

        break;

      case 'onDealerCardChange':
        _this.analytics.dealerCard.onChangeDealer(defaults, additionalValue);

        break;

      case 'onDealerCardRequest':
        _this.analytics.dealerCard.onRequestDealer(defaults, additionalValue);

        break;

      case 'onDealerRequestFailed':
        _this.analytics.dealerRequest.onDealerRequestFailed(defaults, additionalValue, secondAdditionalValue);

        break;

      case 'onDealerSelectionSave':
        _this.analytics.dealerSelection.onDealerSelectionSave(defaults);

        break;

      case 'onDealerSelectionCall':
        _this.analytics.dealerSelection.onDealerSelectionCall(defaults);

        break;

      case 'onMarketingAgreementSaveYes':
        _this.analytics.marketingAgreement.onMarketingAgreementSaveYes(defaults, additionalValue);

        break;

      case 'onMarketingAgreementSaveNo':
        _this.analytics.marketingAgreement.onMarketingAgreementSaveNo(defaults);

        break;

      case 'onMarketingAgreementSubmitChanges':
        _this.analytics.marketingAgreement.onMarketingAgreementSubmitChanges(defaults);

        break;

      case 'onMarketingAgreementCancelWithoutChanges':
        _this.analytics.marketingAgreement.onMarketingAgreementCancelWithoutChanges(defaults);

        break;

      case 'onMarketingAgreementChanged':
        _this.analytics.marketingAgreement.onMarketingAgreementChanged(defaults, additionalValue, secondAdditionalValue, thirdAdditionalValue, forthAdditionalValue);

        break;

      case 'onDashboardEditBankAccountChange':
        _this.analytics.dashboardEdit.onBankAccountChange(defaults);

        break;

      case 'onDashboardEditSepaSign':
        _this.analytics.dashboardEdit.onSepaSign(defaults);

        break;

      case 'onDashboardEditSepaSignSuccess':
        _this.analytics.dashboardEdit.onSepaSignSuccess(defaults);

        break;

      case 'onDashboardEditSepaSignError':
        _this.analytics.dashboardEdit.onSepaSignError(defaults);

        break;

      case 'onPostboxDownload':
        _this.analytics.postbox.onPostboxDownload(additionalValue, defaults);

        break;

      case 'onPostboxDownloadError':
        _this.analytics.postbox.onPostboxDownloadError(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onPostboxInvoiceSignUpCancel':
        _this.analytics.postbox.onPostboxInvoiceSignUpCancel(defaults);

        break;

      case 'onPostboxInvoiceSignUpConfirm':
        _this.analytics.postbox.onPostboxInvoiceSignUpConfirm(defaults);

        break;

      case 'onPostboxDownloadErrorInvoiceDeactivated':
        _this.analytics.postbox.onPostboxDownloadErrorInvoiceDeactivated(defaults);

        break;

      case 'onClickMarketingCard':
        _this.analytics.landingPage.onClickMarketingCard(additionalValue, defaults);

        break;

      case 'onHeyCarLinkClick':
        _this.analytics.earlySettlement.onHeyCarLinkClick(defaults);

        break;

      case 'onRequestsSuccess':
        _this.analytics.requests.onRequestSuccess(defaults, additionalValue);

        break;

      case 'onRequestsError':
        _this.analytics.requests.onRequestFailure(defaults, additionalValue);

        break;

      case 'sepaMandateDownloadError':
        _this.analytics.dashboardEdit.sepaMandate.sepaMandateDownloadError(defaults, additionalValue, secondAdditionalValue);

        break;

      case 'onSepaMandateDownload':
        _this.analytics.dashboardEdit.sepaMandate.onSepaMandateDownload(defaults, additionalValue);

        break;

      case 'onAmortizationTableDownload':
        _this.analytics.amortizationTable.onAmortizationTableDownload(defaults);

        break;

      case 'onBundledProductsDownload':
        _this.analytics.amortizationTable.onBundledProductsDownload(defaults, additionalValue);

        break;

      case 'onFaqQuestion':
        _this.analytics.faq.onFaqQuestion(additionalValue, defaults);

        break;

      case 'onRequestAdditionalHelpIncomeAndExpenditurePrint':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpIncomeAndExpenditurePrint(defaults);

        break;

      case 'onRequestAdditionalHelpSubmitSuccess':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpSubmitSuccess(defaults);

        break;

      case 'onRequestAdditionalHelpSubmitFailed':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpSubmitFailed(defaults);

        break;

      case 'onRequestAdditionalHelpBack':
        _this.analytics.requestAdditionalHelp.onRequestAdditionalHelpBack(defaults);

        break;

      case 'onContactSubmitSuccess':
        _this.analytics.contact.onContactSubmitSuccess(additionalValue, defaults);

        break;

      case 'onContactSubmitFailed':
        _this.analytics.contact.onContactSubmitFailed(additionalValue, defaults);

        break;

      case 'onEarlySettlementGenerateQuote':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementGenerateQuote(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onEarlySettlementEnquiryPrint':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementEnquiryPrint(additionalValue, defaults);

        break;

      case 'onEarlySettlementCompletePrint':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementCompletePrint(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onEarlySettlementPaymentSelectBankTransfer':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementPaymentSelectBankTransfer(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onEarlySettlementPaymentProceedToPayByCard':
        _this.analytics.earlySettlement.hirePurchase.onEarlySettlementPaymentProceedToPayByCard(additionalValue, secondAdditionalValue, defaults);

        break;

      case 'onAcceptCookies':
        _this.analytics.cookieWarning.onAcceptCookies(additionalValue, defaults);

        break;

      case 'onShowCookiePolicy':
        _this.analytics.cookieWarning.onShowCookiePolicy(additionalValue, defaults);

        break;

      case 'onEnterSmsCodeSuccess':
        _this.analytics.authenticationTan.onEnterSmsCodeSuccess(defaults, additionalValue);

        break;

      case 'onRepairApprovalSuccess':
        _this.analytics.reportDamage.onRepairApprovalSuccess(defaults);

        break;

      case 'onRepairApprovalFailure':
        _this.analytics.reportDamage.onRepairApprovalFailure(additionalValue, defaults);

        break;

      case 'onIrapDownload':
        _this.analytics.irapPage.onIrapDownload(defaults);

        break;

      case 'onExpertReportSuccess':
        _this.analytics.reportDamage.onExpertReportSuccess(defaults);

        break;

      case 'onExpertReportFailure':
        _this.analytics.reportDamage.onExpertReportFailure(additionalValue, defaults);

        break;

      case 'onIrapDownload':
        _this.analytics.irapPage.onIrapDownload(defaults);

        break;

      case 'onExpertReportInsuranceClaimDownload':
        _this.analytics.reportDamage.onExpertReportInsuranceClaimDownload(defaults);

        break;

      case 'onTotalLossSuccess':
        _this.analytics.reportDamage.onTotalLossSuccess(defaults);

        break;

      case 'onTotalLossFailure':
        _this.analytics.reportDamage.onTotalLossFailure(additionalValue, defaults);

        break;

      case 'onTotalLossInsuranceClaimDownload':
        _this.analytics.reportDamage.onTotalLossInsuranceClaimDownload(defaults);

        break;

      case 'onTotalLossEarlySettlementRedirect':
        _this.analytics.reportDamage.onTotalLossEarlySettlementRedirect(defaults);

        break;

      case 'onTheftSuccess':
        _this.analytics.reportDamage.onTheftSuccess(defaults);

        break;

      case 'onTheftFailure':
        _this.analytics.reportDamage.onTheftFailure(additionalValue, defaults);

        break;

      case 'onTheftInsuranceClaimDownload':
        _this.analytics.reportDamage.onTheftInsuranceClaimDownload(defaults);

        break;

      case 'onTheftRequestRegistrationCertRedirect':
        _this.analytics.reportDamage.onTheftRequestRegistrationCertRedirect(defaults);

        break;

      case 'onEndOfContractPcpExchangeContactRetailer':
        _this.analytics.endOfContractPcp.onEndOfContractPcpExchangeContactRetailer(defaults);

        break;

      case 'onRequestPriceSubmit':
        _this.analytics.endOfContractPcp.onRequestPriceSubmit(defaults);

        break;

      case 'onEndOfContractPcpExchangeRequestCallback':
        _this.analytics.endOfContractPcp.onEndOfContractPcpExchangeRequestCallback(defaults);

        break;

      case 'onEndOfContractPcpExchangeFinanceOffers':
        _this.analytics.endOfContractPcp.onEndOfContractPcpExchangeFinanceOffers(defaults);

        break;

      case 'onEndOfContractPcpExchangeConfigurator':
        _this.analytics.endOfContractPcp.onEndOfContractPcpExchangeConfigurator(defaults);

        break;

      case 'onEndOfContractPcpExchangeBack':
        _this.analytics.endOfContractPcp.onEndOfContractPcpExchangeBack(defaults);

        break;

      case 'onEndOfContractPcpExchangeDashboard':
        _this.analytics.endOfContractPcp.onEndOfContractPcpExchangeDashboard(defaults);

        break;

      case 'onEndOfContractPcpKeepBack':
        _this.analytics.endOfContractPcp.onEndOfContractPcpKeepBack(defaults);

        break;

      case 'onEndOfContractPcpKeepDashboard':
        _this.analytics.endOfContractPcp.onEndOfContractPcpKeepDashboard(defaults);

        break;

      case 'onEndOfContractPcpHandBackPersonalisedPlates':
        _this.analytics.endOfContractPcp.onEndOfContractPcpHandBackPersonalisedPlates(additionalValue, defaults);

        break;

      case 'onEndOfContractPcpHandBackBvrlaGuidelines':
        _this.analytics.endOfContractPcp.onEndOfContractPcpHandBackBvrlaGuidelines(additionalValue, defaults);

        break;

      case 'onEndOfContractPcpHandBackEndOfContractCharges':
        _this.analytics.endOfContractPcp.onEndOfContractPcpHandBackEndOfContractCharges(additionalValue, defaults);

        break;

      case 'onEndOfContractPcpHandBackBack':
        _this.analytics.endOfContractPcp.onEndOfContractPcpHandBackBack(defaults);

        break;

      case 'onEndOfContractPcpHandBackDashboard':
        _this.analytics.endOfContractPcp.onEndOfContractPcpHandBackDashboard(defaults);

        break;

      case 'onEndOfContractPcpRefinanceBack':
        _this.analytics.endOfContractPcp.onEndOfContractPcpRefinanceBack(defaults);

        break;

      case 'onEndOfContractPcpRefinanceRequest':
        _this.analytics.endOfContractPcp.onEndOfContractPcpRefinanceRequest(defaults);

        break;

      case 'onEndOfContractPcpSellBack':
        _this.analytics.endOfContractPcp.onEndOfContractPcpSellBack(defaults);

        break;

      case 'onEndOfContractPcpSellDashboard':
        _this.analytics.endOfContractPcp.onEndOfContractPcpSellDashboard(defaults);

        break;

      case 'onEndOfContractPcpSellInspect':
        _this.analytics.endOfContractPcp.onEndOfContractPcpSellInspect(additionalValue, defaults);

        break;

      case 'onEndOfContractRchNewContactRetailer':
        _this.analytics.endOfContractRch.onEndOfContractRchNewContactRetailer(defaults);

        break;

      case 'onEndOfContractRchNewFinanceOffers':
        _this.analytics.endOfContractRch.onEndOfContractRchNewFinanceOffers(defaults);

        break;

      case 'onEndOfContractRchNewNewFromStock':
        _this.analytics.endOfContractRch.onEndOfContractRchNewNewFromStock(defaults);

        break;

      case 'onEndOfContractRchNewConfigurator':
        _this.analytics.endOfContractRch.onEndOfContractRchNewConfigurator(defaults);

        break;

      case 'onEndOfContractRchNewBack':
        _this.analytics.endOfContractRch.onEndOfContractRchNewBack(defaults);

        break;

      case 'onEndOfContractRchNewDashboard':
        _this.analytics.endOfContractRch.onEndOfContractRchNewDashboard(defaults);

        break;

      case 'onEndOfContractRchExtendShortTermExtension':
        _this.analytics.endOfContractRch.onEndOfContractRchExtendShortTermExtension(defaults);

        break;

      case 'onEndOfContractRchExtendFormalExtension':
        _this.analytics.endOfContractRch.onEndOfContractRchExtendFormalExtension(defaults);

        break;

      case 'onEndOfContractRchExtendBack':
        _this.analytics.endOfContractRch.onEndOfContractRchExtendBack(defaults);

        break;

      case 'onEndOfContractRchExtendDashboard':
        _this.analytics.endOfContractRch.onEndOfContractRchExtendDashboard(defaults);

        break;

      case 'onEndOfContractRchExtensionBack':
        _this.analytics.endOfContractRch.onEndOfContractRchExtensionBack(defaults);

        break;

      case 'onEndOfContractRchExtensionRequest':
        _this.analytics.endOfContractRch.onEndOfContractRchExtensionRequest(additionalValue, defaults);

        break;

      case 'onEndOfContractRchReturnBvrlaGuidelines':
        _this.analytics.endOfContractRch.onEndOfContractRchReturnBvrlaGuidelines(additionalValue, defaults);

        break;

      case 'onEndOfContractRchReturnEndOfContractCharges':
        _this.analytics.endOfContractRch.onEndOfContractRchReturnEndOfContractCharges(additionalValue, defaults);

        break;

      case 'onEndOfContractRchReturnBack':
        _this.analytics.endOfContractRch.onEndOfContractRchReturnBack(defaults);

        break;

      case 'onEndOfContractRchReturnDashboard':
        _this.analytics.endOfContractRch.onEndOfContractRchReturnDashboard(defaults);

        break;

      case 'onEndOfContractRchCallBackBack':
        _this.analytics.endOfContractRch.onEndOfContractRchCallBackBack(additionalValue, defaults);

        break;

      case 'onEndOfContractRchCallBackRequest':
        _this.analytics.endOfContractRch.onEndOfContractRchCallBackRequest(additionalValue, defaults);

        break;

      case 'onDigitalRenewalStart':
        _this.analytics.digitalRenewal.onDigitalRenewalStart(additionalValue, defaults);

        break;

      case 'onDashboardDigitalRenewal':
        _this.analytics.dashboard.onDashboardDigitalRenewal(defaults);

        break;

      case 'onEndOfContractPcpRenewalSelected':
        _this.analytics.endOfContractPcp.onEndOfContractPcpRenewalSelected(defaults);

        break;

      case 'onEndOfContractPcpDealerData':
        _this.analytics.endOfContractPcp.onEndOfContractPcpDealerData(defaults, additionalValue);

        break;

      case 'onMatchmakerLogin':
        _this.analytics.matchmaker.onMatchmakerLogin(defaults);

        break;

      case 'onDashboardStartMatchmaker':
        _this.analytics.dashboard.onDashboardStartMatchmaker(defaults);

        break;

      case 'onEndOfContractRchStartMatchmaker':
        _this.analytics.endOfContractRch.onEndOfContractRchStartMatchmaker(defaults);

        break;

      case 'onEndOfContractPcpStartMatchmaker':
        _this.analytics.endOfContractPcp.onEndOfContractPcpStartMatchmaker(defaults);

        break;

      case 'onContinueToMatchmaker':
        _this.analytics.matchmaker.onContinueToMatchmaker(defaults);

        break;
    }
  });

  this.analytics = new Analytics(market, version, releaseDate);
};

var AnalyticsContext = /*#__PURE__*/createContext({});
// Provides context for analytics hooks (wrap around MainPage.tsx)
var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var children = _ref.children,
      userGroup = _ref.userGroup,
      privacyStatement = _ref.privacyStatement,
      isAuthenticated = _ref.isAuthenticated,
      brand = _ref.brand,
      market = _ref.market,
      version = _ref.version,
      releaseDate = _ref.releaseDate,
      language = _ref.language,
      registrationPath = _ref.registrationPath,
      loginPath = _ref.loginPath,
      productId = _ref.productId;
  var tracker = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInitialized = _useState2[0],
      setIsInitialized = _useState2[1];

  useEffect(function () {
    tracker.current = new AnalyticsTracker(market, version, releaseDate); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

    !isInitialized && setIsInitialized(true);
    return function cleanup() {
      var _tracker$current;

      (_tracker$current = tracker.current) === null || _tracker$current === void 0 ? void 0 : _tracker$current.clearTimeOut();
    };
  }, [tracker]);
  if (!tracker.current) return null;
  var _tracker$current2 = tracker.current,
      trackAction = _tracker$current2.trackAction,
      trackErrorPageView = _tracker$current2.trackErrorPageView,
      trackPageView = _tracker$current2.trackPageView;
  return /*#__PURE__*/React__default.createElement(AnalyticsContext.Provider, {
    value: {
      trackAction: trackAction,
      trackPageView: trackPageView,
      trackErrorPageView: trackErrorPageView,
      userGroup: userGroup,
      privacyStatement: privacyStatement,
      isAuthenticated: isAuthenticated,
      brand: brand,
      language: language,
      registrationPath: registrationPath,
      loginPath: loginPath,
      productId: productId
    }
  }, children);
};

// Track page views
var useAnalyticsPageViewTracker = function useAnalyticsPageViewTracker(trackingId) {
  var dataLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var additionalValue = arguments.length > 2 ? arguments[2] : undefined;
  var secondAdditionalValue = arguments.length > 3 ? arguments[3] : undefined;
  var thirdAdditionalValue = arguments.length > 4 ? arguments[4] : undefined;

  var _useContext = useContext(AnalyticsContext),
      trackPageView = _useContext.trackPageView,
      userGroup = _useContext.userGroup,
      privacyStatement = _useContext.privacyStatement,
      isAuthenticated = _useContext.isAuthenticated,
      brand = _useContext.brand,
      language = _useContext.language,
      productId = _useContext.productId;

  var viewTracked = useRef(false);
  useEffect(function () {
    // Wait until data are loaded to avoid multiple trackings due to several component mounts/unmounts
    if (trackPageView && !viewTracked.current && dataLoaded) {
      trackPageView(trackingId, {
        currentLanguage: language,
        privacyStatement: privacyStatement,
        userGroup: userGroup,
        loginStatus: isAuthenticated,
        currentBrand: brand,
        productId: productId
      }, additionalValue, secondAdditionalValue, thirdAdditionalValue);
    }
  }, [dataLoaded, language, privacyStatement, userGroup, isAuthenticated, trackingId, additionalValue, brand]);
}; // Track error page views

var useAnalyticsErrorPageTracker = function useAnalyticsErrorPageTracker(trackingId) {
  var _window$location;

  var dataLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var secondAdditionalValue = arguments.length > 2 ? arguments[2] : undefined;

  var _useContext2 = useContext(AnalyticsContext),
      trackErrorPageView = _useContext2.trackErrorPageView,
      userGroup = _useContext2.userGroup,
      privacyStatement = _useContext2.privacyStatement,
      isAuthenticated = _useContext2.isAuthenticated,
      brand = _useContext2.brand,
      language = _useContext2.language,
      productId = _useContext2.productId;

  var viewTracked = useRef(false);
  var lastLocation = useLastLocation();
  var origin = ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin) || '';
  var lastPathname = origin + ((lastLocation === null || lastLocation === void 0 ? void 0 : lastLocation.pathname) || '');
  useEffect(function () {
    if (trackErrorPageView && !viewTracked.current && dataLoaded) {
      trackErrorPageView(trackingId, {
        currentLanguage: language,
        privacyStatement: privacyStatement,
        userGroup: userGroup,
        loginStatus: isAuthenticated,
        currentBrand: brand,
        productId: productId
      }, lastPathname, secondAdditionalValue);
      viewTracked.current = true;
    }
  }, [dataLoaded, language, privacyStatement, userGroup, isAuthenticated, trackingId, lastPathname, brand]);
};
// Track actions (e.g. button click)
var useAnalyticsActionTracker = function useAnalyticsActionTracker(action) {
  var _useContext3 = useContext(AnalyticsContext),
      trackAction = _useContext3.trackAction,
      userGroup = _useContext3.userGroup,
      privacyStatement = _useContext3.privacyStatement,
      isAuthenticated = _useContext3.isAuthenticated,
      brand = _useContext3.brand,
      language = _useContext3.language,
      productId = _useContext3.productId;

  var onAction = useMemo(function () {
    return function (additionalValue, secondAdditionalValue, thirdAdditionalValue, forthAdditionalValue) {
      if (trackAction) {
        trackAction(action, {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          userGroup: userGroup,
          loginStatus: isAuthenticated,
          currentBrand: brand,
          productId: productId
        }, additionalValue, secondAdditionalValue, thirdAdditionalValue, forthAdditionalValue);
      }
    };
  }, [action, language, privacyStatement, userGroup, isAuthenticated, brand]);
  return {
    onAction: onAction
  };
}; // Track if element enters view (e.g. open accordion element)
// isActive: set to false if it is needed to block this action for inactive contracts

var useAnalyticsEnterViewportTracker = function useAnalyticsEnterViewportTracker(trackActionId, elementName) {
  var isActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _useInView = useInView(),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var actionPerformed = useRef(false);

  var _useContext4 = useContext(AnalyticsContext),
      trackAction = _useContext4.trackAction,
      userGroup = _useContext4.userGroup,
      privacyStatement = _useContext4.privacyStatement,
      isAuthenticated = _useContext4.isAuthenticated,
      brand = _useContext4.brand,
      language = _useContext4.language,
      productId = _useContext4.productId;

  useEffect(function () {
    if (trackAction && inView && !actionPerformed.current && isActive) {
      trackAction(trackActionId, {
        currentLanguage: language,
        privacyStatement: privacyStatement,
        userGroup: userGroup,
        loginStatus: isAuthenticated,
        currentBrand: brand,
        productId: productId
      }, elementName);
      actionPerformed.current = true;
    }

    if (!inView && actionPerformed.current) {
      actionPerformed.current = false;
    }
  }, [inView, language, privacyStatement, userGroup, elementName, isAuthenticated, brand]);
  return {
    ref: ref
  };
};

var getErrors = function getErrors(errors, touched) {
  var errorVals = {};

  for (var _i = 0, _Object$keys = Object.keys(errors); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    if (touched[key]) {
      errorVals[key] = errors[key];
    }
  }

  return errorVals;
};

// Track form actions (typing, submitting, error)
var useAnalyticsFormTracker = function useAnalyticsFormTracker(trackingIds) {
  var _useContext5 = useContext(AnalyticsContext),
      trackAction = _useContext5.trackAction,
      userGroup = _useContext5.userGroup,
      privacyStatement = _useContext5.privacyStatement,
      isAuthenticated = _useContext5.isAuthenticated,
      brand = _useContext5.brand,
      language = _useContext5.language,
      productId = _useContext5.productId;

  var typingStarted = useRef(false);
  var errorValues = useRef('');
  var onTyping = useMemo(function () {
    return function (errors, touched, additionalValue) {
      if (trackAction && (trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.startTyping) && !typingStarted.current) {
        trackAction(trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.startTyping, {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          userGroup: userGroup,
          loginStatus: isAuthenticated,
          currentBrand: brand,
          productId: productId
        }, additionalValue);
        typingStarted.current = true;
      }

      if (errors && touched && trackAction && (trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.formValidationError)) {
        var errorVals = getErrors(errors, touched);
        var stringifiedErrorVals = Object.keys(errorVals).map(function (k) {
          return "".concat(k, ": ").concat(errorVals[k]);
        }).join('|').toString();

        if (stringifiedErrorVals && stringifiedErrorVals !== errorValues.current) {
          errorValues.current = stringifiedErrorVals;
          trackAction(trackingIds.formValidationError, {
            currentLanguage: language,
            privacyStatement: privacyStatement,
            userGroup: userGroup,
            loginStatus: isAuthenticated,
            currentBrand: brand,
            productId: productId
          }, stringifiedErrorVals, additionalValue);
        }
      }
    };
  }, [language, privacyStatement, userGroup, isAuthenticated, brand]);
  var onConfirmError = useMemo(function () {
    return function (errors, touched, additionalValue) {
      var errorVals = getErrors(errors, touched);
      var stringifiedErrorVals = Object.keys(errorVals).map(function (k) {
        return "".concat(k, ": ").concat(errorVals[k]);
      }).join('|').toString();

      if (trackAction && (trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.formValidationError) && stringifiedErrorVals) {
        errorValues.current = stringifiedErrorVals;
        trackAction(trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.formValidationError, {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          userGroup: userGroup,
          loginStatus: isAuthenticated,
          currentBrand: brand,
          productId: productId
        }, stringifiedErrorVals, additionalValue);
      }
    };
  }, [language, privacyStatement, userGroup, isAuthenticated, brand]);
  var onSubmit = useMemo(function () {
    return function (additionalValue) {
      if (trackAction && (trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.confirm)) {
        trackAction(trackingIds.confirm, {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          userGroup: userGroup,
          loginStatus: isAuthenticated,
          currentBrand: brand,
          productId: productId
        }, additionalValue);
      }
    };
  }, [language, privacyStatement, userGroup, isAuthenticated, brand]);
  var onError = useMemo(function () {
    return function (additionalValue) {
      if (trackAction && (trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.confirmError)) {
        trackAction(trackingIds.confirmError, {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          userGroup: userGroup,
          loginStatus: isAuthenticated,
          currentBrand: brand,
          productId: productId
        }, additionalValue);
      }
    };
  }, [language, privacyStatement, userGroup, isAuthenticated, brand]);
  var onSuccess = useMemo(function () {
    return function (additionalValue, secondAdditionalValue) {
      if (trackAction && (trackingIds === null || trackingIds === void 0 ? void 0 : trackingIds.confirmSuccess)) {
        trackAction(trackingIds.confirmSuccess, {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          userGroup: userGroup,
          loginStatus: isAuthenticated,
          currentBrand: brand,
          productId: productId
        }, additionalValue, '', secondAdditionalValue);
      }
    };
  }, [language, privacyStatement, userGroup, isAuthenticated, brand]);
  return {
    onTyping: onTyping,
    onSubmit: onSubmit,
    onError: onError,
    onSuccess: onSuccess,
    onConfirmError: onConfirmError
  };
}; // Tracks dashboard page views depending on previous location and availability of unpaid details

var useAnalyticsDashboardPageTracker = function useAnalyticsDashboardPageTracker() {
  var dataLoaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var unpaid = arguments.length > 1 ? arguments[1] : undefined;
  var lastPathName = arguments.length > 2 ? arguments[2] : undefined;
  var isDigitalRenewal = arguments.length > 3 ? arguments[3] : undefined;
  var viewTracked = useRef(false);
  var lastLocation = useLastLocation();
  var defaultLastPathName = lastLocation === null || lastLocation === void 0 ? void 0 : lastLocation.pathname;

  var _useContext6 = useContext(AnalyticsContext),
      trackPageView = _useContext6.trackPageView,
      userGroup = _useContext6.userGroup,
      privacyStatement = _useContext6.privacyStatement,
      isAuthenticated = _useContext6.isAuthenticated,
      brand = _useContext6.brand,
      language = _useContext6.language,
      registrationPath = _useContext6.registrationPath,
      loginPath = _useContext6.loginPath,
      productId = _useContext6.productId;

  useEffect(function () {
    if (dataLoaded && !viewTracked.current) {
      if (lastPathName) {
        defaultLastPathName = lastPathName;
      }

      var login = loginPath && defaultLastPathName === loginPath;
      var register = registrationPath && defaultLastPathName === registrationPath;
      var trackingId = login ? 'dashboardAfterLogin' : register ? 'dashboardAfterRegistration' : 'dashboard';

      if (trackPageView) {
        trackPageView(trackingId, {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          loginStatus: isAuthenticated,
          userGroup: userGroup,
          currentBrand: brand,
          productId: productId
        }, unpaid, isDigitalRenewal);
      }

      viewTracked.current = true;
    }
  }, [dataLoaded, unpaid, language, privacyStatement, userGroup, defaultLastPathName, isAuthenticated, brand, isDigitalRenewal]);
}; // Tracks dashboard page views depending on previous location without availability of unpaid details

var useAnalyticsDashboardPageTrackerWithoutUnpaid = function useAnalyticsDashboardPageTrackerWithoutUnpaid() {
  var dataLoaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var lastPathName = arguments.length > 1 ? arguments[1] : undefined;
  var isDigitalRenewal = arguments.length > 2 ? arguments[2] : undefined;
  var bankAccountUpdate = arguments.length > 3 ? arguments[3] : undefined;
  var viewTracked = useRef(false);

  var _useContext7 = useContext(AnalyticsContext),
      trackPageView = _useContext7.trackPageView,
      userGroup = _useContext7.userGroup,
      privacyStatement = _useContext7.privacyStatement,
      isAuthenticated = _useContext7.isAuthenticated,
      brand = _useContext7.brand,
      language = _useContext7.language,
      registrationPath = _useContext7.registrationPath,
      loginPath = _useContext7.loginPath,
      productId = _useContext7.productId;

  useEffect(function () {
    if (dataLoaded && !viewTracked.current) {
      var login = loginPath && lastPathName === loginPath;
      var register = registrationPath && lastPathName === registrationPath;
      var fromPath = login ? 'login' : register ? 'registration' : '';

      if (trackPageView) {
        trackPageView('dashboardWithoutUnpaid', {
          currentLanguage: language,
          privacyStatement: privacyStatement,
          loginStatus: isAuthenticated,
          userGroup: userGroup,
          currentBrand: brand,
          productId: productId
        }, fromPath, isDigitalRenewal, bankAccountUpdate);
      }

      viewTracked.current = true;
    }
  }, [dataLoaded, language, privacyStatement, userGroup, lastPathName, isAuthenticated, brand, isDigitalRenewal, bankAccountUpdate]);
};
var useAnalyticsHookPageViewTracker = function useAnalyticsHookPageViewTracker(trackingId) {
  var dataLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var lastPathName = arguments.length > 2 ? arguments[2] : undefined;
  var marketingPreferences = arguments.length > 3 ? arguments[3] : undefined;

  var _useContext8 = useContext(AnalyticsContext),
      trackPageView = _useContext8.trackPageView,
      userGroup = _useContext8.userGroup,
      privacyStatement = _useContext8.privacyStatement,
      isAuthenticated = _useContext8.isAuthenticated,
      brand = _useContext8.brand,
      language = _useContext8.language,
      registrationPath = _useContext8.registrationPath,
      loginPath = _useContext8.loginPath,
      productId = _useContext8.productId;

  var viewTracked = useRef(false);
  useEffect(function () {
    // Wait until data are loaded to avoid multiple trackings due to several component mounts/unmounts
    if (trackPageView && !viewTracked.current && dataLoaded) {
      var login = loginPath && lastPathName === loginPath;
      var register = registrationPath && lastPathName === registrationPath;
      var fromPath = login ? 'login' : register ? 'registration' : '';
      trackPageView(trackingId, {
        currentLanguage: language,
        privacyStatement: privacyStatement,
        userGroup: userGroup,
        loginStatus: isAuthenticated,
        currentBrand: brand,
        productId: productId
      }, fromPath, marketingPreferences === null || marketingPreferences === void 0 ? void 0 : marketingPreferences.vwfs);
    }
  }, [dataLoaded, language, privacyStatement, userGroup, isAuthenticated, trackingId, lastPathName, brand]);
};
var useAnalyticsProfilePageViewTracker = function useAnalyticsProfilePageViewTracker(trackingId) {
  var dataLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var marketingPreferences = arguments.length > 2 ? arguments[2] : undefined;

  var _useContext9 = useContext(AnalyticsContext),
      trackPageView = _useContext9.trackPageView,
      userGroup = _useContext9.userGroup,
      privacyStatement = _useContext9.privacyStatement,
      isAuthenticated = _useContext9.isAuthenticated,
      brand = _useContext9.brand,
      language = _useContext9.language,
      productId = _useContext9.productId;

  var viewTracked = useRef(false);
  useEffect(function () {
    // Wait until data are loaded to avoid multiple trackings due to several component mounts/unmounts
    if (trackPageView && !viewTracked.current && dataLoaded) {
      trackPageView(trackingId, {
        currentLanguage: language,
        privacyStatement: privacyStatement,
        userGroup: userGroup,
        loginStatus: isAuthenticated,
        currentBrand: brand,
        productId: productId
      }, '', marketingPreferences);
    }
  }, [dataLoaded, language, privacyStatement, userGroup, isAuthenticated, trackingId, brand]);
};

function createDecoratedRoute(displayName) {
  for (var _len = arguments.length, decorators = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    decorators[_key - 1] = arguments[_key];
  }

  var Component = function Component(_ref) {
    var children = _ref.children,
        rest = _objectWithoutProperties(_ref, ["children"]);

    return decorators.reduceRight(function (acc, Decorator) {
      return /*#__PURE__*/React__default.createElement(Decorator, null, acc);
    }, /*#__PURE__*/React__default.createElement(Route, rest, children));
  };

  Component.displayName = displayName;
  return Component;
}

export { Accordion, AccordionItem, AlertOrSuccessText, AmortizationTableHeader, AmortizationTableLoadingPlaceholder, AmortizationTableTiles, AnalyticsContext, AnalyticsProvider, AnalyticsTracker, AuthenticationProvider, AuthenticationWrapper, AutoLogout, Carousel, Chatbot, CheckmarkList, CleaveInput, Contract, ContractActions, ContractDetailsLoadingPlaceholder, ContractHeader, ContractHeaderLoadingPlaceholder, ContractSummary, ContractSummaryItem, ContractsLoadingPlaceholder, CookieNotification, CookieNotificationStatusEnum, CookiePolicy, CookieTable, CookieWarning, DataOverview, DealerRequestLoadingPlaceholder, DefaultStaticPageContentLoadingPlaceholder, DefinitionList, DefinitionListCollection, DefinitionListHorizontal, DividedContractHeader, DividedContractHeaderLoadingPlaceholder, DownloadLink, EarlySettlementLoadingPlaceholder, ErrorPage, Faq, FaqLoadingPlaceholder, FileUpload, FocusFirstError, Greeting, GreetingLoadingPlaceholder, HeroImage, HeroTeaserLoadingPlaceholder, IconFooter, IconFooterLoadingPlaceholder, IconList, InfoBox, InfoCheckbox, InfoIcon, LandingPageMarketingCardLoadingPlaceholder, LanguageSwitcher, LegalFooter, LegalFooterLoadingPlaceholder, LoginChoiceLoadingPlaceholder, MarketingCardLoadingPlaceholder, MasterPage, MediaTeaser, MyDocumentsLoadingPlaceholder, MyProfileLoadingPlaceholder, NavigationBar, Notification, NotificationStatus, NotificationWithNavigationButton, NotificationsCenter, PageHeader, Postbox, PostboxFilters, PostboxTable, PrivateRoute, RegistrationLoadingPlaceholder, RequestLoadingPlaceholder, ScrollToTopOnNavigation, SimpleNavItem, SiteNav, Skeleton, Spinner, StaticPageLoadingPlaceholder, TableHeaderCell, TableSummary, ThirdPartyLicensesTable, UiBlockingSpinner, ValidatedCheckbox, ValidatedCheckboxGroup, ValidatedCheckboxWithGroup, ValidatedDate, ValidatedInput, ValidatedRadioButtonGroup, ValidatedSelect, ValidatedTextarea, ValueOrErrorMessage, createAuthenticationComponent, createAuthorization, createDecoratedRoute, createDynamicTable, createGroupedTableRows, createOrderedTableRows, getDisplayName, getLicenseKey, groupByFileSize, groupLicensesByType, hasError, isLoading, isRelativeUrl, navigateTo, notInitiated, openInNewWindow, openInSameWindow, preventMouseEvent, preventSubmit, useAnalyticsActionTracker, useAnalyticsDashboardPageTracker, useAnalyticsDashboardPageTrackerWithoutUnpaid, useAnalyticsEnterViewportTracker, useAnalyticsErrorPageTracker, useAnalyticsFormTracker, useAnalyticsHookPageViewTracker, useAnalyticsPageViewTracker, useAnalyticsProfilePageViewTracker, useAuthProfile, useAuthUserInfo, useAuthentication, useNavigation, useNotificationsCenter, withAutoScroll, withCleave };
//# sourceMappingURL=index.es.js.map
